import pageText from './zh-CN/pageText';
import live from './live/zh-CN';
import timezone from './zh-CN/timezone';
import analysis from './zh-CN/analysis';
import activity from './zh-CN/activity';
import leaderboardActivity from './zh-CN/leaderboardActivity';
import vip from './zh-CN/vip';
import commonSelect from "./zh-CN/commonSelect";
import game from './zh-CN/game';
import agent from './zh-CN/agent';
import webConfig from './zh-CN/webConfig';
import luckySpin from './zh-CN/luckySpin';
import adsAgent from './zh-CN/adsAgent';
import adsMccAccount from './zh-CN/adsMccAccount';
import adsAccount from './zh-CN/adsAccount';
import adsReport from './zh-CN/adsReport';
import adsUserPushRecord from './zh-CN/adsUserPushRecord';
import autoPushRecord from './zh-CN/autoPushRecord';
import autoPushConfig from './zh-CN/autoPushConfig';
import autoPushStats from './zh-CN/autoPushStats';
import manualPushRecord from './zh-CN/manualPushRecord';
import smsReport from './zh-CN/smsReport';
import smsChannels from './zh-CN/smsChannels';
import smsTemplates from './zh-CN/smsTemplates';
import smsLogs from './zh-CN/smsLogs';
import smsTasks from './zh-CN/smsTasks';
import inbox from './zh-CN/inbox';
import riskControl from './zh-CN/riskControl';
import news from './zh-CN/news';
import riskDimension from './zh-CN/riskDimension';
import manualTag from './zh-CN/manualTag';
import autoTag from './zh-CN/autoTag';
import auditReport from './zh-CN/auditReport';
import seoPlatform from './zh-CN/seoPlatform.js';
import aiModelConfig from './zh-CN/aiModelConfig.js';

export default {
  ...pageText,
  // 国家配置
  countries: {
    PH: 'PH - 菲律宾',
    VN: 'VN - 越南',
    TH: 'TH - 泰国',
    CN: 'CN - 中国'
  },

  smsChannels,
  smsTemplates,
  smsLogs,
  smsTasks,
  inbox,
  riskControl,
  news,
  ...riskDimension,
  ...manualTag,
  autoTag,
  ...auditReport,
  ...live,
  ...analysis,
  ...activity,
  ...leaderboardActivity,
  ...vip,
  ...commonSelect,
  ...agent,
  ...webConfig,
  ...adsAgent,
  ...adsMccAccount,
  ...adsAccount,
  ...adsReport,
  ...adsUserPushRecord,
  autoPushRecord,
  ...smsReport,
  autoPushConfig,
  autoPushStats,
  manualPushRecord,
  game,
  ...luckySpin,
  seoPlatform,
  aiModelConfig,
  timezone,
    'common.requestFailed': '请求失败',
    'common.required': '请输入',

    // 登录页面
  'login.language': '语言',
  'login.account': '账号',
  'login.accountRequired': '账号不能为空',
  'login.accountPlaceholder': '请输入账号',
  'login.password': '密码',
  'login.passwordRequired': '密码不能为空！',
  'login.passwordPlaceholder': '请输入密码',
  'login.googleAuthCode': '谷歌验证码',
  'login.googleAuthPlaceholder': '请输入谷歌验证码',
  'login.loginButton': '登录',
  'login.bindGoogleAuth': '请绑定谷歌验证码后再次点击登录',
  'login.googleAuthMessage': '请绑定谷歌验证码，再进行登录',
  'login.close': '关闭',
  'login.loading': '加载中...',

  // IP 白名單錯誤
  'ipWhitelist.error.title': '404',
  'ipWhitelist.error.subTitle': '您的 IP 地址未加入白名单，请联络管理员',

  // 左侧菜单管理
  'indexLtMenu.tab.top': '上部菜单',
  'indexLtMenu.tab.middle': '中部菜单',
  'indexLtMenu.tab.bottom': '下部菜单',
  'indexLtMenu.tab.member': '会员菜单',
  'indexLtMenu.tab.preferential': '优惠菜单',
  'indexLtMenu.menuName': '菜单名称',
  'indexLtMenu.menuIcon': '显示图标',
  'indexLtMenu.ltMenuArea': '菜单类型',
  'indexLtMenu.menuOrder': '排序',
  'indexLtMenu.language': '语言',
  'indexLtMenu.menuLink': '链接/Code',
  'indexLtMenu.ltMenuStatus': '状态',
  'indexLtMenu.menuNote': '备注',
  'indexLtMenu.menuSection': '菜单部分',
  'indexLtMenu.languageSettings': '语言设置',

  // 底部菜单管理
  'indexBotMenu.menuName': '导航名称',
  'indexBotMenu.menuIcon': '显示图标',
  'indexBotMenu.menuHighlightIcon': '菜单高亮图标',
  'indexBotMenu.menuCode': '菜单代码',
  'indexBotMenu.menuOrder': '排序',
  'indexBotMenu.language': '语言',
  'indexBotMenu.menuLink': '页面链接',
  'indexBotMenu.isEnable': '状态',
  'indexBotMenu.h5Icon': 'H5图标',
  'indexBotMenu.pcIcon': 'PC图标',
  'indexBotMenu.appIcon': 'APP图标',

  'mlm.promote.userInviteInfoReport': '邀请成就报表.xls',
  'mlm.promote.rebate.level': '反水层级',
  'mlm.promote.gameType_1': '电子返水',
  'mlm.promote.gameType_2': '真人返水',
  'mlm.promote.gameType_3': '体育返水',
  'mlm.promote.gameType_4': '彩票返水',
  'mlm.promote.gameType_5': '捕鱼返水',
  'mlm.promote.gameType_6': '棋牌返水',
  'mlm.promote.gameType_9': '竞猜返水',
  'mlm.promote.gameType_10': '电竞返水',
  'mlm.promote.edit': '编辑',
  'mlm.promote.edit_cancel': '取消',
  'mlm.promote.save': '保存',
  'mlm.promote.operation': '操作',
  'mlm.promote.inviteNotOpen': '邀请成就未开启',
  'mlm.promote.isRebateOpen': '是否开启投注反水',
  'mlm.promote.rebateRatioLimit': '投注反水比例不能超过{rebateRatioLimit}',
  'mlm.promote.digital': '为数字最多两位小数',
  'mlm.promote.start': '从开启之日',
  'mlm.promote.end': '起统计',

  'mlm.promote.invited.isOpen': '是否开启受邀人奖励',
  'mlm.promote.invited.amount': '每一位受邀人可获得奖金金额',
  'mlm.promote.invited.betflow': '流水倍数',
  'mlm.promote.invited.domain': '邀请域名',
  'mlm.promote.invited.domainMsg': '格式为逗号分隔的域名',

  'mlm.promote.bonus.invite': '人人代邀请奖励,{date}',
  'mlm.promote.bonus.rebate': '人人代返水奖励,{date}',
  'mlm.promote.bonus.domain': '人人代指定域名邀请奖励,{date}',
  'mlm.promote.bonus.point': '人人代邀请奖励积分,{0}',

  'mlm.promote.rebateReprot.title1': '序列号',
  'mlm.promote.rebateReprot.title2': '用户名',
  'mlm.promote.rebateReprot.title3': '代理等级',
  'mlm.promote.rebateReprot.title4': '发放日期',
  'mlm.promote.rebateReprot.title5': '合计反水',
  'mlm.promote.rebateReprot.view': '查看详情',
  'mlm.promote.rebateReprot.inviteUserAccount': '邀请人用户名',
  'mlm.promote.rebateReprot.Excel': '好友反水报表.xls',
  'mlm.promote.rebateReprot.totalSum': '受邀请人奖励已发放:{count}笔,{sum}元',

  'mlm.promote.rebateReprotDetail.title1': '序列号',
  'mlm.promote.rebateReprotDetail.title2': '受邀人用户名',
  'mlm.promote.rebateReprotDetail.title3': '代理等级',
  'mlm.promote.rebateReprotDetail.title4': '上级代理',
  'mlm.promote.rebateReprotDetail.title5': '反水层级',
  'mlm.promote.rebateReprotDetail.title6': '统计日期',
  'mlm.promote.rebateReprotDetail.title7': '合计反水',
  'mlm.promote.rebateReprotDetail.suffix': '流水/反水',

  'mlm.promote.inviteeReprot.title1': '序列号',
  'mlm.promote.inviteeReprot.title2': '受邀人用户名',
  'mlm.promote.inviteeReprot.title3': '受邀人奖励金额',
  'mlm.promote.inviteeReprot.title4': '流水倍数',
  'mlm.promote.inviteeReprot.title5': '派发状态',
  'mlm.promote.inviteeReprot.title6': '邀请域名',
  'mlm.promote.inviteeReprot.title7': '邀请人用户名',
  'mlm.promote.inviteeReprot.Excel': '受邀人奖励报表.xls',

  'mlm.promote.inviteeReprotDetail.title1': '受邀人用户名',
  'mlm.promote.inviteeReprotDetail.title2': '注册时间',
  'mlm.promote.inviteeReprotDetail.title3': '累计存款',
  'mlm.promote.inviteeReprotDetail.title4': '状态',
  'mlm.promote.inviteeReprotDetail.title5': '累计有效流水',
  'mlm.promote.inviteeReprotDetail.title6': '是否成为有效会员',
  'mlm.promote.inviteeReprotDetail.title7': '是否同设备IP',
  'mlm.promote.inviteeReprotDetail.title8': '完成时间',
  'mlm.report.finishDomainStatus51': '进行中',
  'mlm.report.finishDomainStatus52': '已完成',

  'mlm.report.title1': '优惠发放报表',
  'mlm.report.title2': '邀请成就报表',
  'mlm.report.title3': '好友反水报表',
  'mlm.report.title4': '受邀人奖励表报',

  'mlm.report.agent': '人人代',
  'mlm.report.agentLevel1': '零级代理',
  'mlm.report.agentLevel2': '一级代理',
  'mlm.report.agentLevel3': '二级代理',
  'mlm.report.agentLevel4': '三级代理',
  'mlm.report.agentLevel5': '四级代理',
  'mlm.report.agentLevel6': '五级代理',
  'mlm.report.finishDepositStatus21': '进行中',
  'mlm.report.finishDepositStatus22': '已完成',

  'mlm.promote.title1': '邀请成就设置',
  'mlm.promote.title2': '投注反水设置',
  'mlm.promote.title3': '其他设置',
  'sys.copySuccess': '复制成功',
  'live.region.name': '地区名称',
  'live.region.status': '地区状态',
  'live.query.region.name': '请输入地区名称',
  'sys.game': '小游戏 - ',
  'sys.eventName': '活动名称',
  'sys.enterEventName': '请输入活动名称',
  'sys.activity.win.type': '中奖展示类型',
  'sys.activity.win.type.prompt': '请选择中奖类型',
  'sys.activity.falseWin': '虚假中奖信息',
  'sys.activity.realWin': '真实中奖信息',
  'sys.activity.lotteryStyle': '抽奖方式',
  'sys.activity.selectLotteryStyle': '请选择抽奖方式',
  'sys.activity.lotteryStyle1': '大转盘',
  'sys.activity.lotteryStyle2': '老虎机',

  'sys.date.type': '时间类型',
  'sys.permanent': '永久有效',
  'sys.validit.period': '有效期',
  'sys.added.prize': '已添加奖品',
  'sys.added.prize1': '已添加奖品',
  'sys.noAdded.prize1': '暂未添加任何奖品',
  'sys.added.prize2': '添加奖品',
  'sys.open': '开启',
  'sys.close': '关闭',
  'sys.cashReward': '现金奖励',
  'sys.pointReward': '积分奖励',
  'sys.physicalReward': '实物奖励',
  'sys.select.prize': '可选奖励',
  'sys.select.prizeType': '请选择奖励类型',
  'sys.noAdded.prize': '暂未添加奖品',
  'sys.activities': '活动内容',
  'sys.fillActivities': '请填写活动内容',
  'sys.copyImageLink': '复制图片链接',
  'sys.imageLink': '图片链接',
  'sys.addOffer': '添加优惠内容',
  'sys.offer': '优惠内容',
  'sys.enterOffer': '请填写优惠内容',
  'sys.prizeName': '奖品名称',
  'sys.enterPrizeName': '请输入奖品名称',
  'sys.prizeType': '奖品类型',
  'sys.prizeType.desc': '奖品类型：现金筹码 |金额：{prizeAmount} |流水倍数：{betMultiple}',
  'sys.prizeType.desc1': '奖品类型：其他',
  'sys.prizeType.desc2': ' |奖品概率：{probability}%',
  'sys.prizeType.desc3': ' |奖品顺序：{sort}',
  'sys.prizeType.desc4': ' |奖品详情：{prizeDetail}',
  'sys.prizeType.desc5': '奖品名称：{prizeName}',
  'sys.ropeType.descInfo': '绳子类型：{configRopeType} |金额：{configPrizeAmount} |流水倍数：{betMultiple} |累计投注：{accumulationBetAmount} |合成绳子类型：{syntheticRopeType} |合成绳子数量：{syntheticQuantity} |奖品顺序：{sort} |奖品详情：{configDetail}',
  'sys.prizeList': '奖品列表',
  'sys.prizeAmount': '奖品金额',
  'sys.probability': '概率',
  'sys.confirmCancel': '确认取消',
  'sys.content': '是否取消会员 {userAccount} 的此次 {activityGameType} 的抽奖资格？',
  'sys.activity.type': '活动类型',
  'sys.prize': '奖品',
  'sys.unspecifiedPrize': '未指定奖品',
  'sys.notIssued': '未发放',
  'sys.obsolete': '作废',
  'sys.upload': '上传',
  'sys.stock': '库存',
  'sys.download': '下载',
  'sys.upload.fail1': '文件上传失败，请删除后重新上传',
  'sys.upload.picture1': '上传图片',
  'sys.upload.imageMaterial': '图片素材上传',
  'sys.upload.activityPicture': '上传活动图片',
  'sys.pc.activityPicture': 'PC端活动图片',
  'sys.h5.activityPicture': '移动端活动图片',
  'sys.pc.activityTurntablePicture': 'PC端转盘图片',
  'sys.h5.activityTurntablePicture': '移动端转盘图片',
  'sys.uploadPC.activityPicture': '请上传PC活动图片',
  'sys.uploadH5.activityPicture': '请上传移动端活动图片',
  'sys.uploadPC.activityTurntablePicture': '请上传PC转盘图片',
  'sys.uploadH5.activityTurntablePicture': '请上传移动端转盘图片',
  'sys.lengthLimit1': '最多输入300个字符',
  'sys.lengthLimit2': '最多输入250个字符',
  'sys.giftCash2': '赠送现金',
  'sys.giftCash1': '赠送现金(%)',
  'sys.maxBonusAmount': '最大赠送金额',
  'sys.enterPrizeType': '请输入奖品类型',
  'sys.discountCash': '优惠现金',
  'sys.giftCash': '赠送现金(元)',
  'sys.giftCashVN': '赠送现金(VND)',
  'sys.enterAmountPrize': '请输入赠送奖品的金额',
  'sys.flowMultiple': '流水倍数',
  'sys.flowMultiple2': '提款流水倍数',
  'sys.enterFlowMultiple': '请输入流水倍数',
  'sys.typeData': '请输入0-100的数字',
  'sys.enterSort': '请输入排序',
  'sys.winningProbability': '中奖概率',
  'sys.winningProbability1': '请输入11位以内的中奖概率',
  'sys.enterNumber': '请输入数字',
  'sys.prizeDetails': '奖品详情',
  'sys.enterPrizeDetails': '请输入奖品详情',
  'sys.rules.number': '最多输入100个字符',
  'sys.prizePicture': '奖品图片',
  'sys.upload.prizePicture': '请上传奖品图片',
  'sys.pc.prizePicture': '移动端奖品图片',
  'sys.editOffer': '修改优惠内容',
  'sys.addPrize.submit': '请添加奖品后再提交!',
  'sys.add.success': '添加成功！',
  'common.requestfail': '请求失败，请重试！',
  'sys.drawTime': '抽奖时间',
  'sys.stockNum': '库存数',
  'sys.stockNum1': '请输入库存数',
  'sys.hasStock': '库存类型',
  'sys.hasStock0': '不限',
  'sys.hasStock1': '限制数量',
  'sys.hasStock3': '请选择奖品类型',
  'lottery.lotteryTime': '抽奖时间',
  'sys.setPrizes': '设置奖品',
  'sys.disqualification': '取消资格',
  'sys.addLottery': '添加抽奖次数',
  'sys.allType': '全部类型',
  'sys.allState': '全部状态',
  'sys.addNumberDrawsWrong': '添加抽奖次数错误，请稍后再试！',
  'sys.gameType1': 'Top1游戏类型',
  'sys.gameType2': 'Top2游戏类型',

  'sys.smallGameType': '小游戏类型',
  'sys.selectSmallGameType': '请选择小游戏类型',
  'sys.frequency': '次数',
  'sys.enterNumberDraws': '请输入抽奖次数',
  'sys.failedLoadPrizes': '加载奖品失败，请稍后再试！',
  'sys.selectPrize': '请选择奖品',
  'sys.title.deleteBeforeDisable1': '为防止出错，请先禁用小游戏后再删除！',
  'sys.title.deleteGame': '即将删除的小游戏：{activityName} 删除后所有关于该游戏的用户未进行抽奖的次数也将被删除，请确认',
  'common.title.createAdmin1': '创建人/时间',
  'common.title.createAdmin2': '创建人/创建时间',
  'sys.expireDate': '过期时间',
  'sys.viewPrize': '查看奖品',
  'constants.activityType_11': '1. 幸运大转盘',
  'constants.activityType_22': '2. 摇一摇',
  'sys.addSmallGame': '新增小游戏',
  'bet.select.gameType1': '选择游戏类型',
  'sys.cancel': '取消',
  'sys.submit': '提交',
  'sys.set': '设置',
  'sys.totalNumberTime': '总次数',
  'user.memberAccount': '会员账号',
  'user.memberAccount1': '会员账号：',
  'user.checkinTime': '签到时间',
  'sys.time': '发放时间',
  'sys.receivePoints': '领取积分',
  'sys.receiveState': '领取状态',
  'sys.receivePrize': '领取奖品',
  'sys.rewardType': '奖励类型',
  'sys.reward': '奖励',
  'sys.processing': '进行中',
  'sys.whetherAdditionalRewards': '是否额外奖励',
  'sys.confirmor': '确认人',
  'sys.other': '其它',
  'sys.integral': '积分',
  'sys.participant': '抽奖机会',

  'sys.no': '否',
  'sys.yes': '是',
  'sys.chooseCheckInTime': '选择签到时间',
  'sys.confirmAward': '确认奖品发放',
  'sys.confirmWhetherRewardIssued': '请确认好奖励是否发放',
  'finance.title.remark2': '备 注',
  'sys.pickUpTime': '领取时间',
  'sys.choosePickUpTime': '选择领取时间',
  'sys.receiveAward': '领取奖励',
  'sys.usePoints': '使用积分',
  'sys.grade': '等级',
  'sys.defaultGrade': '请选择等级',
  'sys.enterGrade': '请输入等级',
  'sys.cumulativeBetAmount': '累计投注额',
  'sys.cumulativeBetAmount1': '累计升级奖金',
  'sys.cumulativeBetAmount2': '累计周俸禄奖金',
  'sys.cumulativeBetAmount3': '累计月俸禄奖金',
  'sys.cumulativeBetAmount4': '累计俸禄奖金',
  'sys.cumulativeBetAmount5': '周俸禄奖金',
  'sys.cumulativeBetAmount6': '月俸禄奖金',
  'sys.cumulativeBetAmount7': '俸禄奖金',
  'sys.update': '修改',
  'sys.updateTime': '更新时间',
  'sys.upgradeUser.name': '升级会员记录列表.xls',
  'sys.offerName': '优惠名称',
  'sys.enterOfferName': '请输入优惠名称',
  'sys.offerName1': '优惠名称：',
  'sys.offerName2': '优惠名称、用户名',
  'sys.offerName3': '优惠名称/用户名',
  'sys.default.sort': '默认排序',
  'sys.rank.ascending': '等级升序',
  'sys.rank.descending': '等级降序',
  'sys.all.offers': '全部优惠',
  'sys.title.delete': '即将删除: {bonusName}',
  'sys.mutuallyExclusiveOffer': '互斥优惠项',
  'sys.addMutuallyExclusiveOffer': '添加互斥优惠',
  'sys.addMutuallyExclusiveOfferGroup': '添加互斥优惠组',
  'sys.alreadyCollectionRule': '已拥有该领取规则',
  'sys.rule.name': '规则名称: ',
  'sys.rule.name1': '规则名称',
  'sys.enterRule.name': '请输入规则名称',
  'sys.collectionRule.description': '领取规则描述',
  'sys.addCollectionRule': '添加领取规则',
  'sys.deleteRule': '即将删除领取规则：{groupCode}',
  'sys.confirmDisabled': '确认禁用',
  'sys.confirmDisabled1': '即将禁用: {groupName}',
  'sys.confirmEnable': '确认启用',
  'sys.confirmEnable1': '即将启用: {groupName}',
  'sys.changeSetting': '修改配置',
  'sys.management': '管理',
  'sys.next': '下一步',
  'sys.addSpecialOffer': '新增优惠文章',
  'sys.addSpecial': '新增优惠',
  'sys.enterNameOfferArticle': '请输入优惠文章名称',
  'sys.nameOfferArticle': '文章名称',
  'sys.addOfferArticle': '新增文章',
  'sys.category': '所属分类',
  'sys.selectCategory': '请选择所属分类',
  'sys.displayOrder': '显示顺序',
  'sys.enterDisplayOrder': '请输入显示顺序',
  'sys.selectPlatformType': '选择平台类型',
  'sys.platformType': '平台类型',
  'sys.enterPlatformType': '请输入平台类型',
  'sys.selectPlatformType1': '请选择适用平台',
  'sys.selectApplicationConditions': '请填写申请条件',
  'sys.computerSideAdvertisingImage': '电脑端广告图片',
  'sys.pcImage': 'PC端图片',
  'sys.APPImage': '移动端图片',
  'sys.uploadComputerImage': '请上传电脑端图片',
  'sys.mobileImage': '移动端广告图片',
  'sys.uploadMobileImage': '请上传移动端图片',
  'sys.associatedActivity': '关联活动',
  'sys.selectOfferWantLink': '请选择需要关联的优惠活动',
  'sys.addFail': '添加失败',
  'sys.addError': '添加错误',
  'sys.newClassification': '新增分类',
  'sys.categoryName': '分类名称',
  'sys.fillCategoryName': '请填写分类名称',
  'sys.deleteOffer': '即将删除的优惠：{bonusName}',
  'sys.confirmCopy': '确认复制',
  'sys.confirmCopy1': '确认复制该优惠文章吗？',
  'sys.promptMessage': '提示信息',
  'sys.disableDelete': '请禁用后再删除。',
  'sys.confirmDelete': '确认删除该优惠文章吗？',
  'sys.confirm1': '确认取消该优惠文章推荐吗？',
  'sys.effectiveTime': '有效时间',
  'sys.startTime': '开始时间：',
  'sys.startTime1': '开始时间',
  'sys.startTime2': '开赛时间',
  'sys.endTime': '结束时间：',
  'sys.endTime1': '结束时间',
  'sys.associationSettings': '关联设置',
  'sys.cancelRecommend': '取消推荐',
  'sys.copy': '复制',
  'sys.modifySort': '修改排序',
  'sys.editCopy': '编辑文案',
  'sys.platform': '平台',
  'sys.platformCode': '平台CODE',
  'sys.computer': '电脑',
  'sys.mobile': '移动',
  'sys.editCategory': '编辑分类',
  'sys.name': '名称：',
  'pay.title.sort1': '排序：',
  'sys.recommendSignature': '推荐标签：',
  'sys.recommendedDisplayImageUpload': '推荐展示图片上传',
  'sys.recommendedDisplayImage': '推荐展示图片',
  'sys.uploadImage': '请上传图片',
  'sys.collectionMethod': '领取方式',
  'sys.seletCollectionMethod': '请选择领取方式',
  'sys.automaticDistribution': '自动派发',
  'sys.manually': '手动领取',
  'sys.issuingMethod': '发放方式',
  'sys.seletIssuingMethod': '请选择发放方式',
  'sys.dayIssuing': '日发放',
  'sys.weekIssuing': '周发放',
  'sys.flowMultipleCalculationAmount': '流水倍数计算金额',
  'sys.selectFlowMultipleCalculationAmount': '请选择流水倍数计算金额',
  'sys.returnAmount': '返水金额',
  'sys.withdrawalRestrictions': '提款限制',
  'sys.enterWithdrawalRestrictions': '请输入提款限制',
  'sys.doubleWaterWithdrawDiscount': '倍流水可将优惠提现',
  'sys.platformPointSettings': '平台及点数设置',
  'sys.chooseGamePlatform': '选择游戏平台',
  'sys.returnPoint': '返水点数',
  'sys.lowest': '最低',
  'sys.highest': '最高',
  'sys.yuan': '元',
  'sys.yuanVN': 'VND',
  'sys.yuanPHP': 'PHP',
  'sys.yuan1': '元,',
  'sys.validBetReached': '有效投注达',
  'sys.storageReach': '存款达',
  'sys.howManyGetDraw': '元可获得一次奖券机会',
  'sys.onThatDay': '当日',
  'sys.twoDays': '两天',
  'sys.activityPeriod': '活动期间',
  'sys.runningWaterAmount': '流水金额',
  'sys.platformConditionSettings': '平台及条件设置',
  'sys.selectGamePlatform': '选择游戏平台(按类型分类)',
  'sys.addedOffers': '已添加的优惠内容',
  'sys.NoSpecialOffersYet': '暂未添加优惠内容',
  'sys.selectGiftType': '请选择赠送类型',
  'sys.betAmount': '投注额(含)',
  'sys.betAmount1': '最高投注额(不含)',
  'sys.betAmount2': '请输入最高投注额',
  'sys.betAmount3': '投注额',
  'sys.enterMinimumAmount': '请输入最低投注额',
  'sys.cashGiftForm': '现金赠送形式',
  'sys.selectCashGiftForm': '请选择现金赠送形式',
  'sys.giveCashFixedAmount': '以固定数量赠送现金',
  'sys.giveCashFixedAmount1': '以固定比例赠送现金',
  'sys.numberGifts': '赠送次数',
  'sys.enterNumberGifts': '请输入赠送次数',
  'sys.enterAmountCashGiven': '请输入赠送现金的数量',
  'sys.enterAmountCashGiven1': '请输入赠送现金最高限额',
  'sys.enterProportionCashGiven': '请输入赠送现金的比例',
  'sys.enterProportionmaxBonusAmount': '请输入最大赠送金额',
  'sys.noMoreThan': '最高不超过(元)',
  'sys.noMoreThanVN': '最高不超过(VND)',
  'sys.noMoreThan1': '最高不超过(分)',
  'sys.basicInformationOffer': '优惠基本信息',
  'sys.relatedArticles': '关联文章',
  'sys.selectOfferArticleWantLink': '请选择需要关联的优惠文章',
  'sys.pc.sideOfferPicture': 'PC端优惠图片',
  'sys.uploadPc.sideOfferPicture': '请上传pc图片',
  'sys.mobile.sideOfferPicture': '移动端优惠图片',
  'sys.mobile.accountAuthentication': '账户认证',
  'sys.mobile.phoneAuthentication': '手机认证',
  'sys.user.address': '收货地址设置',
  'sys.uniqueLimit.IP': 'IP唯一限制',
  'sys.uniqueLimit.device': '设备唯一限制',
  'sys.uniqueLimit.phone': '手机号唯一限制',
  'sys.mobile.emailAuthentication': '邮箱认证',
  'sys.bindingBankCard': '绑定银行卡',
  'sys.setPreferentialConditions': '设置优惠条件',
  'sys.selectLogType_platform': '请选择游戏平台',
  'sys.noteType': '注单类型',
  'sys.noteNumber': '注单号',
  'sys.selectDuplicateRequestLimit': '请选择重复申请限制',
  'sys.duplicateRequestLimit': '重复申请限制',
  'sys.payoutAmount': '派彩金额',
  'sys.profitAmount': '盈利金额',
  'sys.onlyOnce': '仅限一次',
  'sys.everyDay': '每天',
  'sys.weekly': '每周',
  'sys.perMonth': '每月',
  'sys.perYear': '每年',
  'sys.maximumNumberApplications': '最多申请次数',
  'sys.enterMaximumNumberOffers': '请输入优惠最多申请次数',
  'sys.expirationTimeType': '过期时间类型',
  'sys.enterExpirationTimeType': '请选择过期时间类型',
  'sys.day': '天',
  'sys.noteExpirationTime': '注单过期时间',
  'sys.enterBillingExpirationTime': '请输入注单过期时间',
  'sys.withdrawalConditions': '提款条件',
  'sys.selectWithdrawalCondition': '请选择提款条件',
  'sys.directWithdrawal': '直接提款',
  'sys.flowRequirement': '流水要求',
  'sys.enterFlowRequirement': '请输入优惠提现流水倍数',
  'sys.setBetRequirements': '设置注单要求',
  'sys.addWinningConditions': '添加中奖条件',
  'sys.winningConditions': '中奖条件(包含)',
  'sys.enterWinningCondition': '中奖条件(包含)',
  'sys.offerMethod': '优惠赠送方式',
  'sys.noteBetAmountMultiple': '注单下注金额倍数',
  'sys.noteBetAmountMultiple1': '注单派彩金额倍数',
  'sys.noteBetAmountMultiple2': '注单盈利金额倍数',
  'sys.giftPoints': '赠送积分(分)',
  'sys.giftPoints1': '赠送积分(%)',
  'sys.giftPoints2': '赠送积分',
  'sys.giftPoints3': '| 赠送积分：{giftPoint}分',
  'sys.giftPoints4': '| 赠送积分：{pointPercent}%(不超过{maxPoint}分)',
  'sys.enterGiftPoints2': '请输入积分',
  'sys.enterNumberBonusPoints': '请输入赠送积分的数量',
  'sys.preferentialAmountBenchmarkRate': '优惠金额基准倍率',
  'sys.enterPreferentialAmountBenchmarkRate': '请输入优惠金额基准倍率',
  'sys.enterPreferentialAmountBenchmarkRate1': '请输入优惠金额',
  'sys.maximumDiscountAmountLimit': '最高优惠金额限额',
  'sys.enterMaximumDiscountAmountLimit': '请输入最高优惠金额限额',
  'sys.integralBenchmarkMagnification': '积分基准倍率',
  'sys.integralBenchmarkMagnification1': '积分基准倍率',
  'sys.maximumPointLimit': '最高积分限额',
  'sys.enterMaximumPointLimit': '请输入最高积分限额',
  'sys.memberInformationBindingOffer': '会员信息绑定优惠',
  'sys.binding': '绑定信息',
  'sys.binding1': '绑定类型',
  'sys.binding2': '请选择绑定类型',
  'sys.phoneNumber': '手机号',
  'sys.pequiredDepositAmount': '要求存款金额',
  'sys.pequiredDepositAmount1': '请输入要求存款金额',
  'sys.giftAmount': '赠送金额',
  'sys.giftAmount1': '请输入赠送金额',
  'sys.maximumAmountAvailable': '最高可提金额',
  'sys.maximumAmountAvailable1': '请最高可提金额',
  'sys.continuousDeposit': '连续存款投注优惠 设置 (隔天凌晨4: 00-4: 30自动发放)',
  'sys.newContinuousDeposit': '累计存款投注优惠设置',
  'sys.depositRequestAmount': '存款要求金额',
  'sys.depositRequestAmount1': '流水要求金额',
  'sys.consecutiveDays': '连续天数',
  'sys.cumulativeDays': '累计天数',
  'sys.selectType': '请选择所属类型',
  'sys.continuous': '连续',
  'sys.cumulative': '累计',
  'sys.enterNumberDays': '请输入天数',
  'sys.enterCumulativeDays': '请输入累计天数',
  'sys.enterAmount': '请输入金额',
  'sys.userEffectiveFlowRequirements': '用户有效流水要求',
  'sys.enterFlowRequirement1': '请输入流水要求',
  'sys.continuousDepositBonusSetting': '连续存款奖励设置',
  'sys.cumulativeDepositBettingBonusSettings': '累计存款投注奖励设置',
  'sys.di': '第',
  'sys.song': '送',
  'sys.bei': '倍',
  'sys.wu': '无',
  'sys.you': '有',
  'sys.extraBonus': '是否有额外奖励',
  'sys.extraDelivery': '额外送',
  'sys.addedOffer': '已添加优惠内容',
  'sys.msg1': '无需申请 次日凌晨04: 00自动派送',
  'sys.applicationConditions': '申请条件',
  'sys.selectCategory1': '请选择所属类别',
  'sys.category1': '所属类别',
  'sys.selectDepositChannel': '请选择存款渠道',
  'sys.depositChannel': '存款渠道',
  'sys.receiveCount': '领取次数',
  'sys.msg2': '最高存款金额必须大于最低存款金额',
  'sys.msg3': '最低存款(含)',
  'sys.msg4': '请输入最低存款金额',
  'sys.msg5': '最高存款(不含)',
  'sys.msg6': '请输入最高存款金额',
  'sys.msg7': '以固定存款区间赠送现金',
  'sys.pre-purchaseOffer': '前置优惠-提款条件',
  'sys.pre-purchaseOffer1': '前置优惠',
  'sys.postOffer': '后置优惠-领取条件',
  'sys.postOffer1': '后置优惠',
  'sys.minusDiscount': '减去优惠',
  'sys.accountType': '账户类型',
  'sys.accountType1': '请选择账户类型',
  'sys.masterAccount': '主账户',
  'sys.gameAccount': '游戏账户',
  'sys.gameAccountType': '游戏账户类型',
  'sys.majorClass': '大类',
  'sys.account': '账户',
  'sys.enterAccount1': '请选择存款账户',
  'sys.depositOrder': '存款次序',
  'sys.enterDepositOrder': '请选择存款次序',
  'sys.nthDeposit': '第 n 次存款',
  'sys.nthDeposit1': '非首次的前 n 次存款',
  'sys.nthDeposit2': '所有存款',
  'sys.nthDeposit3': '填写 n 的值',
  'sys.nthDeposit4': '总累计存款',
  'sys.nthDeposits': '第 n 笔存款',
  'sys.greaterNthDeposit': '大于第 n 笔存款',
  'sys.enterNumberDepositLimits': '请输入存款限制次数',
  'sys.flowType': '流水类型',
  'sys.selectypeFlow': '流水类型',
  'sys.msg8': '全局统一设置流水倍数',
  'sys.msg9': '单条优惠内容设置流水倍数',
  'sys.msg10': '已添加优惠内容 (更改流水类型将取消所有优惠内容，如编辑过，需重新编辑。)',
  'sys.receivingValidityPeriod': '领取有效期',
  'sys.enterExpirationDate': '请输入优惠领取有效期',
  'sys.pointGiftForm': '积分赠送形式',
  'sys.selectPointGiftForm': '请选择积分赠送形式',
  'sys.givePointsFixedAmount': '以固定数量赠送积分',
  'sys.givePointsFixedAmount1': '以固定比例赠送积分',
  'sys.enterProportionBonusPoints': '请输入赠送积分的比例',
  'sys.enterMaximumCreditLimit': '请输入赠送积分的比例',
  'sys.msg11': ' 实时: 随入款一起存入',
  'sys.uploadH5Image': '请上传h5图片',
  'sys.msg12': '移动端尺寸: 718*158px',
  'sys.check-inPointSetting': '签到积分设置',
  'sys.check-inDaysSetting': '签到天数设置',
  'sys.check-in': '签到',
  'sys.check-in1': '签到第',
  'sys.msg13': '固定天数额外奖励设置',
  'sys.doubleWater': '倍流水可提',
  'sys.pointRedemptionSettings': '积分兑换设置',
  'sys.exchange': '兑换',
  'sys.msg14': '被推荐人要求',
  'sys.msg15': '天内达到',
  'sys.rewarderSelection': '奖励方选择',
  'sys.invitees': '被邀请人',
  'sys.invitees1': '邀请人',
  'sys.inviterReward': '邀请人奖励',
  'sys.inviterReward1': '请输入邀请人奖励',
  'sys.inviterReward2': '被邀请人奖励',
  'sys.inviterReward3': '请输入被邀请人奖励',
  'sys.unlimited': '是否无限',
  'sys.discountPoints': '优惠积分',
  'sys.preferential': '优惠的',
  'sys.doubleWater1': '倍流水',
  'sys.maxWithdrawal': '最高提款',
  'sys.enterMaxWithdrawalAmount': '请输入最高提款金额',
  'sys.msg16': '平台及条件设置(每天04: 00 定时派送)',
  'sys.msg17': '最高派彩倍数必须大于最低派彩金额',
  'sys.msg18': '派彩大于有效投注倍数(含)',
  'sys.msg19': '请输入最低派彩大于有效投注倍数',
  'sys.msg20': '最高派彩大于有效投注倍数(不含)',
  'sys.msg21': '请输入最高派彩大于有效投注倍数',
  'sys.msg22': '赠送投注额倍数',
  'sys.msg23': '请输入赠送投注额倍数',
  'sys.msg24': 'VIP游戏返水优惠,(若设置两条VIP游戏返水，系统将按照创建时间早的进行发放)',
  'sys.msg25': '提款限制,N倍流水可提',
  'sys.msg300': '每日领取次数',
  'sys.enterDailyPickupCount': '请输入每日领取次数',
  'sys.selectLeastOne': '请选择至少一种',
  'sys.addUpgradeConditions': '添加升级条件',
  'sys.msg26': '所需投注额',
  'sys.msg27': '请输入所需投注额',
  'sys.msg28': '周俸禄礼金',
  'sys.msg29': '请输入周俸禄礼金',
  'sys.msg30': '月俸禄礼金',
  'sys.msg31': '请输入月俸禄礼金',
  'sys.msg32': '升级条件，（周俸禄每周星期三派发，月俸禄每月3号派发）',
  'sys.msg33': '暂未添加升级条件',
  'sys.upgradeGift': '升级礼金',
  'sys.enterUpgradeGift': '请输入升级礼金',
  'sys.platformLevelSettings': '平台及等级设置',
  'sys.msg34': '赠送现金：{giftMoney}元',
  'sys.msg34VN': '赠送现金：{giftMoney}VND',
  'sys.msg35': '赠送现金：{giftMoney}%(不超过{maxMoney}元)',
  'sys.msg35VN': '赠送现金：{giftMoney}%(不超过{maxMoney}VND)',
  'sys.msg36': ' | 流水要求：{betMultiple} 倍',
  'sys.msg37': '累积投注：{minBetAmount}~{maxBetAmount}',
  'sys.msg38': ' | 赠送次数：{giftCount} 次',
  'sys.selectLeastOneGamePlatform': '请至少选择一个游戏平台！',
  'sys.setLeastOneObtainingMethod': '请至少设置一项奖券获取方式！',

  'sys.editLeastOneOffer': '请至少编辑一条优惠内容',
  'sys.vip1': 'Vip {vipLevel} 返水比例必需大于等于0！',
  'sys.vip2': 'Vip {vipLevel} 最高金额应该大约最低金额！',
  'sys.vip3': '请填写Vip {vipLevel}返水比例',
  'sys.vip4': '请填写Vip {vipLevel} 最低返水金额',
  'sys.vip5': '请填写Vip {vipLevel} 最高返水金额',
  'sys.vip6': 'Vip {vipLevel} 最高金额应该大于最低金额！',
  'sys.addBetConditionBeforeSubmitting': '请添加注单条件后再提交',
  'sys.noteTailNumber': '注单尾号：{conditionValue1}',
  'sys.noteTailNumber1': '注单下注金额：{conditionValue1}',
  'sys.noteTailNumber2': '注单派彩金额：{conditionValue1}',
  'sys.noteTailNumber3': '注单盈利金额：{conditionValue1}',
  'sys.msg39': '固定方式：优惠金额：{giftMoney}元，积分：{giftPoint}',
  'sys.msg39VN': '固定方式：优惠金额：{giftMoney}VND，积分：{giftPoint}',
  'sys.msg40': '下注金额方式：金额倍率：{moneyPercent}，最高不超过：{maxMoney}元 | ',
  'sys.msg40VN': '下注金额方式：金额倍率：{moneyPercent}，最高不超过：{maxMoney}VND | ',
  'sys.msg41': '下注金额方式：积分倍率：{pointPercent}，最高不超过：{maxPoint}',
  'sys.msg42': '派彩金额方式：金额倍率：{moneyPercent}，最高不超过：{maxMoney}元 | ',
  'sys.msg42VN': '派彩金额方式：金额倍率：{moneyPercent}，最高不超过：{maxMoney}VND | ',
  'sys.msg43': '派彩金额方式：积分倍率：{pointPercent}，最高不超过：{maxPoint}',
  'sys.msg44': '盈利金额方式：金额倍率：{moneyPercent}，最高不超过：{maxMoney}元 | ',
  'sys.msg44VN': '盈利金额方式：金额倍率：{moneyPercent}，最高不超过：{maxMoney}VND | ',
  'sys.msg45': '盈利金额方式：积分倍率：{pointPercent}，最高不超过：{maxPoint}',
  'sys.msg46': '元，达到',
  'sys.msg46VN': 'VND，达到',
  'sys.msg47': '{money} 元，{betflowMulti} 倍流水可提',
  'sys.msg47VN': '{money} VND，{betflowMulti} 倍流水可提',
  'sys.msg48': '{point} 积分',
  'sys.msg49': '中奖概率 {probability}%，总共 {totalNumber}份，每日 {dailyTotalNumber} 份',
  'sys.msg50': '请添加优惠内容后再提交！',
  'sys.msg51': '{giftMoney}元现金入主账户，{betMultiple}倍流水可提。',
  'sys.msg52': '{giftPoint} 积分入主账户。 ',
  'sys.msg53': '{prizeName} 自定义实物奖励。',
  'sys.msg54': '再接再厉哦',
  'sys.msg55': '自定义实物',
  'sys.msg56': '再接再厉',
  'sys.msg57': '请添加连续奖励内容后再提交！',
  'sys.msg58': '连续天数必须大于0！',
  'sys.msg59': '|流水要求方式：',
  'sys.msg60': '+优惠金额 ',
  'sys.msg61': '优惠金额 ',
  'sys.bonus.lock.type': '锁定类型 ',
  'sys.bonus.lock.type.1': '优惠金额',
  'sys.bonus.lock.type.2': '优惠金额 + 本金',
  'sys.bonus.deposit.lock.type': '解锁相关',
  'sys.bonus.deposit.lock.type.0': '不解锁',
  'sys.bonus.deposit.lock.type.1': '解锁此订单的充值锁定',
  'sys.msg62': '| {betMultiple} 倍流水',
  'sys.app': 'APP',
  'sys.mobileVersion': '手机版',
  'sys.webVersion': '网页版',
  'sys.continuousCheck-inForFixedRewards': '连续签到固定奖励',
  'sys.singleSign-inRaffleReward': '单次签到抽奖奖励',
  'sys.loginSide': '登录端',
  'sys.selectLoginSide': '请选择登录端',
  'sys.prizeSetting': '奖品设置',
  'sys.selectPrizeSetting': '请选择奖品设置',
  'sys.continuousCheck-in': '连续签到',
  'sys.continuousCheck-in1': '请输入连续签到天数',
  'sys.amountObtained': '获得金额',
  'sys.earnPoints': '获得积分',
  'sys.enterEarnPoints': '请输入可获得的积分',
  'sys.addedSweepstakesBonus': '已添加的抽奖奖励',
  'sys.no1': '暂无',
  'sys.addReward': '添加奖励',
  'sys.rewardAmount': '奖励金额',
  'sys.enterRewardAmount': '请输入奖励金额',
  'sys.cashFlowRequirement': '提现流水要求',
  'sys.enterCashFlowRequirement': '请输入提现流水要求',
  'sys.rewardPoints': '奖励积分',
  'sys.enterRewardPoints': '请输入奖励积分',
  'sys.physicalName': '实物名称',
  'sys.enterPhysicalName': '请输入实物名称',
  'sys.clickSelectImage': '点击选择图片',
  'sys.enterProbabilityWinning': '请输入中奖概率',
  'sys.totalNumberCopies': '总份数',
  'sys.enterTotalNumberCopies': '请输入总份数',
  'sys.distributeMostDaily': '每日最多派发',
  'sys.enterDistributeMostDaily': '请输入每日最多派发数量',
  'sys.lotteryConditions': '抽奖条件',
  'sys.daysDeposit': '存款天数',
  'sys.enterDaysDeposit': '请输入连续存款天数',
  'sys.dailyDepositAmount': '每日存款金额',
  'sys.addLotteryPrizes': '添加抽奖奖品',
  'sys.ruleSetting': '规则设置',
  'sys.balance': '余额',
  'sys.msg63': '存款金额：{minDeposit}~{maxDeposit}',
  'sys.msg64': '赠送现金：{giftPercent}%，最多可送：{maxBonusAmount}',
  'sys.msg65': ' | 流水倍数：{betMultiple}',
  'sys.msg66': '存款金额：{minDeposit}~{maxDeposit} | 流水要求：{betMultiple} 倍以上',
  'sys.msg67': '赠送现金：{giftPercent}%，最多可送：{maxBonusAmount} | 流水倍数：{betMultiple}',
  'sys.successfulOperation': '操作成功！',
  'sys.discountInformation': '优惠信息',
  'sys.displayInformation': '展示信息',
  'sys.previous': '上一步',
  'sys.offerEditedSuccessfully': '优惠编辑成功。',
  'sys.returnListPage': '返回列表页',
  'sys.msg68': '赠送投注额倍数：{giftMultiple}',
  'sys.msg69': ' | 流水要求：{betMultiple} 倍 | 赠送金额最高不能超过：{maxGiftMoney}',
  'sys.msg70': '派彩大于有效投注倍数：{minMultiple} ~ {maxMultiple}',
  'sys.msg71': '请至少选择一个优惠内容！',
  'sys.msg72': '等级：{level}，累计 {betflow} 元有效投注额',
  'sys.msg73': '享受：{upAmount} 元升级礼金，{weekAmount} 元周俸禄礼金，{monthAmount} 元月俸禄礼金。所有礼金 {betMultiple} 倍流水可提款',
  'sys.importTime': '导入时间',
  'sys.importCount': '导入条数',
  'sys.importSuccessCount': '导入成功条数',
  'sys.importFailCount': '失败条数',
  'sys.seeDetails': '查看详情',
  'sys.batchImport': '批量导入',
  'sys.formatDescription': '格式说明',
  'sys.formatDescription1': '1、红利名称',
  'sys.formatDescription2': '2、用户名',
  'sys.formatDescription3': '3、优惠金额',
  'sys.formatDescription4': '4、流水要求金额',
  'sys.busyServer': '服务器繁忙，请稍后再试。',
  'sys.batchImportSucceeded': '批量导入成功',
  'sys.importSucceeded': '导入成功',
  'sys.importFail': '导入失败',
  'sys.msg74': '总导入 {importCount} 条,成功 {importSuccessCount} 条,失败 {importFailCount} 条。',
  'sys.msg75': '首页推荐最多可以设置6条',
  'sys.uploadError': '上传错误，请稍后再试。',
  'sys.batchImportOffers': '批量导入优惠',
  'sys.batchImportOffersDetails': '批量导入优惠详情',
  'sys.determine': '确定',
  'sys.import': '导入',
  'sys.whetherSucceed': '是否成功',
  'sys.importStatus': '导入状态',
  'sys.content1': '内容',
  'sys.enterContent1': '请输入内容',
  'sys.error.loadRoles': '加载角色数据失败',
  'agent.title.confirmOffer2': '请确认是否发放?',
  'sys.confirmRejectionThisOffer': '请确认拒绝此优惠申请?',
  'sys.confirmCancelThisOffer': '请确认取消此优惠?',
  'sys.winningNumber': '中奖注单号',
  'sys.preferentialVariety': '优惠品种',
  'sys.allVarieties': '全部品种',
  'sys.preferentialPrincipal': '优惠本金',
  'sys.targetFlow': '目标流水',
  'sys.effectiveFlow': '活动期间总有效投注',
  'sys.flowCalculationState': '流水计算状态：',
  'sys.completionCalculation': '计算完成',
  'sys.hasFailed': '已失败',
  'sys.offerCurrentStatus': '优惠当前状态：',
  'sys.offerCurrentStatus1': '优惠当前状态',
  'sys.offerArrivalTime': '优惠到账时间',
  'sys.runningWaterCalculationCompletionTime': '计算完成时间',
  'sys.userWinsLoses': '用户输赢',
  'sys.platformProfitLoss': '平台盈亏',
  'sys.examinationPassed': '审核通过',
  'sys.setEffectiveFlow': '设置有效流水',
  'sys.winningNumber1': '中奖单号',
  'sys.totalDiscount': '总优惠金额',
  'sys.totalDiscount1': '总优惠条数',
  'sys.totalDiscount2': '总救援金条数',
  'sys.totalDiscount3': '总升级奖励条数',
  'sys.totalDiscount4': '总蝉联奖励条数',
  'sys.totalDiscount5': '总手动添加优惠条数',
  'sys.totalDiscount6': '总流水优惠条数',
  'sys.totalDiscount7': '总存款优惠条数',
  'sys.totalDiscount8': '总邀请优惠条数',
  'sys.totalDiscount9': '总其他优惠条数',
  'sys.totalDiscount10': '总新邀请优惠条数',
  'sys.xls': '优惠领取记录报表.xls',
  'sys.keyword': '关键字',
  'sys.releaseStartTime': '发放开始时间',
  'sys.chooseStartTime': '选择开始时间',
  'sys.chooseEndTime': '选择结束时间',
  'sys.releaseEndTime': '发放结束时间',
  'sys.enterValidWater': '请输入有效流水',
  'sys.recommendedOfferTips': '推荐优惠提示',
  'sys.setRecommendedBonusInformation': '设置推荐红利信息',
  'sys.offerTitle': '优惠标题',
  'sys.offerTitleName': '优惠类型名称',
  'sys.offerTitle1': '优惠副标题',
  'sys.enterOfferTitle1': '请输入优惠副标题',
  'sys.msg76': 'PC端尺寸: 1000*150px',
  'sys.msg77': '移动端推荐优惠图片',
  'sys.msg78': '移动端尺寸: 360*180px',
  'sys.msg79': '建议您先下架文章后，再关闭此优惠。',
  'sys.msg80': '确认取消首页优惠推荐吗？',
  'sys.offerType': '优惠类型',
  'sys.scopeApplication': '适用范围',
  'sys.editor': '编辑人',
  'sys.editTime': '更新时间',
  'sys.self-serviceArea': '自助服务区',
  'sys.image': '图片',
  'sys.whetherDisplayListBySort': '是否按排序显示列表',
  'sys.selectOfferType': '选择优惠类型',
  'sys.msg81': '是否清楚关联优惠信息',
  'sys.msg82': '请仔细核对是否确认？',
  'sys.offerList': '优惠列表',
  'sys.unlink': '取消关联',
  'sys.firstDepositOffer': '首存优惠',
  'sys.OtherOffers': '其他优惠',
  'sys.clientType': '客户端类型',
  'sys.offerMap': '优惠图',
  'sys.sharingPhoto': '宣传图片',
  'sys.amount': '发放金额',
  'sys.profitLoss': '优惠盈亏',
  'sys.numberRecipients': '领取人数',
  'sys.numberIssues': '发放次数',
  'sys.offerStatus': '优惠状态',
  'sys.msg83': '即将删除标题 {name} 的公告',
  'sys.msg84': '确认禁用该公告吗？',
  'sys.msg85': '确认启用该公告吗？',
  'sys.msg86': '即将删除标题 {title} 的文章',
  'sys.msg87': '即将删除标题 {name} 的文章类型',
  'sys.msg88': '即将删除名为{pcName}的游戏导航图标',
  'sys.confirmationOperation': '确认操作',
  'sys.pushTitle': '推送标题',
  'sys.usableNot': '是否可用',
  'sys.usable': '可用',
  'sys.usable1': '不可用',
  'sys.modifyAnnouncementMessage': '修改公告消息',
  'sys.addAnnouncement': '添加公告',
  'sys.addAnnouncementMessage': '添加公告消息',
  'sys.announcementTitle': '公告标题',
  'sys.loseAnnouncementTitle': '请输公告标题',
  'sys.enterTitleAnnouncement': '请输入公告标题',
  'sys.announcementType': '公告类型',
  'sys.selectAnnouncementType': '请选择公告类型',
  'sys.announcementContent': '公告内容',
  'sys.enterAnnouncementContent': '请输入公告内容',
  'sys.startEndTime': '起止时间',
  'sys.selectStartEndTime': '请选择起止时间',
  'sys.articleTitle': '文章标题',
  'sys.enterArticleTitle': '请输入文章标题',
  'sys.articleType': '文章类型',
  'sys.enterArticleType': '请输入文章类型',
  'sys.pcPlatform': 'PC平台',
  'sys.h5Platform': 'H5平台',
  'sys.modifyArticles': '修改文章',
  'sys.addArticle': '添加文章',
  'sys.articleContent': '文章内容',
  'sys.enterArticleContent': '请填写文章内容',
  'sys.addArticleType': '添加文章类型',
  'sys.enterArticleTypeTitle': '请输入文章类型标题',
  'sys.articleExhibitType': '推送至',
  'sys.articleExhibitType2': '展示类型',
  'sys.articleHelpCenter': '帮助中心',
  'sys.articleTopIconPc': '置顶图标PC端',
  'sys.articleTopIconH5': '置顶图标移动端',
  'sys.smallIcon': '小图标',
  'sys.bigIcon': '大图标',
  'sys.extraLogo': '额外图标',
  'sys.addGameNavigation': '添加游戏导航',
  'sys.addGameName': '游戏导航名称',
  'sys.msg89': 'PC端大小图标必须传一个',
  'sys.msg90': 'Mobile端大小图标必须传一个',
  'sys.msg91': 'pc端-上传游戏小LOGO',
  'sys.msg92': 'pc端-上传游戏大LOGO',
  'sys.msg93': 'mobile端-上传游戏小LOGO',
  'sys.msg94': 'mobile端-上传游戏大LOGO',
  'sys.msg95': '即将删除配置项{name}!',
  'sys.msg96': '图片路径事件URI: 有此字段时,当点击图片时,会调转至点击路径的页面,要是此字段无值,则不对点击图片做任何操作',
  'sys.msg97': '注意: 图片路径事件URI的格式为;例如www.baidu.com/#/game/all此页面为所需要调转的页面的全路径,则在此所需要的参数的URI为#/game/all',
  'sys.msg98': '该功能用于商户上传图片,来新增/替换前端图片',
  'sys.msg99': '顺序: 可自行排序图片展示顺序',
  'sys.msg100': '即将删除名称为: {imgName} 的图片',
  'sys.msg101': '图片路径事件URI',
  'sys.msg201': 'pc端-上传游戏额外LOGO',
  'sys.msg202': 'mobile端-上传游戏额外LOGO',
  'sys.msg203': '新版手机端游戏平台图标',
  'sys.msg204': '新版H5图片',
  'sys.gameNavigationName': '游戏导航名字',
  'sys.enterGameNavigationName': '请输入游戏导航名字',
  'sys.page': '页面',
  'sys.fillRoleInformation': '填写角色信息',
  'sys.enterName': '请输入名称',
  'sys.enterType': '请输入类型',
  'sys.enterStatus': '请输入状态',
  'sys.contentConfiguration': '内容配置',
  'sys.contentConfiguration1': '页面配置',
  'sys.keywordSearch': '关键字搜索',
  'sys.imageName': '图片名称',
  'sys.enterImageName': '请输入图片名称',
  'sys.imageName1': '图片名称/描述',
  'sys.imageGroup': '图片组',
  'sys.addPictures': '添加图片',
  'sys.imageDescription': '图片描述',
  'sys.msg102': '点击图片时的链接',
  'sys.msg103': '最大可传图片数: 是限制该CODE组下最大可拥有的图片数',
  'sys.msg104': '描述: 对图片/图片组的作用做概述',
  'sys.msg105': '即将禁用名称为: {imgName}的图片组',
  'sys.msg106': '即将启用名称为: {imgName}的图片组',
  'sys.numberUploadedImages': '已上传图片数',
  'sys.sendPushMessage': '发送推送消息',
  'sys.pushPlatform': '推送平台',
  'sys.pushPlatform1': '请选择推送平台',
  'sys.android': '安卓',
  'sys.ios': 'IOS',
  'sys.title': '标题',
  'sys.fillPushTitle': '请填写推送标题',
  'sys.fillPushContent': '请填写推送内容',
  'sys.pushContent': '推送内容',
  'sys.msg107': '推送人/推送时间',
  'sys.msg108': '是否选择记录置为已读',
  'sys.msg109': '是否选择记录置为未读',
  'sys.pushDate': '推送日期',
  'sys.messageType': '消息类型',
  'sys.theme': '主题',
  'sys.enterTheme': '请输入主题',
  'sys.time1': '时间',
  'sys.haveRead': '已读',
  'sys.unread': '未读',
  'sys.reply': '回信',
  'sys.hasBeenBack': '已回',
  'sys.userNotSelected': '未选中用户',
  'sys.markRead': '标记为已读',
  'sys.markRead1': '标记为未读',
  'sys.msg110': '是否删除选择记录',
  'sys.recipient': '收件人',
  'sys.selectRecipient': '请选择收件人',
  'sys.sender': '寄件人',
  'sys.systemSend': '系统发送',
  'sys.operationalTransmission': '运营发送',
  'sys.operator': '操作人员',
  'sys.sender1': '发件人',
  'sys.send': '发送',
  'sys.sendHand': '手工发送',
  'sys.sendSiteMsg': '发送站内信',
  'sys.agentMustSelected': '必须选择代理',
  'sys.memberMustFilledOut': '必须填写会员',
  'sys.mustFillVipLevel': '必须填写vip等级',
  'sys.mustFillTimePeriod': '必须填写时间段',
  'sys.parameterNotComplete': '参数未填写完整',
  'sys.msg111': '温馨提醒: 会员账号如果绑定了邮箱,既可收到您填写的邮件',
  'sys.msg112': '请输入会员可以以(,)逗号分隔',
  'common.agent1': '代理: ',
  'sys.selectAgent': '请选择代理',
  'sys.allMembers': '所有会员',
  'sys.actingMembers': '代理会员',
  'sys.baiBanMembers': '白板APP会员',
  'sys.sixtyMembers': '近60天内登陆过会员',
  'sys.contentEmail': '邮件内容',
  'sys.fillLetter': '请填写站内信',
  'sys.stationLetterContent': '站内信内容',
  'sys.operation.upgrade': '升级模式',
  'sys.msg113': '升级条件，（周俸禄每周星期三派发，月俸禄每月三号派发）',
  'sys.timeArrival': '到账时间',
  'sys.totalNumberArticles': '总条数',
  'sys.add': '新增',
  'sys.smg114': '确认将',
  'sys.smg115': '级所属',
  'sys.smg116': '特权设置',
  'sys.smg117': '即将删除的特权：{title}',
  'sys.smg118': '{vipLevel}级',
  'sys.smg119': '请输入少于20字符的特权主标题',
  'sys.smg120': '请输入推广图片名称',
  'sys.smg121': '请输入少于20字的特权副标题',
  'sys.smg122': '请确认填写信息正确，以及对应逻辑正确。',
  'sys.confirmModificationStatus': '确认修改状态',
  'sys.vip7': '特权所属VIP',
  'sys.vip8': '特权主标题',
  'sys.vip9': '特权副标题',
  'sys.vip10': '添加特权',
  'sys.ipAll': '全部IP',
  'sys.ipAddr': 'IP地址',
  'sys.ipRemark': 'IP/备注',
  'sys.abnormalOperation': '操作异常，请稍后再试。',
  'sys.vip11': '添加特权信息',
  'sys.vip12': '请输入特权主标题',
  'sys.vip13': '请输入特权副标题',
  'sys.vip14': 'VIP 等级设置',
  'sys.vip15': 'Vip 名称',
  'sys.vip16': '请输入VIP名称',
  'sys.vip17': 'VIP等级',
  'sys.vip18': '查看特权',
  'sys.oldPromotionPicture': '旧推广图片',
  'sys.uploadFile': '请上传文件',
  'sys.privilegeOrder': '特权顺序',
  'sys.enterPrivilegeOrder': '请输入特权顺序',
  'sys.confirmSubmissionChanges': '确认提交修改',
  'sys.memberExpirationDate': '会员有效期',
  'sys.memberRoundMaxBet': '每局下注限额',
  'sys.memberExpirationDate1': '请选择有效期',
  'sys.promotionRequirements': '晋级要求',
  'sys.requiredPoints': '所需积分',
  'sys.requiredDeposit': '所需存款',
  'sys.requiredFlow': '所需流水',
  'sys.requiredPoints2': '保级积分',
  'sys.requiredDeposit2': '保级存款',
  'sys.requiredFlow2': '保级流水',
  'sys.relegationPeriod': '保级有效期',
  'sys.coupletRequest': '蝉联要求',
  'sys.runningWater': '流水>=',
  'sys.runningWater1': '流水',
  'sys.msg123': '%负盈利,',
  'sys.msg124': '倍可提',
  'sys.issueOnce': '发放一次',
  'sys.issueOnce1': '每天发放',
  'sys.issueOnce2': '每周发放',
  'sys.issueOnce3': '每月发放',
  'sys.issueOnce4': '每年发放',
  'sys.msg125': 'Vip {vipLevel} 级({vipName}) 会员等级设置?',
  'sys.showName': '显示名称',
  'sys.view': '查看',
  'sys.msg126': '请确认是否解锁?',
  'sys.msg127': '请确认是否通过审核?',
  'sys.lockedAmount': '锁定金额',
  'sys.flowCompletionProgress': '流水完成进度',
  'sys.completedFlow': '已完成流水：',
  'sys.offerTime': '优惠领取时间',
  'sys.offerLockList': '优惠锁定列表',
  'sys.monthlySettlementCommission': '月度结算佣金',
  'sys.confirmationReview': '确认审核',
  'sys.proxyName': '代理名称',
  'sys.selectDate': '请选择日期',
  'sys.completeSchedule': '完成进度',
  'sys.rechargeTime': '充值时间',
  'sys.depositLockList': '存款锁定列表',
  'sys.transferAmount': '转账金额',
  'sys.transferStatus': '转账状态',
  'sys.transferType': '转账类型',
  'sys.gameOut': '游戏转出',
  'sys.abnormal': '异常',
  'sys.msg128': '是否置为成功?',
  'sys.msg129': '置为成功,如果转账类型为游戏转出,则金额添加到玩家资产上',
  'sys.msg130': '是否置为失败?',
  'sys.msg131': '置为失败,如果转账类型为转入游戏,则金额添加到玩家资产上',
  'sys.msg132': '订单号、用户名、游戏平台',
  'sys.setSuccess': '置为成功',
  'sys.setFail': '置为失败',
  'sys.totalWithdrawal': '总取款',
  'sys.offerComposition': '优惠组成',
  'sys.gameWater': '游戏流水',
  'sys.bankRelated': '银行相关',
  'sys.bankCode': '银行代码：',
  'sys.bankName': '银行名称：',
  'sys.branchName': '支行名称：',
  'sys.branchAddr': '支行地址：',
  'sys.accountRelated': '账户相关',
  'sys.msg133': '账户名：',
  'sys.msg134': '银行账号：',
  'sys.msg135': '最终得到金额',
  'sys.msg136': '近七日流水记录',
  'sys.msg137': 'IP所在地区',
  'sys.msg138': '查看该 IP 登录过的用户',
  'sys.msg139': 'IP地址统计',
  'sys.normal': '正常',
  'sys.bankInformation': '银行信息',
  'sys.attributionType': '归属类型',
  'sys.offerRecord': '优惠记录',
  'sys.userDeviceID': '用户设备ID',
  'sys.deviceInformation': '设备信息',
  'sys.operatingSystemVersion': '操作系统版本',
  'sys.longitude': '经度',
  'sys.latitude': '纬度',
  'sys.loginTimes': '登录次数',
  'sys.loginTimes1': '登录次数: ',
  'sys.registrationTime': '注册时间',
  'sys.cellphoneNumber': '手机号码',
  'sys.cellphoneNumber2': '手机号码：',
  'sys.cellphoneNumber3': '手机是否认证：',
  'sys.msg140': '该 IP 登录过的其他用户',
  'sys.msg141': '上次登录时间',
  'sys.msg142': '提交申请时间',
  'sys.msg1421': '个人详细',
  'sys.windControlManagement': '风控管理',
  'sys.loginLog': '登录日志',
  'sys.deviceID': '设备Id',
  'sys.browser': '浏览器',
  'sys.transactionRecord': '交易记录',
  'sys.transactionType': '交易类型',
  'sys.transferDetails': '转账详情',
  'sys.amountAfterSettlement': '结算后金额',
  'sys.fundChange': '资金变化',
  'sys.increase': '增加',
  'sys.cutBack': '减少',
  'sys.winLossAmount': '输赢金额',
  'sys.chronologically': '时间顺序: ',
  'sys.agentWithdraw': '提款申请',
  'sys.selectRiskLevel': '选择风险等级',
  'sys.selectRiskLevel1': '请选择风控等级',
  'sys.windControlLevel': '风控等级',
  'sys.confirmConsent': '确认同意',
  'sys.confirmConsent1': '是否同意此操作?',
  'sys.confirmConsent2': '是否拒绝此操作?',
  'sys.cardholder': '持卡人',
  'sys.viewUserDetails': '查看用户详情',
  'sys.by': '通过',
  'sys.notApproved': '未审批',
  'sys.passed': '已通过',
  'sys.paid': '已出款',
  'sys.successfulPayment': '出款成功',
  'sys.smg143': '待审批用户',
  'sys.smg144': '限制优惠用户',
  'sys.smg145': '限制提款用户',
  'sys.smg146': '限制登录用户',
  'sys.smg147': '登录过的IP地址',
  'sys.smg148': '同设备同IP信息',
  'sys.smg149': '用户输赢曲线',
  'sys.smg150': '邮箱是否认证：',
  'sys.smg151': '用户风控属性列表',
  'sys.flowRecord': '流水记录',
  'sys.userInfo': '用户信息',
  'sys.attribution': '手机归属地',
  'sys.attribution1': 'IP归属地',
  'sys.registerationName': '注册域名: ',
  'sys.details': '详细信息: ',
  'sys.searchUser': '用户名: ',
  'sys.numberDeposits': '存款次数: ',
  'sys.numberWithdrawals': '提现次数: ',
  'sys.allGrades': '全部等级',
  'sys.riskValueScore': '风险值分数',
  //sys
  'sys.managementPlatformGame': '管理平台游戏',
  'sys.receivingTime': '接收时间：',
  'sys.completeTime': '完成时间：',
  'sys.processResult': '处理结果',
  'sys.addWorkOrder': '添加工单',
  'sys.smg155': '内容/备注/提交人',
  'sys.submitPer': '提交人',
  'sys.submitTime': '提交时间',
  'sys.fillWorkOrder': '填写工单',
  'sys.enterTitle': '请输入标题',
  'sys.smg156': '请输入工单内容、建议或者意见',
  'sys.enterProcessingResult': '请输入处理结果',
  'sys.realUnlockAmount': '真人解锁金额',
  'sys.enterParameterAmount': '请输入参数金额',
  'sys.realState': '真人状态',
  'sys.videoGameUnlockAmount': '电子游戏解锁金额',
  'sys.videoGameStatus': '电子游戏状态',
  'sys.sportsUnlockAmount': '体育解锁金额',
  'sys.sportsStatus': '体育状态',
  'sys.chessCardUnlockingAmount': '棋牌解锁金额',
  'sys.chessState': '棋牌状态',
  'sys.fishingUnlockAmount': '捕鱼解锁金额',
  'sys.fishingStatus': '捕鱼状态',
  'sys.lotteryUnlockAmount': '彩票解锁金额',
  'sys.lotteryStatus': '彩票状态',
  'sys.universalUnlockAmount': '通用解锁金额',
  'sys.defaultState': '默认状态',
  'sys.smg157': '注意：解锁金额设置的数字会影响会员锁定中的资金。',
  'sys.smg158': '优惠锁定金额减去优惠输钱金额低于这个解锁金额。',
  'sys.smg159': '存款锁定金额减去输的钱低于这个解锁金额。',
  'sys.smg160': '系统就会自动将该优惠或存款解锁，并将状态设置为失败。',
  'sys.smg161': '指定游戏类型的优惠会使用对应游戏类型的解锁参数，没有指定游戏类型的优惠及存款锁定会使用默认的解锁参数。',
  'sys.confirmUpload': '确认上传',
  'sys.smg162': '此上传会影响到用户APP端下载。请谨慎，是否上传?',
  'sys.smg163': 'APP版本打包上传',
  'sys.AppType': 'APP类型',
  'sys.selectAppTypr': '请选择APP类型',
  'sys.version': '版本号',
  'sys.enterVersion': '请输入版本号',
  'sys.smg164': '最多输入10个字符',
  'sys.pleaseUpload': '请上传',
  'sys.pleaseUploadApp': '请上传APP包',
  'sys.pleaseNote': '请注意',
  'sys.smg165': '选择APP文件确定之后，自动提交上传！！！',
  'sys.AppUploadUpdateSucceeded': 'APP上传更新成功',
  'sys.returnRefreshHome': '返回刷新首页',
  'sys.configurationItem': '配置说明项',
  'sys.enterConfigurationItem': '请输入配置说明项',
  'sys.withdrawalOrderSplit': '提现订单拆分',
  'sys.smg166': '是否{msg}提现订单拆分？',
  'sys.addPaymentChannel': '添加代付渠道',
  'sys.orderSplitConfiguration': '订单拆分配置',
  'sys.maxAmount': '最高金额',
  'sys.minAmount': '最低金额',
  'sys.nameCode': '名称/code',
  'sys.fillPaymentChannelInformation': '填写代付渠道信息',
  'sys.paymentRate': '代付费率',
  'sys.enterPaymentRate': '请输入代付费率',
  'sys.controllerPath': 'controller路径',
  'sys.fillPaymentSplitConfiguration': '填写代付拆分配置',
  'sys.splitMinimumAmount': '拆分最小金额',
  'sys.splitMaximumAmount': '拆分最大金额',
  'sys.whetherOpen': '是否开启',
  'sys.isSubmit': '是否提交',
  'sys.confirmSubmit': '请仔细核对信息是否正确，是否提交',
  'sys.diffPass': '密码不一致，请确认',
  'sys.formatError': '只能以小写字母开头，只含有小写字母和数字',
  'sys.Pass': '密 码',
  'sys.cleanValidator': '确认要将该后台账号绑定的验证器清除吗？',
  'sys.deleteAccount': '即将删除的账号：{username}',
  'sys.forceOffline': '强制离线',
  'sys.resetValidator': '重置验证器',
  'sys.fillDeviceInfo': '填写设备信息',
  'sys.deviceNo': '设备编号',
  'sys.deviceNo1': '请输入设备编号',
  'sys.deviceNo2': '请输入设备编号备注',
  'sys.deviceNo3': '即将删除的设备编号：{deviceNum}',
  'sys.confirmRefreshBlackList': '确定要刷新设备黑名单列表吗？',
  'sys.refreshBlackList': '刷新设备黑名单',
  'sys.addDeviceNo': '添加设备编号',
  'sys.fillIPInfo': '填写IP信息',
  'sys.startIP': '开始IP',
  'sys.startIP1': '请输入开始IP',
  'sys.endIP': '结束IP',
  'sys.endIP1': '请输入结束IP',
  'sys.endIP2': '请输入IP备注',
  'sys.deleteIP': '即将删除的IP：{ipMinRange}',
  'sys.beginIP': 'IP地址开始',
  'sys.overIP': 'IP地址结束',
  'sys.confirmRefreshIPBlackList': '确定要刷新IP黑名单列表吗？',
  'sys.addIP': '添加IP',
  'sys.refreshIpBlackList': '刷新IP黑名单',
  'sys.changeTime': '修改时间',
  'sys.inputIPAddress': '请输入IP地址',
  'sys.inputIPAddress1': '多IP请用\',\'号分割',
  'sys.editPlayMethodDesc': '编辑玩法说明',
  'sys.playMethodDesc': '玩法说明',
  'sys.playMethodDesc1': '请输入玩法说明',
  'sys.winningExample': '中奖举例',
  'sys.winningExample1': '请输入中奖举例',
  'sys.confirmEnablePlayMethod': '确认要启用该玩法吗？',
  'sys.confirmDisablePlayMethod': '确认要禁用该玩法吗？',
  'sys.people': '人员',
  'sys.editDesc': '编辑说明',
  'sys.inputYear': '输入年份',
  'sys.attributeName': '属性名称',
  'sys.confirmChangeLiuHeOdds': '是否确认修改六合彩彩【 {firstName}-{secondName} 】玩法赔率?',
  'sys.save': '保存',
  'sys.odds': '，赔率：',
  'sys.cleanWhiteListCache': '清理白名单缓存',
  'sys.inputIPAddress3': '请输入IP地址,多IP请用\',\'号分割',
  'sys.accountUnlockParam': '账户解锁参数',
  'sys.lowOrderCount': '最低订单数',
  'sys.lowOrderCount1': '请输入最低订单数',
  'sys.lowOrderCount2': '请输入正确的数字',
  'sys.percentageWarning': '预警百分比',
  'sys.percentageWarning1': '请输入预警百分比',
  'sys.disablePercentage': '禁用百分比',
  'sys.disablePercentage1': '请输入禁用百分比',
  'sys.lowOrderCount3': '最低订单数：支付方式的总订单数大于该数值，开始判断该支付方式是否发送预警消息及自动禁用。',
  'sys.percentageWarning2': '预警百分比：支付方式的成功率低于该百分比，发送预警消息，发送消息显示在页面右上角。',
  'sys.disablePercentage2': '禁用百分比：支付方式的成功率低于该百分比，该支付方式自动禁用，并发送禁用消息，发送的消息显示在页面右上角。',
  'sys.disablePercentage3': '已被禁用的支付方式不会再重复发送消息。',
  'sys.gamePlatformInfo': '游戏平台信息',
  'sys.chineseName': '中文名称',
  'sys.chineseName1': '请输入中文名称',
  'sys.gameSort': '游戏排序',
  'sys.gameSort1': '请输入游戏顺序，从小到大排列',
  'sys.pc': '支持pc',
  'sys.pc1': '请选择是否支持pc',
  'sys.pc2': '支持 PC',
  'sys.notSupport': '不支持',
  'sys.h5': '支持h5',
  'sys.h51': '请选择是否支持h5',
  'sys.h52': '支持 H5',
  'sys.hotGame': '热门游戏',
  'sys.notHotGame': '非热门',
  'sys.newestGame': '最新游戏',
  'sys.notNewGame': '非最新',
  'sys.pcPic': 'PC 图片',
  'sys.h5Pic': 'H5 图片',
  'sys.gameNo': '游戏编号',
  'sys.pcPicH5Pic': 'PC/H5图片',
  'sys.notSupportPc': '不支持PC 端',
  'sys.notSupportH5': '不支持移动端',
  'sys.newGame': '新游戏',
  'sys.tryPlay': '支持试玩',
  'sys.hot': '热',
  'sys.new': '新',
  'sys.try': '试',
  'sys.addMaintenanceInfoSuccess': '添加维护信息成功！',
  'sys.addMaintenanceInfoFail': '添加维护信息失败',
  'sys.addMaintenanceInfoError': '添加维护信息错误',
  'sys.maintenanceInfo1': '请填写维护信息',
  'sys.maintenanceInfo': '维护信息',
  'sys.fillGamePlatFormInfo': '填写游戏平台信息',
  'sys.platFormNo': '请输入平台编号',
  'sys.platFormGameNo': '平台游戏编号',
  'sys.platFormGameNo1': '请输入平台游戏编号',
  'sys.platFormFullName': '平台全称',
  'sys.gameNameAndGameType': '平台名称+游戏类型',
  'sys.platformRate': '平台费率',
  'sys.platformRate1': '请输入平台费率',
  'sys.platformDesc': '平台描述',
  'sys.platformDesc1': '请输入平台描述',
  'sys.platformDesc2': '最多输入255个字符',
  'sys.platformSort1': '请输入平台排序',
  'sys.platformSort2': '按自然顺序从大到小',
  'sys.platformSort': '平台排序',
  'sys.allPlatform': '全部平台',
  'sys.fullName': '全名',
  'sys.gameRate': '游戏费率',
  'sys.confirmDeleteGamePlatForm': '即将删除的游戏平台{fullName}',
  'sys.isHot': '是否热门',
  'sys.hotSort': '热门排序',
  'sys.addPlatFomr': '添加平台',
  'sys.isMaintenance': '是否维护',
  'sys.changeHotSort': '修改 {value} 的热门排序',
  'sys.hotSort1': '请输入热门排序',
  'sys.mailInfo1': '填写邮箱信息',
  'sys.mailInfo2': '请输入邮箱用户名',
  'sys.mailInfo3': '请输入少于80个字符的邮箱用户名',
  'sys.mailPass': '邮箱密码',
  'sys.mailPass1': '请输入邮箱密码',
  'sys.mailPass2': '请输入少于80个字符的邮箱密码',
  'sys.mailSMTP1': '请输入SMTP地址',
  'sys.mailSMTP2': '请输入少于200个字符的SMTP地址',
  'sys.encryptionType': '加密类型',
  'sys.encryptionType1': '请选择加密类型',
  'sys.encryptionType2': '无加密(多数的端口是25)',
  'sys.ssl': 'SSL(多数的端口是465)',
  'sys.tls': 'TLS(多数的端口是587)',
  'sys.port': '端口号',
  'sys.port1': '请输入端口号',
  'sys.deleteMail': '即将删除的邮箱：{username}',
  'sys.addMail': '添加邮箱',
  'sys.addMailTemplate': '填写邮件模板信息',
  'sys.templateName': '模板名称',
  'sys.templateName1': '请输入模板名称',
  'sys.mailTitle': '邮件标题',
  'sys.mailTitle1': '请输入邮件标题',
  'sys.mailContent1': '请输入邮件内容',
  'sys.mailRemark': '邮件备注',
  'sys.mailRemark1': '请输入邮件备注',
  'sys.deleteMailTemplate': '即将删除的邮件模板：{name}',
  'sys.addTemplate': '添加模板',
  'sys.allTemplate': '全部模板',
  'sys.buttonPermissionMgt': '按钮权限管理',
  'sys.noticeDataPermissionMgt': '通知数据权限管理',
  'sys.noticePermission': '通知权限',
  'sys.pageDataPermissionMgt': '页面数据权限管理',
  'sys.console': '控制台',
  'sys.deleteRole': '即将删除的角色：{roleName}',
  'sys.roleName': '角色名称',
  'sys.roleSort': '角色顺序',
  'sys.dataPermission': '数据权限',
  'sys.operatePermission': '操作权限',
  'sys.disableRole': '是否要禁用此角色？',
  'sys.enableRole': '是否要启用此角色？',
  'sys.addRole': '添加角色',
  'sys.inputRoleName': '请输入角色名称',
  'sys.inputRoleSort': '请输入角色顺序',
  'sys.payLine': '赔付线',
  'sys.cumulativePrizePool': '累计奖池',
  'sys.classGame': '经典游戏',
  'sys.eliminateMusic': '消消乐',
  'sys.electricHorn': '电动角子',
  'sys.gameId': '游戏ID',
  'sys.intoGameParam': '进入游戏参数,慎重填写',
  'sys.isTryGame': '请选择是否支持试玩',
  'sys.payLine1': '请输入赔付线',
  'sys.uploadPcPic': '上传PC图片',
  'sys.oldPcPic': '旧PC图片: ',
  'sys.oldH5Pic': '旧h5图片: ',
  'sys.uploadH5Pic': '上传h5图片',
  'sys.platformName': '平台名字',
  'sys.uploadApp': '上传APP文件',
  'user.title.totalUserCount': '总人数: ',
  'user.title.totalDepositUserCount': '总存款人数',
  'user.title.totalFirstDepositUserCount': '首存金额',
  'common.productName': '游石 · Game Stone',
  'common.changeLang': '切换语言',
  'common.page.showtotal': '当前共 {total} 条记录',
  'common.page.pageInfo': '第 {currentPage}/{totalPages} 页',
  'common.page.showSelectTotal': '当前共 {total} 条，已选中 {select} 条',
  'common.404': '404',
  'common.unkonwException': '未知异常',
  'common.unkonwError': '未知异常',
  'common.requestException': '请求异常',
  'common.requestException1': '请求异常，请稍后再试。',
  'common.requestError1': '请求失败，请重试！',
  'common.requestError': '{err}，请稍后再试。',
  'common.operateFail': '操作失败',
  'common.action': '操作',
  'common.delete': '删除',
  'common.operateSuccess': '操作成功',
  'common.operateSuccess2': '操作成功,系统自动处理，请稍后刷新查询。',
  'common.operateSuccess1': '添加成功',
  'common.operateFail1': '操作失败，请稍后再试',
  'common.operateFail2': '操作失败，{message}',
  'common.export.loading': '正在导出计算中......',
  'common.export.success': '导出成功!',
  'common.export.error': '导出失败,导出数据过大,请分批导出',
  'common.export.excel': '导出报表',
  'common.export.noneExport': '当前用户没有导出的数据',
  'common.export': '导出',
  'common.tip': '提示',
  'common.pleaseSelectDateRange': '请选择日期范围',
  'common.exportFailed': '导出失败',
  'common.export.type': '导出类型',
  'common.export.type0': '常规会员导出',
  'common.export.type2': '常规代理导出',
  'common.export.type1': '总计会员导出',
  'common.export.type3': '总计代理导出',
  'common.export.notice': '请选择要生成的Execl表内容',
  'common.Button.details': '详情',
  'common.Button.expandDetails': '展开明细',
  'common.Button.collapseDetails': '收起明细',
  'common.Button.enableDeduplication': '开启去重',
  'common.Button.disableDeduplication': '关闭去重',
  'common.button.update': '修改',
  'common.button.update.role': '修改角色',
  'common.button.delete': '删除',
  'common.button.add': '新增',
  'common.query': '查询',
  'common.queryFrm.search': '搜索',
  'common.queryFrm.reset': '重置',
  'common.refresh': '刷新',
  'common.queryFrm.searchMore': '更多搜索',
  'common.queryFrm.searchClean': '清空搜索条件',
  'common.queryFrm.searchHide': '更多搜索已隐藏，如果未清空搜索条件，可点击按钮清空搜索条件',
  'common.queryFrm.keyWord': '关键词',
  'common.queryFrm.nickName': '昵称',
  'common.queryFrm.cleanAndClose': '清空并关闭',
  'common.queryFrm.searchUserAccountPhoneMail': '用户名/手机/邮箱',
  'common.queryFrm.searchUserAccountBetflowNumber': '用户名/流水号',
  'common.queryFrm.searchUserAccountBetflowRoundNumber': '用户名/注单号/竞猜期数',
  'common.queryFrm.searchUserAccountRemark': '用户名/备注',
  'common.queryFrm.giftGiveName': '送礼人',
  'common.queryFrm.giftCollectName': '收礼人',
  'common.queryFrm.giftName': '礼物名称',
  'common.queryFrm.showAccount': '主播账号',

  'common.radio.seconds': '秒',
  'common.radio.minute': '分钟',
  'common.radio.hour': '小时',
  'common.radio.day': '天',
  'common.radio.week': '周',
  'common.radio.month': '月',
  'common.radio.permanent': '永久',
  'common.radio.today': '今天',
  'common.radio.yesterday': '昨天',
  'common.radio.beforeYesterday': '前天',
  'common.radio.last7Day': '前7天',
  'common.radio.last15Day': '前15天',
  'common.radio.last30Day': '前30天',
  'common.radio.thisWeek': '本周',
  'common.radio.lastWeek': '上周',
  'common.radio.thisMonth': '本月',
  'common.radio.lastMonth': '上月',
  'common.radio.disable': '禁用',
  'common.radio.enable': '启用',
  'common.radio.enableDisable': '请选择是否启用',
  'common.radio.enableDisable1': '是否启用',
  'common.radio.block': '隐藏',
  'common.radio.display': '显示',
  'common.radio.blockDisplay': '是否启用',
  'common.radio.recommend': '推荐',
  'common.radio.notRecommend': '不推荐',
  'common.radio.recommendAndNotRecommend': '是否推荐',
  'common.radio.pc': '电脑端',
  'common.radio.mobile': '移动端',
  'common.radio.pcAndMobile': '显示平台',
  'common.radio.level1': '一级',
  'common.radio.level2': '二级',
  'common.title.dataSummary': '数据汇总',
  'common.title.operate': '操作',
  'common.title.serialNumber': '序号',
  'common.title.userName': '用户名',
  'common.title.completeUserName': '请输入完整会员账号',
  'common.title.createAdmin': '创建人',
  'common.title.createTime': '创建时间',
  'common.title.updateAdmin': '操作人',
  'common.title.settlement': '结算',
  'common.title.noData': '暂无数据',
  'common.records': '条记录',
  'common.queryFailed': '查询失败',
  'common.reset': '重置',
  'common.title.updateTime': '操作时间',
  'common.select.selectPlatform': '请选择平台',
  'common.select.allPlatform': '所有平台',
  'common.select.selectType1': '选择类型',
  'common.select.selectType': '请选择类型',
  'common.select.allType': '所有类型',
  'common.select.allWay': '所有方式',
  'common.select.allStatus': '所有状态',
  'common.select.allDevice': '所有设备',
  'common.select.allLevel': '所有级别',
  'common.select.selectChannel': '请选择渠道',
  'common.select.init': '请选择',
  'common.input': '请输入',
  'common.select.allChannel': '所有渠道',
  'common.select.init1': '全部',
  'common.select.init2': '全部配置',
  'common.select.selectStatus': '请选择状态',
  'common.checkBox.selectAll': '全选',
  'common.checkBox.selectAll2': '选择全部',
  'login.install.verify': '请先安装验证器',
  'login.input.username': '请输入用户名',
  'login.input.password': '请输入密码',
  'login.submit': '登录',
  'login.success': '登录成功',
  'login.please': '请登录',
  'menu.index': '首页',
  'menu.export': '数据导出',
  'menu.console': '控制台',
  'menu.queryMember': '会员列表',
  'menu.queryNewMember': '新增用户',
  'menu.queryDepositMember': '存款用户',
  'menu.queryActiveUser': '活跃用户',
  'menu.queryProfitAndLossAccount': '流失与回流用户',
  'menu.querySilentUser': '沉默用户',
  'menu.retainedUser': '活跃留存分析',
  'menu.depositUser': '存款留存分析',
  'menu.queryRegMember': '注册用户存款分析',

  'menu.userAnalysis': '用户分析',
  'menu.memberContact': '会员信息',
  'menu.memberWithdrawalInformation': '会员提款信息',
  'menu.UserGroup': '会员组管理',
  'menu.GroupStatistic': '会员组统计',
  'menu.QueryMemberLogin': '会员登录日志',
  'menu.member': '会员管理',
  'menu.bonusSetting': '优惠设置',
  'menu.bonusUpperLimit': '优惠上限',
  'menu.bonusActivities': '活动专题',
  'menu.bonusImport': '批量发放',
  'menu.bonusReport': '领取记录',
  'menu.bonusWinOrLoseReport': '盈亏统计',
  'menu.bonus': '优惠系统',
  'menu.setting': 'VIP等级设置',
  'menu.vip': '会员等级管理',
  'menu.announcement': '公告管理',
  'menu.gamePlatformLogo': '游戏平台图标管理',
  'menu.frontContent': '前台内容管理',
  'menu.activitySetting': '小游戏设置',
  'menu.activitySyntheticLog': '合成游戏领取记录',
  'menu.activityCashTurnLog': '现金大转盘记录',
  'menu.activityLog': '小游戏抽奖记录',

  'menu.activityUserCount': '小游戏额度记录',
  'menu.activity': '活动管理',
  'menu.sendSiteMsg': '发送站内信',
  'menu.inbox': '收件箱',
  'menu.siteMsg': '站内信',
  'menu.sendMail': '邮件发送',
  'menu.operation': '运营中心',
  'menu.queryGroupList': '图库',
  'menu.queryTopicList': '发帖管理',
  'menu.queryReplyList': '回复管理',
  'menu.queryComplaintList': '投诉管理',
  'menu.sixLottery': '香港六合彩',
  'menu.lotteryUserLevel': '会员等级',
  'menu.lotteryUserAttention': '会员关注',
  'menu.lotteryUserApprove': '会员点赞',
  'menu.lotteryUserDailyTask': '每日任务',
  'menu.lotteryUserTrace': '会员踪迹',
  'menu.orderList': '购彩订单',
  'menu.giveBonusList': '派奖记录',
  'menu.lotteryOrder': '六合订单',
  'menu.generalManager': '通用配置',
  'menu.userBanList': '禁言管理',
  'menu.dailyTaskManager': '日常任务',
  'menu.lotteryLevelSetting': '等级设置',
  'menu.lotteryManager': '六合管理',
  'menu.queryLotteryEntryList': '奖源录入',
  'menu.queryLotteryHistoryList': '开奖结果',
  'menu.queryLotteryOpenDateList': '开奖日期',
  'menu.lotteryOpen': '开奖管理',
  'menu.information': '资讯',
  'menu.queryMarket': '我的名单',
  'menu.unLoggedList': '未登录名单',
  'menu.queryAllocation': '分配名单',
  'menu.querySeat': '坐席管理',
  'menu.queryTeam': '团队业绩',
  'menu.queryMyScore': '我的业绩',
  'menu.queryAllScore': '查看专员详情',
  'menu.callListA': '通话详情',
  'menu.callRecord': '拨打记录',
  'menu.userInfoCallRecord': '会员详情拨打记录',
  'menu.tele': '电销系统',
  'menu.queryAgent': '代理列表',
  'menu.agentContact': '代理信息',
  'menu.queryPhoto': '宣传图片',
  'menu.agentCommissionSetting': '佣金设置',
  'menu.agentFlowCommissionSetting': '流水佣金设置',
  'menu.queryOtherCost': '代理其它费用',
  'menu.agentDomain': '代理域名',
  'menu.commissionReport': '佣金报表',
  'menu.flowCommissionReport': '流水佣金报表',
  'menu.agentReport': '代理报表',
  'menu.agentBulletin': '代理链接说明',
  'menu.agent': '代理系统',
  'menu.addAdvertising': '新增广告支出',
  'menu.queryAdAgent': '广告渠道列表',
  'menu.ad': '广告管理',
  'menu.market': '市场推广',
  'menu.seo': 'seo推广查询表',
  'menu.riskSetting': '提款审批',
  'menu.userPropAuth': '会员属性审核',
  'menu.bonusLockList': '优惠锁定',
  'menu.depositLockList': '存款锁定',
  'menu.checkAgentCommissionByRisk': '代理佣金风控审核',
  'menu.queryGameTrans': '游戏转账异常',
  'menu.risk': '风险控制',
  'menu.overall': '整体趋势',
  'menu.reportBetRecord': '投注记录报表',
  'menu.RoomReport': '直播间报表',
  'menu.RoomManage': '直播间管理',
  'menu.liveBetRecord': '竞猜投注记录报表',
  'menu.sportUnSettlement': '体育未结算记录',
  'menu.sportBetRecord': 'haha体育投注记录',
  'menu.userBehavior': '注册数据统计',
  'menu.realTimeStatistics': '实时统计',
  'menu.reportPlatform': '平台概况',
  'menu.reportChannel': '渠道报表',
  'menu.reportGamePlatform': '游戏平台报表',
  'menu.reportDeposit': '存款报表',
  'menu.reportWithdrawal': '取款报表',
  'menu.reportDividend': '优惠报表',
  'menu.userDeposit': '用户充值报表',
  'menu.paymentStatistics': '支付渠道报表',
  'menu.operationLog': '操作日志',
  'menu.giftAndShowReport2': '送礼报表',
  'menu.openShowReport': '开播报表',
  'menu.region': '直播地区管理',
  'menu.filterWord': '屏蔽词管理',
  'menu.hotWeight': '热度权重管理',
  'menu.analyze': '数据分析',
  'menu.queryPayOrder': '充值订单管理',
  'menu.payFrontConfig': '支付分类设置',
  'menu.checkAgentCommissionByFinance': '代理佣金财务审核',

  'menu.payGroup': '支付分组设置',
  'menu.payCallbackIpWhite': '支付回调白名单设置',

  'menu.payChannel': '支付渠道设置',
  'menu.withdraw': '代付渠道设置',
  'menu.UsdtAccount': 'USDT账号管理',
  'menu.finance': '财务中心',
  'menu.customerServiceConfig': '客服系统配置',
  'menu.queryRole': '角色管理',
  'menu.adminAccount': '后台账号管理',
  'menu.queryMailPool': '邮箱配置',
  'menu.queryMailTemplate': '邮件模板',
  'menu.queryGameList': '游戏列表设置',
  'menu.paymentSuccessRate': '支付成功率预警设置',
  'menu.slotManage': '老虎机管理',
  'menu.payIpWhitelist': '支付IP白名单',
  'menu.ipWhitelist': '后台 IP 白名单',
  'menu.ticket': '工单系统',
  'menu.unlockCondition': '自动解锁流水设置',
  'menu.uploadPackage': 'APP包管理',
  'menu.sys': '系统设置',
  'menu.queryMenu': '菜单管理',
  'menu.queryButton': '按钮管理',
  'menu.gameMonitor': '全局游戏监控',
  'menu.queryNotify': '通知类型管理',
  'menu.queryConfig': '系统参数',
  'menu.paySetting': '支付参数',
  'menu.queryAdmin': '管理员账号管理',
  'menu.ee': '彩蛋',
  'menu.pictureGroup': '图片管理',
  'menu.queryGamePlatform': '游戏平台设置',
  'menu.signQueryGamePlatform': '游戏平台标识设置',
  'menu.balanceRate.programSetting': '方案设置',
  'menu.queryWithdraw': '提现订单管理',
  'menu.C2CWithdraw': 'C2C提现订单管理',
  'menu.configPictureGroup': '图片组配置',
  'menu.agentWithdraw': '提款申请',
  'menu.settingGamePlatform': '游戏平台设置',

  'menu.quiz': '竞猜管理',
  'menu.guessGroup': '游戏玩法管理',
  'menu.guessRecord': '竞猜投注记录',
  'menu.guessResultLog': '竞猜开奖记录',
  'menu.uncertainBet': '待审核注单表',
  'menu.guessFeedback': '开奖反馈审核',
  'menu.liveTask': '任务管理',
  'menu.pool': '任务池',
  'menu.progress': '用户任务进度',
  'menu.jobProgress': '（新）用户任务进度',
  'menu.dailyJob': '（新）每日任务',
  'menu.sprogJob': '（新）新手任务',
  'menu.deleteJob': '即将删除的任务：{jobName}',
  'menu.payWithdraw': '提款渠道限额设置',
  'menu.handleFee': '提款手续费设置',
  'menu.payBlacklist': '渠道黑名单',

  'menu.turntable': '直播间活动',
  'menu.game': '转盘游戏设置',
  'menu.log': '转盘中奖记录',
  'menu.drawsLog': '转盘抽奖记录',
  'menu.redSendReport': '红包发送报表',
  'menu.redReceiveReport': '红包领取报表',
  'menu.firebaseLog': '消息推送',

  'menu.pixel': '像素管理',
  'menu.statistics': '统计记录',
  'menu.push': '推送记录',
  'menu.source': '像素源管理',
  'menu.userPush': '用户推送记录',

  'menu.yyg': 'YYG管理',
  'menu.yygOrder': '订单管理',
  'menu.yygConfig': '系统设置',
  'menu.yygCommodity': '商品管理',
  'menu.yygData': '数据管理',
  'menu.yygSummaryMain': '数据汇总',
  'menu.yygSummaryDetail': '数据明细',
  'menu.yygMutiple': '配置平台语言',
  'menu.yygPlatform': '配置多平台',
  'menu.yygList': '商品列表',
  'menu.yygCategory': '商品分类',
  'menu.yygPlan': '抢购计划',

  'pixel.event': '推送事件',
  'pixel.all.event': '全部事件',
  'pixel.rePush': '重新推送像素',
  'pixel.rePush.select': '请选择要推送的像素源',
  'pixel.up.name': '修改配置',
  'pixel.statistics.name': '像素名/id',
  'pixel.statistics.completeRegistration': '完成注册',
  'pixel.statistics.purchase': '首存',
  'pixel.statistics.initiateCheckout': '首次发起购物',
  'pixel.statistics.addPaymentInfo': '首次绑定银行卡',
  'pixel.xls': '像素统计报表.xls',
  'pixel.push.xls': '像素推送报表.xls',
  'pixel.add': '新增像素源',
  'pixel.up': '修改像素源',
  'pixel.select': '请选择像素源',
  'pixel.select.agent': '请选择代理',
  'pixel.source.name': '像素名称',
  'pixel.source.info': '像素ID',
  'pixel.id': '像素ID',
  'pixel.detail': '像素推送详细',
  'pixel.push.note': '推送会员可能较多，请耐心等待系统推送完毕',
  'pixel.push.detail.title': '事件详情',
  'pixel.push.user.detail': '用户信息状态',
  'pixel.push.detail.time': '推送时间及状态',

  'pixel.block.name': '推送次数名称',
  'pixel.block.userCount': '用户数',
  'pixel.block.shouldCount': '应该推送事件总数',
  'pixel.block.practicalCount': '实际推送事件总数',
  'pixel.block.regCount': '注册事件: 已推送 / 未推送',
  'pixel.block.bakCount': '首次绑定银行卡事件：已推送 / 未推送',
  'pixel.block.orderCount': '拉起订单事件：已推送 / 未推送',
  'pixel.block.depositCount': '购物事件：已推送 / 未推送',
  'pixel.block.time': '推送时间',
  'pixel.agent.clean': '解绑',


  'constants.riskLevelType_20': '增加存款方式',
  'constants.riskLevelType_10': '存款畅通',
  'constants.riskLevelType_0': '普通',
  'constants.riskLevelType_-9': '限制领取VIP游戏返水',
  'constants.riskLevelType_-10': '限制领取优惠',
  'constants.riskLevelType_-20': '限制提款',
  'constants.riskLevelType_-30': '限制登录',
  'constants.gameType_1': '电子',
  'constants.gameType_2': '真人',
  'constants.gameType_3': '体育',
  'constants.gameType_4': '彩票',
  'constants.gameType_5': '捕鱼',
  'constants.gameType_6': '棋牌',
  'constants.gameType_9': '竞猜',
  'constants.gameType_10': '电竞',
  'constants.nav_0': '首页',
  'constants.nav_1': '真人',
  'constants.nav_2': '体育',
  'constants.nav_3': '电子',
  'constants.nav_4': '棋牌',
  'constants.nav_5': '捕鱼',
  'constants.nav_6': '彩票',
  'constants.nav_7': '钻石俱乐部',
  'constants.nav_8': '优惠',
  'constants.nav_9': '优惠大厅',
  'constants.nav_10': '其他',
  'constants.transferType_0': '后台扣除',//新加的后台扣除
  'constants.transferType_1': '后台增减',//原 后台增减
  'constants.transferType_2': '存款',
  'constants.transferType_3': '提现',
  'constants.transferType_4': '转入游戏',
  'constants.transferType_5': '从游戏转出',
  'constants.transferType_6': '冻结',
  'constants.transferType_7': '解冻',
  'constants.transferType_8': '优惠/救援等',
  'constants.transferType_9': '人工存入',
  'constants.transferType_10': '人工取出',
  'constants.transferType_14': '指定域名邀请奖励',
  'constants.transferType_15': '人人代返水奖励',
  'constants.transferType_17': '人人代邀请奖励',
  'constants.transferType_16': '上级代理手动转入',
  'constants.regSourceType_0': '自己注册',
  'constants.regSourceType_1': '代理',
  'constants.regSourceType_2': '广告',
  'constants.regSourceType_3': '电销',
  'constants.regSourceType_4': '邀请',
  'constants.gameSlot_NEWBBIN': '新 BBIN 电子',
  'constants.gameSlot_BBIN': 'BBIN',
  'constants.gameSlot_NEWPT': '新 PT 电子',
  'constants.gameSlot_NEWSA': '新 SA 电子',
  'constants.gameSlot_PT': 'PT',
  'constants.gameSlot_MG': 'MG',
  'constants.gameSlot_HB': 'HB',
  'constants.gameSlot_JDB': 'JDB',
  'constants.gameSlot_DT': 'DT',
  'constants.gameSlot_VT': 'VT 路虎',
  'constants.gameSlot_PNG': 'Play\'n GO',
  'constants.gameSlot_AMEBA': 'AMEBA',
  'constants.gameSlot_SKYWIND': 'Skywind',
  'constants.gameSlot_CQ9': 'CQ9',
  'constants.gameSlot_GNS': 'GNS',
  'constants.gameSlot_GSS': 'GSS',
  'constants.gameSlot_AB': '欧博',
  'constants.gameSlot_REDTIGER': '红虎',
  'constants.gameSlot_SA': 'SA',
  'constants.gameSlot_NETENT': 'NetEnt',
  'constants.gameSlot_BETSOFT': 'BetSoft',
  'constants.gameSlot_PLAYSTAR': 'PlayStar 电子',
  'constants.gameSlot_SG': 'SG 电子',
  'constants.gameSlot_RTG': 'RTG 电子',
  'constants.gameSlot_QT': 'QT 电子',
  'constants.gameSlot_PGSOFT': 'PGSOFT 电子',
  'constants.gameSlot1_PG': 'PGSOFT 电子',
  'constants.gameSlot_LG': 'LG电子',
  'constants.gameSlot_ISOFTBET': 'IsoFtBet电子',
  'constants.gameSlot_KingMaker': 'KM电子',
  'constants.gameSlot_CG': 'CG电子',
  'constants.gameSlot_CRG': 'CRG电子',
  'constants.gameSlot_PP': 'PP电子',
  'constants.gameSlot_SEA': 'SEA电子',
  'constants.gameSlot_FC': 'FC',
  'constants.gameSlot_YESBINGO': 'YESBINGO',
  'constants.gameSlot_SPRIBE': 'SPRIBE',
  'constants.gameSlot_BNG': 'BNG',
  'constants.gameSlot_MW': 'MW',
  'constants.gameSlot_WG': 'WG',
  'constants.gameSlot_PCLASSICG': 'PCLASSICG',
  'constants.gameSlot1_MW': 'MW',
  'constants.vipValidType_0': '永久',
  'constants.vipValidType_1': '立即生效，30天',
  'constants.vipValidType_3': '立即生效，365天',
  'constants.vipValidType_5': '立即生效，60天',
  'constants.vipValidType_6': '立即生效，90天',
  'constants.status_0': '已禁用',
  'constants.status_1': '已启用',
  'constants.bonusType_1': '流水优惠',
  'constants.bonusType_2': '存款优惠',
  'constants.bonusType_3': '邀请优惠',
  'constants.bonusType_4': '签到优惠',
  'constants.bonusType_5': '人工审核优惠',
  'constants.bonusType_6': '连续存款优惠',
  'constants.bonusType_7': '注册优惠',
  'constants.bonusType_8': '存款渠道优惠',
  'constants.bonusType_9': '注单优惠',
  'constants.bonusType_10': '投注优惠',
  'constants.bonusType_11': 'VIP游戏返水优惠',
  'constants.bonusType_12': '实时存款优惠',
  'constants.bonusType_13': '信息绑定优惠',
  'constants.bonusType_14': '派彩优惠',
  'constants.bonusType_15': '签到积分优惠',
  'constants.bonusType_16': '连续存投优惠',
  'constants.bonusType_17': '投注升级优惠',
  'constants.bonusType_19': '日常任务优惠',
  'constants.bonusType_21': '新签到优惠',
  'constants.bonusType_23': 'VIP存款优惠',
  'constants.bonusType_24': '新邀请优惠',
  'constants.bonusType_26': '对暗号优惠',
  'constants.bonusType_28': '首次提款优惠',
  'constants.bonusType_30': '大转盘优惠',
  'constants.bonusType_31': '累计存投优惠',
  'constants.bonusType_32': '游戏笔笔存',
  'constants.bonusType_33': '提款渠道优惠',
  'constants.bonusType_34': '七天存款优惠',
  'constants.bonusType_38': '充值页面优惠',

  'constants.newBonusType_1': '流水优惠',
  'constants.newBonusType_2': '存款优惠',
  'constants.newBonusType_3': '邀请优惠',
  'constants.newBonusType_5': '人工审核优惠',
  'constants.newBonusType_7': '注册优惠',
  'constants.newBonusType_8': '存款渠道优惠',
  'constants.newBonusType_9': '注单优惠',
  'constants.newBonusType_10': '投注优惠',
  'constants.newBonusType_11': 'VIP游戏返水优惠',
  'constants.newBonusType_12': '实时存款优惠',
  'constants.newBonusType_13': '信息绑定优惠',
  'constants.newBonusType_14': '派彩优惠',
  'constants.newBonusType_15': '签到积分优惠',
  'constants.newBonusType_16': '连续存投优惠',
  'constants.newBonusType_19': '日常任务优惠',
  'constants.newBonusType_21': '新签到积分优惠',
  'constants.newBonusType_24': '新邀请优惠',
  'constants.newBonusType_26': '对暗号优惠',
  'constants.newBonusType_28': '首次提款优惠',
  'constants.newBonusType_30': '大转盘优惠',
  'constants.newBonusType_31': '累计存投优惠',
  'constants.newBonusType_32': '游戏笔笔存',
  'constants.newBonusType_33': '提款渠道优惠',
  'constants.newBonusType_34': '七天存款优惠',
  'constants.newBonusType_38': '充值页面优惠',
  'constants.bonusMainType_A': '救援金',
  'constants.bonusMainType_B': '升级奖金',
  'constants.bonusMainType_C': '蝉联奖金',
  'constants.bonusMainType_D': '存款要求',
  'constants.bonusMainType_E': '周俸禄',
  'constants.bonusMainType_F': '月俸禄',
  'constants.bonusMainType_G': '生日奖金',
  'constants.bonusMainType_0': '后台添加优惠',
  'constants.bonusMainType_1': '流水优惠',
  'constants.bonusMainType_2': '存款优惠',
  'constants.bonusMainType_3': '邀请优惠',
  'constants.bonusMainType_4': '签到优惠',
  'constants.bonusMainType_5': '人工审核优惠',
  'constants.bonusMainType_6': '连续存款优惠',
  'constants.bonusMainType_7': '注册优惠',
  'constants.bonusMainType_8': '存款渠道优惠',
  'constants.bonusMainType_9': '注单优惠',
  'constants.bonusMainType_10': '投注优惠',
  'constants.bonusMainType_11': 'VIP游戏返水优惠',
  'constants.bonusMainType_12': '实时存款优惠',
  'constants.bonusMainType_13': '信息绑定优惠',
  'constants.bonusMainType_14': '派彩优惠',
  'constants.bonusMainType_15': '签到积分优惠',
  'constants.bonusMainType_16': '连续存投优惠',
  'constants.bonusMainType_18': '小游戏抽奖',
  'constants.bonusMainType_19': '日常任务优惠',
  'constants.bonusMainType_21': '新签到积分优惠',
  'constants.bonusMainType_24': '新邀请优惠',
  'constants.bonusMainType_26': '对暗号优惠',
  'constants.bonusMainType_28': '首次提款优惠',
  'constants.bonusMainType_30': '大转盘优惠',
  'constants.bonusMainType_31': '累计存投优惠',
  'constants.bonusMainType_32': '游戏笔笔存',
  'constants.bonusMainType_33': '提款渠道优惠',
  'constants.bonusMainType_34': '七天存款优惠',
  'constants.bonusMainType_38': '充值页面优惠',
  'constants.bonusMainType_35': '邀请成就',
  'constants.bonusMainType_36': '投注反水',
  'constants.bonusMainType_37': '受邀人奖励',
  'constants.newBonusMainType_A': '救援金',
  'constants.newBonusMainType_B': '升级奖金',
  'constants.newBonusMainType_C': '蝉联奖金',
  'constants.newBonusMainType_E': '周俸禄',
  'constants.newBonusMainType_F': '月俸禄',
  'constants.newBonusMainType_G': '生日奖金',
  'constants.newBonusMainType_0': '后台添加优惠',
  'constants.newBonusMainType_1': '流水优惠',
  'constants.newBonusMainType_2': '存款优惠',
  'constants.newBonusMainType_3': '邀请优惠',
  'constants.newBonusMainType_5': '人工审核优惠',
  'constants.newBonusMainType_7': '注册优惠',
  'constants.newBonusMainType_8': '存款渠道优惠',
  'constants.newBonusMainType_9': '注单优惠',
  'constants.newBonusMainType_10': '投注优惠',
  'constants.newBonusMainType_11': 'VIP游戏返水优惠',
  'constants.newBonusMainType_12': '实时存款优惠',
  'constants.newBonusMainType_13': '信息绑定优惠',
  'constants.newBonusMainType_14': '派彩优惠',
  'constants.newBonusMainType_15': '签到积分优惠',
  'constants.newBonusMainType_16': '连续存投优惠',
  'constants.newBonusMainType_17': '投注升级优惠',
  'constants.newBonusMainType_18': '小游戏抽奖',
  'constants.newBonusMainType_19': '日常任务优惠',
  'constants.newBonusMainType_21': '新签到积分优惠',
  'constants.newBonusMainType_24': '新邀请优惠',
  'constants.newBonusMainType_26': '对暗号优惠',
  'constants.newBonusMainType_28': '首次提款优惠',
  'constants.newBonusMainType_29': '复活优惠',
  'constants.newBonusMainType_30': '大转盘优惠',
  'constants.newBonusMainType_31': '累计存投优惠',
  'constants.newBonusMainType_32': '游戏笔笔存',
  'constants.newBonusMainType_33': '提款渠道优惠',
  'constants.newBonusMainType_34': '七天存款优惠',
  'constants.newBonusMainType_38': '充值页面优惠',

  'constants.bonusStatus_0': '申请中',
  'constants.bonusStatus_1': '计算中',
  'constants.bonusStatus_2': '已完成',
  'constants.bonusStatus_3': '拒绝',
  'constants.bonusStatus_4': '失败',
  'constants.bonusStatus_5': '未领取',
  'constants.bonusStatus_6': '未抽中',
  'constants.ticketStatus_0': '已提交',
  'constants.ticketStatus_1': '处理中',
  'constants.ticketStatus_2': '处理完成',
  'constants.bonusConfigStatus_0': '编辑中',
  'constants.gameMaintain_0': '未维护',
  'constants.gameMaintain_1': '维护中',
  'constants.payLevel_0': '仅一级会员可用',
  'constants.payLevel_1': '全部会员',
  'constants.payLevel_2': '二级及以上会员',
  'constants.payLevel_3': '三级及以上会员',
  'constants.payLevel_4': '四级及以上会员',
  'constants.payLevel_5': '五级及以上会员',
  'constants.payLevel_6': '六级及以上会员',
  'constants.payLevel_7': '七级及以上会员',
  'constants.payLevel_8': '八级及以上会员',
  'constants.payLevel_9': '九级及以上会员',
  'constants.payLevel_10': '十级及以上会员',
  'constants.payLevel_11': '十一级及以上会员',
  'constants.payLevel_12': '十二级及以上会员',
  'constants.payLevel_13': '十三级及以上会员',
  'constants.payLevel_14': '十四级及以上会员',
  'constants.payLevel_15': '十五级及以上会员',
  'constants.payLevel_16': '十六级及以上会员',
  'constants.payLevel_17': '十七级及以上会员',
  'constants.payLevel_18': '十八级及以上会员',
  'constants.payLevel_19': '十九级会员',
  'constants.logType_ad': '广告',
  'constants.logType_admin': '后台账号',
  'constants.logType_agent': '代理',
  'constants.logType_bonus': '优惠',
  'constants.logType_button': '按钮',
  'constants.logType_config': '系统配置参数',
  'constants.logType_custom': '工单信息',
  'constants.logType_domain': '域名',
  'constants.logType_platform': '游戏平台',
  'constants.logType_ip': 'IP',
  'constants.logType_market': '电销',
  'constants.logType_menu': '菜单',
  'constants.logType_notify': '通知',
  'constants.logType_pay': '支付',
  'constants.logType_risk': '风控',
  'constants.logType_role': '角色',
  'constants.logType_withdraw': '提现',
  'constants.logType_user': '用户',
  'constants.logType_picture': '图片配置',
  'constants.logType_announcement': '公告',
  'constants.logType_login': '后台登录',
  'constants.logType_logout': '后台退出',
  'constants.agentOtherType_0': '退款',
  'constants.agentOtherType_1': '市场费用',
  'constants.sysAdminType_-1': '超级管理员',
  'constants.sysAdminType_-2': '管理员',
  'constants.activityType_1': '幸运大转盘',
  'constants.activityType_2': '摇一摇',
  'constants.activityType_3': '合成游戏',
  'constants.activityType_4': '抽盲盒',
  'constants.activityType_5': '现金大转盘游戏',
  'constants.activityChannelType_0': '系统增加',
  'constants.activityChannelType_1': '手动增加',
  'constants.activityChannelType_2': '抽奖递减',
  'constants.activityChannelType_3': '手工删除',
  'constants.prizeType_0': '现金',
  'constants.prizeType_1': '其他',
  'constants.prizeType_2': '不中奖',
  'constants.prizeType_3': '积分',
  'constants.announcementType_6': '公告',
  'constants.announcementType_7': '推荐',
  'constants.frontType_0': 'PC端',
  'constants.frontType_1': '移动端',
  'constants.frontType_3': '全平台',
  'constants.siteMsgType_0': '存取款问题',
  'constants.siteMsgType_1': '优惠活动',
  'constants.siteMsgType_2': '游戏问题',
  'constants.siteMsgType_3': '其它问题',
  'constants.siteMsgType_4': '建议',
  'constants.siteMsgType_5': '投诉',
  'constants.manualType_1': '手工调账',
  'constants.manualType_9': '人工存入',
  'constants.manualType_10': '人工取出',
  'constants.gameSlot1_BBIN': 'BBIN',
  'constants.gameSlot1_NEWBBIN': '新 BBIN 电子',
  'constants.gameSlot1_PT': 'PT',
  'constants.gameSlot1_NEWPT': '新 PT 电子',
  // 'constants.gameSlot1_MG': 'MG',
  'constants.gameSlot1_HB': 'HB',
  'constants.gameSlot1_JDB': 'JDB',
  'constants.gameSlot1_JDB2': 'JDB2',
  'constants.gameSlot1_DT': 'DT',
  'constants.gameSlot1_VT': 'VT 路虎',
  'constants.gameSlot1_PNG': 'Play\'n GO',
  'constants.gameSlot1_AMEBA': 'AMEBA',
  'constants.gameSlot1_TP': 'TP',
  'constants.gameSlot1_FKJILI': 'FKJILI',
  'constants.gameSlot1_FKJILI1': 'FKJILI1',
  'constants.gameSlot1_FKPG': 'FKPG',
  'constants.gameSlot1_OMGPG': 'OMGPG',
  'constants.gameSlot1_OMGJILI': 'OMGJILI',
  'constants.gameSlot1_OMGPP': 'OMGPP',
  'constants.gameSlot1_FKPG1': 'FKPG1',
  'constants.gameSlot1_JS2PG': 'JS2PG',

  'constants.gameSlot1_GB': 'GB',
  'constants.gameSlot1_YL': 'YL',
  'constants.gameSlot1_PCLASSICG': 'PCLASSICG',
  'constants.gameSlot1_WMDZ': 'WMDZ',
  'constants.gameSlot1_NS': 'NEXTSPIN',
  'constants.gameSlot1_WM': 'WM',
  'constants.gameSlot1_KA': 'KA',
  'constants.gameSlot1_CRG': 'CRG',
  'constants.gameSlot1_FTG': 'FTG',
  'constants.gameSlot1_VA': 'VA',
  'constants.gameSlot1_ASKME': 'ASKME',
  'constants.gameSlot1_OMG': 'OMG',
  'constants.gameSlot1_VNRICH88': 'VNRICH88',
  'constants.gameSlot1_VNRTG': 'VNRTG',
  'constants.gameSlot1_JL': 'JL',
  'constants.gameSlot1_PP': 'PP',
  'constants.gameSlot1_SKYWIND': 'Skywind',
  'constants.gameSlot1_CQ9': 'CQ9',
  'constants.gameSlot1_GNS': 'GNS',
  'constants.gameSlot1_GSS': 'GSS',
  'constants.gameSlot1_AB': '欧博',
  'constants.gameSlot1_REDTIGER': '红虎',
  'constants.gameSlot1_SA': 'SA',
  'constants.gameSlot1_SA2': '新SA',
  'constants.gameSlot1_MG2': 'MG2',
  'constants.gameSlot1_MG3': 'MG3',
  'constants.gameSlot1_NETENT': 'NetEnt',
  'constants.gameSlot1_BETSOFT': 'BetSoft',
  'constants.gameSlot1_PLAYSTAR': 'PlayStar 电子',
  'constants.gameSlot1_SG': 'SG 电子',
  'constants.gameSlot1_RTG': 'RTG 电子',
  'constants.gameSlot1_QT': 'QT 电子',
  'constants.gameSlot1_PGSOFT': 'PGSOFT 电子',
  'constants.gameSlot1_LG': 'LG电子',
  'constants.gameSlot1_ISOFTBET': 'IsoFtBet电子',
  'constants.gameSlot1_TOTALEGAME': 'TOTALEGAME电子',
  'constants.gameSlot1_IGS': 'IG电子',
  'constants.gameSlot1_PT2': 'PT电子',
  'constants.gameSlot1_PT1': 'PT1电子',
  'constants.gameSlot1_GG2': 'GG电子',
  'constants.gameSlot1_FUNKY': 'FUNKY电子',
  'constants.gameSlot1_YESBINGO': 'YESBINGO',
  'constants.gameSlot1_SPRIBE': 'SPRIBE',
  'constants.gameSlot1_BNG': 'BNG',
  'constants.gameSlot1_NEWAG': 'NEWAG',
  'constants.gameSlot1_AG': 'AG',
  'constants.gameSlot1_WG': 'WG',
  'constants.gameSlot1_JILISLOT': 'JILI',
  'constants.gameSlot1_JILI': 'JILI',
  'constants.gameSlot1_PHJILISLOT': 'PHJILI',
  'constants.gameSlot1_TTG': 'TTG 电子',
  'constants.gameSlot1_OBDZ': 'OBDZ 电子',
  'constants.gameSlot1_PGO': 'Play\'n GO 电子',
  'constants.gameSlot1_RT': 'Red Tiger 电子',
  'constants.gameSlot1_PRAP': 'PRAGMATIC PLAY 电子',
  'constants.gameSlot1_PST': 'PLAYSTAR 电子',
  'constants.gameSlot1_RICH': 'Rich88 电子',
  'constants.gameSlot1_SPB': 'Spribe 街机',
  'constants.gameSlot1_PHPREDTIGER': 'RedTiger电子',
  'constants.gameSlot1_FC': 'FC',
  'constants.gameSlot1_RICH88': 'RICH 88',
  'constants.gameSlot1_FCSLOT': 'FC 电子',
  'constants.gameSlot1_SEA': 'SEA',
  'constants.gameSlot1_PHPSG': 'SG',



  'constants.gameLive2_AG': 'AG',
  'constants.gameLive2_NEWAG': '新AG',
  'constants.gameLive2_EBET': 'EBET',
  'constants.gameLive2_OG': 'OG',
  'constants.gameLive2_OG1': 'OG1',
  'constants.gameLive2_BG': 'BG',
  'constants.gameLive2_BG2': 'BG2',
  'constants.gameLive2_GD': 'GD',
  'constants.gameLive2_EG': 'EG真人',
  'constants.gameLive2_SB': '申博真人',
  'constants.gameLive2_TS': '泰山真人',
  'constants.gameLive2_DG': 'DreamGame',
  'constants.gameLive2_SEXY': 'Sexy真人',
  'constants.gameLive2_VENUS': 'Venus真人',
  'constants.gameLive2_SEXY3': 'Sexy真人3',
  'constants.gameLive2_VENUS3': 'Venus真人3',
  'constants.gameLive2_MAYE': '玛雅真人',
  'constants.gameLive2_AB': '欧博',
  'constants.gameLive2_BBIN': 'BBIN',
  'constants.gameLive2_NEWBBIN': 'NEWBBIN',
  'constants.gameLive2_SA': 'SA',
  'constants.gameLive2_TP': 'TP',
  'constants.gameLive2_GPI': 'GPI',
  'constants.gameLive2_NEWSA': '新SA',

  'constants.gameSport3_XSPORT': 'HAHA体育',
  'constants.gameSport3_AVIA': '泛亚电竞',
  'constants.gameSport3_IBC': 'IBC 沙巴体育',
  'constants.gameSport3_UG': 'UG 联合体育',
  'constants.gameSport3_UG2': 'UG 联合体育',
  'constants.gameSport3_PINGBO': '平博体育',
  'constants.gameSport3_BETLINK': '博林体育',
  'constants.gameSport3_IM': 'IM体育',
  'constants.gameSport3_IMDJ': 'IM电竞',
  'constants.gameSport3_XINBAO': 'XINBAO电竞',
  'constants.gameSport3_NEWIM': '新IM体育',
  'constants.gameSport3_IBC2': '沙巴体育',
  'constants.gameSport3_ESPORTS': 'ESports',
  'constants.gameSport3_THREESING': '3昇体育',
  'constants.gameSport3_UWIN': 'U赢 电竞',
  'constants.gameSport3_DSDJ': '东森电竞',
  'constants.gameSport3_XA': '小艾电竞',
  'constants.gameSport3_LH': '雷火电竞',
  'constants.gameSport3_FB': '速博体育',
  'constants.gameSport3_JC': '竞彩体育',
  'constants.gameSport3_CMD': 'CMD体育',
  'constants.gameSport3_BTI': 'BTI体育',
  'constants.gameSport3_AISPORT': 'AI体育',
  // 'constants.gameSport3_PM' : 'PM体育',
  'constants.gameSport3_FBTY': 'FB体育',
  'constants.gameSport3_WS168': 'WS168斗鸡',
  'constants.gameSport3_S128': 'S128斗鸡',
  'constants.gameSport3_BBIN': 'BBIN',
  'constants.gameSport3_TP': 'TP',
  'constants.gameSport3_SBO': 'SBO sports',
  'constants.gameSport3_HG': '皇冠体育',
  'constants.gameSport3_PM': 'PM体育',
  'constants.gameSport3_SBOI': 'SBOI体育',
  'constants.gameSport3_DS': 'DS88 体育',
  'constants.gameSport3_DS888': 'DS888 斗鸡',
  'constants.gameSport3_SPB': 'SPB 街机',
  'constants.gameSport3_PHSBO': 'SBO 体育',
  'constants.gameSport3_SABA': 'SABA 体育',

  'constants.gameLottery4_CQ': 'ST胜天彩票',
  'constants.gameLottery4_VR': 'VR彩票',
  'constants.gameLottery4_KG': 'KG彩票',
  'constants.gameLottery4_DSEN': '东森彩票',
  'constants.gameLottery4_TCG': 'TCG 彩票',
  'constants.gameLottery4_TCG_VN': 'TCG 彩票',
  'constants.gameLottery4_YESBINGO': 'YB 彩票',

  'constants.gameLottery4_IG_GFC': 'IG 官方彩',
  'constants.gameLottery4_GS': '本站彩票',
  'constants.gameLottery4_KK': 'KK彩票',
  'constants.gameLottery4_SPRIBE': 'SPRIBE彩票',
  'constants.gameLottery4_CG': 'CG彩票',
  'constants.gameLottery4_VL': 'VL 彩票',
  'constants.gameLottery4_AE': 'AE 彩票',
  'constants.gameFish5_GG': 'GG捕鱼',
  'constants.gameFish5_BBIN': 'BBIN',
  'constants.gameFish5_NEWBBIN': 'NEWBBIN',
  'constants.gameFish5_SA': 'SA',
  'constants.gameFish5_SA2': '新SA',
  'constants.gameFish5_AG': 'AG',
  'constants.gameFish5_NEWAG': '新AG',
  'constants.gameFish5_JILI': 'JILI',
  'constants.gameFish5_TP': 'TP',
  'constants.gameFish5_YL': 'YL',
  'constants.gameFish5_KA': 'KA',
  'constants.gameFish5_VA': 'VA',
  'constants.gameFish5_FTG': 'FTG',
  'constants.gameFish5_PLAYSTAR': 'PLAYSTAR',
  'constants.gameFish5_ASKME': 'ASKME',
  'constants.gameFish5_VNRTG': 'VNRTG',
  'constants.gameFish5_OBBY': 'OBBY',
  'constants.gameFish5_JDB2': 'JDB2',
  'constants.gameChess6_OBQP': 'DB棋牌',
  'constants.gameFish5_FC': 'FC',
  'constants.gameFish5_YESBINGO': 'YESBINGO',
  'constants.gameFish5_LUCKY': 'Lucky',
  'constants.gameFish5_PHPSG': 'SG',
  'constants.gameFish5_WG': 'WG',

  'constants.gameFish5_ACE': 'ACE 捕鱼',
  'constants.gameFish5_SGFISH': 'SG 捕鱼',
  'constants.gameFish5_JDB': 'JDB',
  'constants.gameFish5_PHJILI': 'PHJILI',
  'constants.gameChess6_PHJILI': 'JILI',
  'constants.gameChess6_WG': 'WG',
  'constants.gameChess6_KY': '开元棋牌',
  'constants.gameChess6_LUCKY': '幸运棋牌',
  'constants.gameChess6_V8': 'V8棋牌',
  'constants.gameChess6_LY': 'LY棋牌',
  'constants.gameChess6_YL': 'YL棋牌',
  'constants.gameChess6_KM': 'KM棋牌',
  'constants.gameChess6_TP': 'TP',
  'constants.gameChess6_VNRICH88': 'VNRICH88',
  'constants.gameChess6_FTG': 'FTG',
  'constants.gameChess6_KINGMAKER_CHESS': 'KINGMAKER 棋牌',
  'constants.gameChess6_VG': 'VG棋牌',
  'constants.gameChess6_SSO761': 'AP棋牌',
  'constants.gameChess6_LEG': '乐游棋牌',
  'constants.gameChess6_CS': '财神棋牌',
  'constants.gameChess6_GAMMA': '加玛棋牌',
  'constants.gameChess6_HT': '黑桃棋牌',
  'constants.gameChess6_TM': '天美棋牌',
  'constants.gameChess6_LC': '凯旋棋牌',
  'constants.gameChess6_JILI': 'JILI',
  'constants.gameChess6_PHKM': 'KM 棋牌',

  'constants.platforms_BBIN': 'BBIN',
  'constants.platforms_NEWBBIN': 'NEWBBIN',
  'constants.platforms_SA': 'SA',
  'constants.platforms_SA2': '新SA',
  'constants.platforms_NEWSA': '新SA',
  'constants.platforms_AG': 'AG',
  'constants.platforms_NEWAG': '新AG',
  'constants.signType_0': '热门',
  'constants.signType_1': '活动',
  'constants.signType_2': '大奖',
  'constants.gameSignType_0': '热门',
  'constants.gameSignType_1': '电子',
  'constants.gameSignType_2': '真人',
  'constants.gameSignType_3': '体育',
  'constants.gameSignType_4': '彩票',
  'constants.gameSignType_5': '捕鱼',
  'constants.gameSignType_6': '棋牌',
  'constants.gameSignType_9': '竞猜',
  'constants.gameSignType_10': '电竞',

  'gift.title.name': '礼物名称',
  'gift.title.nickName': '送礼人',
  'gift.title.roomName': '收礼人',
  'gift.title.giftNumber': '消耗（元）',
  'gift.title.giftPrice': '收获（元）',
  'gift.title.presentTime': '日期',
  'gift.title.show.account': '主播账号',
  'gift.title.show.startDate': '开播时间',
  'gift.title.show.stopDate': '停止时间',
  'gift.title.show.longtine': '直播时长',
  'gift.title.show.lookNum': '观看人数',

  'user.searchUser': '搜索到用户，用户名: {userAccount}',
  'user.searchUserFail': '搜索不到用户',
  'user.logout': '退出登录',
  'user.changePass': '修改密码',
  'user.title.message': '消息',
  'user.empty.message': '您已读完所有消息',
  'user.icon.online': ' 在线',
  'user.button.confirm': ' 确认',
  'user.form.oldPass': '请输入旧密码',
  'user.form.newPass': '请输入新密码',
  'user.form.newPassAgain': '请再次输入新密码',
  'msg.clear': '清空',
  'msg.allRead': '全部已读',
  'msg.closeBeep': '关闭提示音',
  'msg.openBeep': '开启提示音',
  'bet.title.platformCode': '平台编号',
  'bet.title.betAmount': '下注金额',
  'bet.title.betflow': '有效金额',
  'common.title.resultAmount': '平台盈利',
  'bet.title.betTime': '下注时间',
  'bet.title.createTime': '结算时间',
  'pay.label.pageAmount': '本页金额',
  'pay.label.pageUnTotal': '本页申请中提现订单数',
  'pay.label.pageRiskSuccess': '本页风控审核过提现订单数',
  'pay.label.pageSuccess': '本页出款成功提现订单数',
  'pay.label.pageRefuse': '本页已拒绝提现订单数',
  'pay.label.amount': '总金额',
  'pay.label.differenceAmount': '剩余金额',
  'pay.label.unTotal': '总申请中提现订单数',
  'pay.label.riskSuccessTotal': '总风控审核过提现订单数',
  'pay.label.successTotal': '总出款成功提现订单数',
  'pay.label.refuseTotal': '总已拒绝提现订单数',
  'bet.label.pageBet': '本页下注额(元)',
  'bet.label.pageBetVN': '本页下注额(VND)',
  'bet.label.pageFlow': '本页有效投注(元)',
  'bet.label.pageFlowVN': '本页有效投注(VND)',
  'bet.label.pageProfit': '本页平台盈利(元)',
  'bet.label.pageProfitVN': '本页平台盈利(VND)',
  'bet.label.totalBet': '总下注额(元)',
  'bet.label.totalBetVN': '总下注额(VND)',
  'bet.label.totalFlow': '总有效投注(元)',
  'bet.label.totalFlowVN': '总有效投注(VND)',
  'bet.label.totalProfit': '总平台盈利(元)',
  'bet.label.totalProfitVN': '总平台盈利(VND)',
  'bet.strAttr1.game': '游戏',
  'bet.strAttr1.platType': '玩法',
  'bet.strAttr1.period': '局号',
  'bet.strAttr1.titleNumber': '桌号',
  'bet.strAttr1.result': '结果',
  'game.platform.order': '平台单号：{gsId}',
  'game.platform.order2': '竞猜期数：{gsId}',
  'game.game.order': '游戏单号：{bizNo}',
  'game.game.order2': '注单编号：{bizNo}',
  'bet.export.exportName': '投注记录导出',
  'bet.export.title': '导出提示',
  'bet.export.content': '导出任务已经进入导出队列，点击确定查看导出进度,也可稍后通过 控制台->数据导出 查看下载',
  'bet.queryFrm.betDate': '下注时间',
  'bet.queryFrm.createDate': '结算时间',
  'bet.queryFrm.platformCode': '游戏平台',
  'bet.queryFrm.gameType': '游戏类型',
  'bet.select.gameType': '请选择游戏类型',
  'user.chart.memberCount': '会员数(人)',
  'user.chart.memberCount1': '用户数(人)',
  'user.title.activeUser': '活跃用户',
  'user.title.peopleNumber': '人数',
  'user.title.register': '注册',
  'common.chart.orderCount': '单量(千笔)',
  'common.chart.orderCount1': '单量',
  'common.chart.betOrderCount': '投注单量',
  'common.chart.date': '日期',
  'common.chart.date1': '请选择日期',
  'common.chart.percentage': '百分比',
  'common.chart.user': '用户',
  'common.chart.count': '数量',
  'common.chart.amount': '金额(万元)',
  'common.chart.amount1': '金额',
  'common.chart.amount3': '金额(元)',
  'common.chart.amount3VN': '金额(元)',
  'common.chart.validBet': '有效投注',
  'common.chart.amount2': '金额(千元)',
  'bet.chart.bettingSettlement': '投注结算',
  'finance.title.prompt': '提示',
  'finance.content.prompt': '是否改为计入存提?',
  'finance.content.prompt2': '是否改为不计入存提?',
  'bet.title.userAccount': '会员名',
  'bet.title.ticketNumber': '投注单号',
  'finance.title.transNoAndTransName': '订单号/名称',
  'finance.title.transName': '名称：{transDetail}',
  'finance.title.transType': '调账类型',
  'finance.title.amount': '调账金额',
  'finance.title.transType1': '方式',
  'finance.title.transType1_1': '未计入',
  'finance.title.transType1_9': '计入存款',
  'finance.title.transType1_10': '计入取款',
  'finance.title.afterAmount': '之后余额',
  'finance.title.remark': '备注',
  'finance.title.remark1': '请输入备注',
  'finance.title.createTimeAndCreateAdmin': '调账人/调账时间',
  'finance.title.updateTimeAndUpdateAdmin': '修改人/修改时间',
  'finance.title.totalAmount': '总金额',
  'finance.title.totalOrderCount': '总笔数',
  'finance.button.call': '拨打电话',
  'finance.export.name': '调账报表.xls',
  'finance.queryFrm.ManualTransferDate': '调账时间',
  'finance.queryFrm.ManualTransferType': '调账类型',
  'finance.queryFrm.TransactionType': '交易类型',
  'finance.queryFrm.urmoo': '用户名、备注、调账人、订单号、订单名称',
  'finance.queryFrm.urmoo2': '请输入备注/调账人关键字',
  'user.title.name': '姓名',
  'user.title.mobilePhone': '联系电话',
  'user.title.idNo': '身份证号',
  'user.title.regType': '来源',
  'user.title.domain': '上次登录网址',
  'user.title.registerTime': '注册日期',
  'user.title.createTime': '在线时间',
  'user.title.level': '等级|风控等级',
  'user.title.totalDeposit': '总存款',
  'user.title.totalWithdraw': '总提款',
  'user.title.totalBonus': '总优惠',
  'user.title.balance': '主账户总余额',
  'user.description.totalUserNum': '在线人数',
  'user.description.totalDeposit': '当前在线会员总存款',
  'user.description.totalWithdraw': '当前在线会员总提款',
  'user.description.totalBonus': '当前在线会员总优惠',
  'user.description.totalBetFlow': '当前在线会员总流水',
  'user.radio.onlineUserType_-1': '不选',
  'user.radio.onlineUserType_1': '总存款',
  'user.radio.onlineUserType_2': '总提款',
  'user.radio.onlineUserType_3': '总优惠',
  'user.radio.onlineUserType_4': '当前余额',
  'user.select.channelType_1': '不选',
  'user.select.channelType_0': '总存款',
  'user.select.channelType_4': '总提款',
  'user.select.channelType_2': '总优惠',
  'user.select.channelType_3': '当前余额',
  'sys.title.createTime': '操作时间',
  'sys.title.createAdmin': '操作人',
  'sys.title.beingAdmin': '被操作人',
  'sys.title.operatingMsg': '操作说明',
  'sys.title.resultMsg': '结果说明',
  'sys.title.logType': '日志类型',
  'sys.title.operatingStatus': '操作状态',
  'sys.title.operatingStatusFail': '失败',
  'sys.title.operatingStatusSuccess': '成功',
  'bonus.title.newNumber': '新用户',
  'bonus.title.oldNumber': '老用户',
  'bonus.title.oldUserRatio': '老用户占比',
  // 'bonus.label.repeatTimeEveryDay':'每日可申请次数',
  // 'bonus.label.repeatTimeEveryDayMsg':'请填写每日可申请次数',
  'analyze.card.cumulativeUser': '累积用户',
  'analyze.card.last7dayActiveUser': '过去7天活跃用户',
  'analyze.card.last30dayActiveUser': '过去30天活跃用户',
  'analyze.card.moreWaitting': '敬请期待',
  'analyze.card.cumulativePayingUser': '累积付费用户',
  'analyze.card.cumulativePaymentAmount': '累积付费金额',
  'analyze.card.paymentRate': '付费率',
  'analyze.card.userComposition': '用户构成',
  'analyze.card.activeUserComposition': '活跃用户构成',
  'analyze.card.newUsers': '新增用户',
  'analyze.card.firstDepositUsers': '首存用户',
  'analyze.card.withdrawalUsers': '取款用户',
  'analyze.card.depositUsers': '存款用户',
  'analyze.card.depositUsersDistinct': '存款用户(去重)',
  'analyze.card.activeUser': '活跃用户',
  'analyze.card.depositBet': '总存投用户',
  'analyze.card.depositBetInfo': '统计首存会员和当天有效投注行为的会员，加一起后再去重',
  'analyze.card.activeUserDistinct': '活跃用户(去重)',
  'analyze.card.userRecharge': '用户充值',
  'analyze.card.top-upUser': '充值用户',
  'analyze.card.depositAmount': '充值金额',
  'analyze.card.rechargeRate': '充值率',
  'analyze.card.firstDepositAmount': '首充金额',
  'analyze.card.totalDeposit': '存款总额',
  'analyze.card.totalWithdrawal': '取款总额',
  'analyze.card.offerDiscount': '发放优惠',
  'analyze.card.platformFlow': '平台流水',
  'analyze.card.platformFlow1': '平台流水(元)',
  'analyze.card.platformFlow1VN': '平台流水(VND)',
  'analyze.card.betUserCount': '投注人数(按平台)',
  'analyze.card.betUserCount1': '投注人数',
  'analyze.card.orderCount': '注单数量',
  'finance.title.firstDeposit': '首存',
  'finance.title.totalDeposit': '总存',
  'finance.title.totalWithdraw': '总取',
  'finance.title.totalBetflow': '总流水',
  'finance.title.totalWin': '存提差',
  'finance.title.profitLoss': '损益',
  'pay.platformName': '支付平台',
  'pay.orderAmount': '订单金额',
  'pay.orderCount': '订单金额',
  'pay.platformNameOrderAmount': '支付平台*订单金额',
  'pay.platformNameOrderCount': '支付平台*订单金额',
  'pay.title.amountStatistics': '支付平台交易金额统计',
  'pay.title.countStatistics': '支付平台交易笔数统计',
  'pay.title.successChannelRate': '各渠道支付成功率',
  'pay.title.usageRatio': '支付平台使用占比',
  'pay.title.successRatio': '支付平台成功占比',
  'pay.title.payName': '三方名称',
  'pay.title.successCount': '成功笔数',
  'pay.title.successAmount': '成功金额',
  'pay.title.orderCount': '总笔数',
  'pay.title.amountSummary': '总金额',
  'pay.title.successRate': '成功率',
  'pay.title.pageSuccessCount': '本页成功笔数',
  'pay.title.pageSuccessAmount': '本页成功金额',
  'pay.title.pageOrderCount': '本页总笔数',
  'pay.title.pageAmountSummary': '本页总金额',
  'pay.title.pageSuccessRate': '本页成功率',
  'pay.export.payExcel': '支付成功率报表.xls',
  'pay.label.settlementDate': '结算日期',
  'pay.label.allChannel': '全部渠道',
  'pay.label.allPayType': '全部支付类型',
  'pay.label.payChannel': '支付渠道',
  'pay.label.payChannel1': '请选择支付渠道',
  'pay.label.payType': '支付类型',
  'pay.label.payType1': '请选择支付类型',
  'pay.label.useLevel': '使用等级',
  'pay.label.useLevel1': '请选择使用等级',
  'pay.label.useLevelAbove': 'vip等级需达',
  'pay.label.depositMin': '最小金额',
  'pay.label.depositMin1': '请输入最小金额',
  'pay.label.depositMax': '最大金额',
  'pay.label.depositMax1': '请输入最大金额',
  'pay.label.depositAmountNotice': '请输入合法金额数字',
  'pay.label.depositRequest': '充值要求',
  'pay.label.depositRequest1': '请输入充值要求',
  'pay.label.param': '参数',
  'pay.label.orderSort': '排列顺序',
  'pay.label.orderSort1': '请输入合法顺序',
  'pay.label.deviceType': '平台类型',
  'pay.label.writeUserName': '填写付款人姓名',
  'pay.label.deviceType1': '请选择平台类型',
  'pay.label.amountType': '金额类型',
  'pay.label.amountType1': '请选择金额类型',
  'pay.label.exchangeType': '请选择汇率类型',
  'pay.label.amountType_1': '用户输入金额',
  'pay.label.amountType_2': '固定金额列表',
  'pay.label.amountType_3': '两者都支持',
  'pay.label.fixedAmountList': '固定金额',
  'pay.label.fixedAmountList1': '请输入固定金额',
  'pay.label.fixedAmountList2': '最多输入200个字符固定金额',
  'pay.label.fixedAmountList3': '请输入固定金额,多金额请用\',\'号分割',
  'pay.label.cardNumber': '银行账号',
  'pay.label.cardOwner': '持卡人姓名',
  'pay.label.withdrawalAmount': '提款金额',
  'pay.label.withdrawalAmount1': '提款金额',
  'pay.label.withdrawType': '提款方式',
  'pay.label.withdrawInfo': '收款信息',
  'pay.withdraw.apName': '支付宝姓名',
  'pay.withdraw.apName_jk4': 'GCash姓名',
  'pay.withdraw.apAccount': '支付宝账号',
  'pay.withdraw.apAccount_jk4': 'GCash账号',
  'pay.withdraw.usdtPayCount': '支付个数',
  'pay.withdraw.cardOwner': '账户姓名',
  'pay.withdraw.bankName': '所属银行',
  'pay.withdraw.bankNumber': '卡号',
  'pay.withdraw.feeRate': '手续费率',
  'pay.title.createTime': '申请时间',
  'pay.title.riskAdmin': '风控人',
  'pay.title.riskTime': '风控时间',
  'pay.title.payAdmin': '出款人',
  'pay.title.payTime': '出款时间',
  'pay.title.refuseAdmin': '拒绝人',
  'pay.title.operateDate': '操作时间',
  'pay.label.bankName': '银行名称',
  'pay.label.bankName1': '请输入银行名称',
  'pay.label.bankName2': '最多输入25个字符',
  'pay.label.bankAccount': '收款人',
  'pay.label.bankAccount1': '请输入收款人',
  'pay.label.bankAccount2': '最多输入50个字符',
  'pay.label.bankAccount3': '最多输入100个字符',
  'pay.label.bankAccount4': '最多输入20个字符',
  'pay.label.bankAddr': '开户网点',
  'pay.label.bankAddr1': '请输入开户网点',
  'pay.label.bankNumber': '银行卡号',
  'pay.label.bankNumber1': '请输入银行卡号',
  'pay.label.qrCode': '二维码',
  'pay.label.qrCode1': '请上传二维码',
  'pay.label.payDesc': '推荐描述',
  'pay.label.payDesc1': '请输入推荐描述',
  'pay.label.payDesc3': '最多输入200个字符推荐描述',
  'pay.label.payViewName': '渠道自定义名称',
  'pay.label.payViewName1': '请输入自定义名称',
  'pay.loadConfigInfoFail': '加载支付配置信息失败',
  'pay.loadConfigInfoError': '加载支付配置信息失败error',
  'pay.title.channelName': '渠道名称',
  'pay.title.channelName1': '请输入渠道名称',
  'pay.title.channelName2': '请输入自定渠道名称',
  'analyze.title.cumulativeUsers': '累积用户(渠道总用户/平台总用户)',
  'pay.title.payCode': '渠道编号',
  'pay.title.viewName': '渠道类型',
  'pay.title.depositMin': '金额限制',
  'common.agent': '代理',
  'common.channel': '代理',
  'common.title.agentAccount': '代理账号',
  'common.title.agentCode': '代理CODE',
  'agent.h3.channelDistribution': '渠道分布',
  'finance.title.depositTime': '存款时间',
  'finance.title.depositAmount': '存款金额',
  'finance.title.depositType': '存款方式',
  'finance.title.totalDepositUsers': '总会员人数',
  'finance.title.totalDepositAmount': '总存款金额(元)',
  'finance.title.totalDepositAmountVN': '总存款金额(VND)',
  'finance.export.excel': '存款报表.xls',
  'bonus.export.excel': '优惠报表.xls',
  'bonus.title.offerTime': '优惠发放时间',
  'finance.title.bonusAmount': '优惠金额',
  'finance.title.bonusName': '优惠名称',
  'finance.title.approveAdmin': '手动添加操作人',
  'finance.title.totalUserCount': '优惠总人数',
  'finance.title.totalBonusAmount': '总优惠金额',
  'game.title.betUsers': '下注用户数',
  'game.title.betOrderCount': '下注单量',
  'game.title.betAmount': '下注额(元)',
  'game.title.betAmountVN': '下注额(VND)',
  'game.title.betAmount1': '下注额',
  'game.title.playerProfit': '玩家盈利(元)',
  'game.title.playerProfitVN': '玩家盈利(VND)',
  'game.title.playerProfit1': '玩家盈利',
  'game.title.platformProfit': '平台盈利(元)',
  'game.title.platformProfitVN': '平台盈利(VND)',
  'game.title.platformProfitLose': '平台盈亏',
  'user.title.pageBetOrderCount': '本页总投注笔数',
  'user.title.pageBetAmount': '本页总下注额',
  'user.title.pagePlayerResultAmount': '本页总玩家输赢',
  'user.title.pageBetflow': '本页总流水',
  'user.title.totalOrderCount': '总投注笔数',
  'user.title.totalResultAmount': '总玩家输赢',
  'pay.title.pageOrderAmount': '本页订单金额',
  'pay.title.pagePaidOrders': '本页已支付订单数',
  'pay.title.pageUnpaidOrders': '本页未支付订单数',
  'pay.title.pageExpiredOrders': '本页已过期订单数',
  'pay.title.totalOrderAmount': '总订单金额',
  'pay.title.totalPaidOrders': '总已支付订单数',
  'pay.title.totalUnpaidOrders': '总未支付订单数',
  'pay.title.totalExpiredOrders': '总已过期订单数',
  'game.title.pageBetUserCount': '本页下注用户数',
  'game.title.pageBetOrderCount': '本页下注单量',
  'game.title.pageBetAmount': '本页下注额(元)',
  'game.title.pageBetAmountVN': '本页下注额(VND)',
  'game.title.pagePlatformProfit': '本页平台盈利(元)',
  'game.title.pagePlatformProfitVN': '本页平台盈利(VND)',
  'game.title.totalUserCount': '总下注用户数',
  'game.title.totalOrderCount': '总下注单量',
  'game.title.totalBetAmount': '总下注额(元)',
  'game.title.totalBetAmountVN': '总下注额(VND)',
  'game.title.totalBetAmount1': '总下注额',
  'game.title.totalPlayerResultAmount11': '总玩家输赢',
  'game.title.totalPlatformProfit': '总平台盈利(元)',
  'game.title.killRate': '杀率(%)',
  'game.title.killRateFormulas': '杀率=平台盈利/下注额',
  'game.title.totalPlatformProfitVN': '总平台盈利(VND)',
  'game.title.totalPlayerResultAmount': '玩家输赢',
  'game.title.totalPlayerResultAmount1': '玩家输赢',
  'finance.title.pageDepositCount': '本页总充值次数',
  'finance.title.pageDepositAmount': '本页总存款额',
  'finance.title.pageFirstAmount': '本页首充额',
  'finance.title.totalDepositProfit': '总充值次数',
  'finance.title.totalDepositAmount2': '总存款额(元)',
  'finance.title.totalDepositAmount2VN': '总存款额(VND)',
  'finance.title.totalFirstDepositAmount': '总首充额(元)',
  'finance.title.totalFirstDepositAmountVN': '总首充额(VND)',
  'game.export.platformExcel': '游戏平台报表.xlsx',
  'game.title.platformName': '平台名称',
  'game.title.platformName1': '请输入平台名称',
  'common.title.dataDetail': '数据详情',
  'finance.title.withdrawalTime': '取款时间',
  'finance.title.withdrawalAmount': '取款金额',
  'finance.title.withdrawalType': '取款方式',
  'finance.title.withdrawalType2': '提现方式',
  'finance.title.totalWithdrawUsers': '总提款会员数',
  'finance.title.totalWithdrawAmount': '总提款金额',
  'finance.export.withdrawalExcel': '取款报表.xls',
  'finance.export.userDepositExcel': '用户充值报表.xls',
  'user.export.userGameExcel': '用户游戏报表.xlsx',
  'activity.export.excel': '小游戏抽奖记录.xls',
  'common.title.type': '类型',
  'common.title.type1': '实名认证',
  'common.title.type2': '手机短信',
  'common.title.type3': '是否有实名',
  'quick3.betManage.xls': '快三注单管理.xls',

  'activity.batch.userAccount': '会员账号',
  'activity.batch.count': '次数',
  'activity.batch.days': '有效天数',
  'activity.batch.status': '导入状态',
  'activity.batch': '批量添加',
  'activity.batchDetail': '批量导入详情',
  'menu.activityBatch': '批量添加',
  'activity.batch.desc1': '1.会员账号;',
  'activity.batch.desc2': '2.添加次数;',
  'activity.batch.desc3': '3.有效天数;',



  'msg.title.certificationTime': '认证时间',
  'msg.title.period': '时间段',
  'game.title.gameName': '游戏名称',
  'bet.title.betFlowId': '流水号',
  'bet.title.rawData': '原始数据(游戏平台时间)',
  'finance.title.depositCount': '充值次数',
  'finance.title.totalDepositAmount1': '总充值金额',
  'finance.title.firstDepositTime': '首充时间',
  'finance.title.lastDepositTime': '最后充值时间',
  'finance.text.addBlacklist': '渠道黑名单',
  'finance.title.disablePaymentChannels': '禁用支付渠道',
  'finance.label.selectDisablePaymentChannels': '选择禁用支付渠道',
  'user.title.lastLoginTime': '上次登入时间',
  'user.title.userLevel': '用户等级',
  'user.title.riskLevel': '风险等级',
  'user.title.registerIP': '注册IP',
  'user.title.registerAddress': '注册地址',
  'user.title.registerType': '注册类型',
  'user.title.ipType': '来源属性',
  'analyze.title.statisticalDate': '统计日期',
  'user.title.betOrderCount': '投注笔数',
  'user.title.betAmount': '投注金额',
  'user.title.dataOverview': '数据概览',
  'user.title.displayNumber': '显示数字',
  'user.title.displayLiveData': '只显示电竞竞猜数据',
  'sys.title.exportName': '名称',
  'sys.title.exportName1': '请输入正确的名称',
  'sys.title.nodeNumber': '节点编号',
  'sys.title.exportStatus': '导出状态',
  'sys.title.exportStatus0': '等待导出',
  'sys.title.exportStatus1': '完成',
  'sys.title.exportStatus2': '失败',
  'sys.title.exportStatus3': '正在导出',
  'sys.title.exportStatus4': '下载已过期',
  'sys.title.finishTime': '完成时间',
  'sys.title.nameAndNumber': '名称/编号',
  'sys.title.confirmDelete': '确认删除',
  'sys.title.deletePicGroup': '即将删除图片组配置：{imgCode}',
  'sys.title.deleteButton': '即将删除的按钮：{btnName}',
  'sys.title.deleteConfig': '即将删除的配置：{configKey}',
  'sys.title.deleteMenuName': '即将删除的菜单：{menuName}',
  'sys.title.deleteNotifyName': '即将删除的通知类型：{notifyName}',
  'sys.title.deleteBeforeDisable': '为防止出错，请先禁用后再删除！',
  'sys.title.addGroupConfig': '添加组配置',
  'sys.title.repeatGroup': '添加组配置',
  'sys.title.imgCode': '图片组Code',
  'sys.title.imgCode1': '图片组Code: ',
  'sys.title.imgCode2': '请输入图片组Code',
  'sys.title.imgName': '图片组名称',
  'sys.title.imgName1': '图片组名称: ',
  'sys.title.imgName2': '请输入图片组名称',
  'sys.title.remark': '描述',
  'sys.title.remark1': '描述: ',
  'sys.title.remark2': '图片组描述',
  'sys.title.maxAmount': '最大可传图片数',
  'sys.title.maxAmount1': '最大可传图片数量: ',
  'sys.title.maxAmount2': '最大可传图片数量',
  'sys.enter.user.upgrade.level': '升级模式等级',
  'sys.enter.user.upgrade.mode': '升级模式',
  'sys.enter.user.upgrade.updfail': '升级模式修改失败',
  'sys.enter.user.upgrade.updsucc': '升级模式修改成功',
  'user.title.submit': '是否提交',
  'user.title.confirmSubmit': '请仔细核对信息是否正确，是否提交',
  'user.title.notSamePass': '密码不一致，请确认',
  'user.title.wrongPassNotice': '只能以小写字母开头，只含有小写字母和数字',
  'user.title.existUser': '用户已存在',
  'user.title.addBackAccount': '添加后台账号',
  'user.title.minUserNameLength': '请输入少于6个字符的用户名',
  'user.title.maxUserNameLength': '请输入最多25个字符的用户名',
  'user.title.userNameLengthLimit': '请输入登录用户名，6-25个字符',
  'user.title.name1': '请输入姓名',
  'user.title.name2': '请输入正确的姓名',
  'user.title.pass': '密码',
  'user.title.pass1': '请输入登录用密码,留空不修改',
  'user.title.pass2': '请输入密码',
  'user.title.pass3': '请输入登录用密码',
  'user.title.pass4': '确认密码',
  'user.title.pass5': '请再次输入登录用密码',
  'user.title.pass6': '请确认密码',
  'user.title.mail': '邮箱',
  'user.title.mail1': '请输入正确的邮箱',
  'user.title.mail2': '请输入邮箱',
  'user.title.phone': '手机',
  'user.title.phone1': '请输入正确的手机号码',
  'user.title.phone2': '请输入手机号码',
  'user.title.role': '角色',
  'user.title.role1': '请选择角色',
  'user.title.status': '状态',
  'user.title.status1': '请选择状态',
  'user.title.goBack': '返回',
  'user.title.submit1': '提交',
  'user.title.name3': '名字',
  'user.title.isOnline': '是否在线',
  'user.title.online': '在线',
  'user.title.offline': '离线',
  'user.title.forceOffline': '强制离线',
  'sys.button.cleanCache': '清除本机缓存',
  'user.title.channel': '渠道',
  'user.button.addAccount': '添加账号',
  'user.button.addButton': '添加按钮',
  'user.button.addConfig': '添加配置',
  'sys.button.addLeafMenu': '添加子菜单',
  'sys.button.addParam': '添加参数',
  'sys.button.addTopMenu': '添加顶级菜单',
  'sys.button.addNotifyType': '添加通知类型',
  'sys.button.addExternalChain': '添加外链支付',
  'user.disableNotice': '确认要禁用该后台账号吗？',
  'user.enableNotice': '确认要启用该后台账号吗？',
  'user.title.confirmNotice': '确认提示',
  'user.offlineUserAccountNotice': '确认要将该后台账号强制离线吗？',
  'sys.navName': '导航名称',
  'sys.navName.prompt': '请输入导航名称',
  'sys.nav.type': '导航类型',
  'sys.nav.type.prompt': '请选择导航类型',
  'sys.nav.img': '导航图片',
  'sys.nav.img.prompt': '请上传导航图片',
  'sys.nav.modal.list': '导航列表',
  'sys.nav.frontType': '所属端',
  'sys.nav.frontType.prompt': '请选择所属端',
  'sys.nav.frontType.all': '请选择',
  'sys.nav.frontType.PC': 'PC端',
  'sys.nav.frontType.APP': '移动端',
  'sys.nav.msg01': '即将删除名为{navName}的导航',
  'sys.title.fillButtonInfo': '填写按钮信息',
  'sys.title.fillRejectReason': '填写拒绝原因',
  'sys.title.fillMenuInfo': '填写菜单信息',
  'sys.title.fillInfo': '填写信息',
  'sys.title.fillPayChannelInfo': '填写支付渠道参数',
  'sys.title.fillNoticeTypeInfo': '填写通知类型信息',
  'sys.title.fillOnlinePayInfo': '填写在线支付信息',
  'sys.title.fillUSDTPayInfo': '填写USDT支付信息',
  'sys.title.fillVIPPayInfo': '填写V币支付信息',
  'sys.title.fillGoPayInfo': '填写G币支付信息',
  'sys.title.fillEbPayInfo': '填写E币支付信息',
  'sys.title.fillYBFPayInfo': '填写易币付支付信息',
  'sys.title.fillKdPayInfo': '填写KDPAY支付信息',
  'sys.title.fillCbPayInfo': '填写CBPAY支付信息',
  'sys.title.fillOkPayInfo': '填写OKPAY支付信息',
  'sys.title.fillJDPayInfo': '填写JDPAY支付信息',
  'sys.title.fillBCPayInfo': '填写BCPAY支付信息',
  'sys.title.fill808PayInfo': '填写808PAY支付信息',
  'sys.title.fillOffLinePayChannelInfo': '填写线下支付渠道信息',
  'sys.title.groupName': '分组名称',
  'sys.title.groupName1': '请输入分组名称',
  'sys.title.groupName2': '请输入少于20个字符的分组名称',
  'sys.title.buttonName': '按钮名称',
  'sys.title.buttonName1': '请输入按钮名称',
  'sys.title.buttonName2': '请输入少于20个字符的按钮名称',
  'sys.title.buttonNumber': '按钮编号',
  'sys.title.buttonNumber1': '请输入按钮编号',
  'sys.title.buttonNumber2': '请输入少于100个字符的按钮编号',
  'sys.title.buttonDes': '按钮描述',
  'sys.title.buttonDes1': '请输入按钮描述',
  'sys.title.buttonDes2': '请输入少于1000个字符的按钮描述',
  'sys.title.groupNameAndNumber': '分组名称/编号',
  'sys.title.buttonAndLink': '按钮名称/链接',
  'sys.title.configNameValueGroup': '配置名/值/组',
  'sys.title.belongUserGroup': '所属用户组',
  'sys.title.userGroup': '用户组',
  'sys.title.adminGroup': '管理组',
  'sys.title.userGroup1': '请选择用户组',
  'sys.title.configGroup': '配置组',
  'sys.title.configGroup1': '请输入配置组',
  'sys.title.group': '组',
  'sys.title.group1': '请输入组',
  'sys.title.limitLength20': '请输入少于20个字符',
  'sys.title.limitLength50': '请输入少于50个字符',
  'sys.title.limitLength100': '请输入少于100个字符',
  'sys.title.limitLength200': '请输入少于200个字符',
  'sys.title.limitLength1000': '请输入少于1000个字符',
  'sys.title.keyNotice': '请输入key',
  'sys.title.value': '值',
  'sys.title.valueNotice': '请输入值',
  'sys.title.sort': '顺序',
  'sys.title.sortNotice': '请输出顺序',
  'sys.title.fillMenuInfoNotice': '菜单编号必需是链接最后一个 / 后边的内容',
  'sys.title.hierarchical': '菜单层级',
  'sys.title.hierarchical1': '{menuLevel} 级菜单',
  'sys.title.topMenu': '顶部菜单',
  'sys.title.leafMenu': '叶子菜单',
  'sys.title.leafMenu1': '叶子菜单',
  'sys.title.menuName': '菜单名称',
  'sys.title.menuName1': '请输入菜单名称',
  'sys.title.menuName2': '请输入少于20个字符的菜单名称',
  'sys.title.menuLevel': '菜单级别',
  'sys.title.menuLevel1': '请选择菜单级别',
  'sys.title.menuLevel_1': '一级菜单',
  'sys.title.menuLevel_2': '二级菜单',
  'sys.title.menuLevel_3': '三级菜单',
  'sys.title.menuType': '菜单类型',
  'sys.title.menuType1': '是否是叶子菜单',
  'sys.title.menuOrder': '菜单顺序',
  'sys.title.menuOrder1': '请输入菜单顺序',
  'sys.title.menuLink': '菜单链接',
  'sys.title.menuLink1': '请输入菜单编号，用于拼接链接',
  'sys.title.menuLink2': '请输入少于100个字符的菜单编号',
  'sys.title.menuLink3': '"/"开头 + 上级链接 + "/" + 菜单编号 ',
  'sys.title.menuCode': '菜单编号',
  'sys.title.menuCode1': '请输入菜单编号，字母、数字、小数点',
  'sys.title.menuCode2': '请输入少于100个字符的菜单编号',
  'sys.title.menuCode3': '链接组成: 上级菜单编号/菜单编号',
  'sys.title.menuIcon': '菜单图标',
  'sys.title.menuIcon1': '请输入少于20个字符的菜单图标',
  'sys.title.menuIcon2': '请输入菜单图标，一级菜单不需要',
  'sys.title.reviewIcon': '图标预览',
  'sys.title.menuGroup': '菜单组',
  'sys.title.menuNameAndLink': '菜单名称/链接',
  'msg.title.notifyName': '通知名称',
  'msg.title.notifyName1': '请输入通知类型名称',
  'msg.title.notifyName2': '请输入少于20个字符的通知类型名称',
  'msg.title.notifyCode': '通知编号',
  'msg.title.notifyCode1': '请输入通知类型编号，用于拼接链接',
  'msg.title.notifyCode2': '请输入少于100个字符的通知类型编号',
  'msg.title.notifyCode3': '链接组成: 上级通知类型编号/通知类型编号',
  'msg.title.notifyDesc': '通知描述',
  'msg.title.notifyDesc1': '请输入少于20个字符的通知类型描述',
  'msg.title.notifyDesc2': '请输入通知类型描述',
  'msg.title.notifyNameAndLink': '通知类型名称/链接',
  'msg.title.notifyNameR': '通知名称',
  'msg.title.notifyCodeR': '通知编号',
  'sys.title.updateDesc': '更新說明:',
  'sys.title.updateDesc1': '建议不超过5行, 每行15个字(含字符)',
  'agent.title.confirmOffer': '确认发放',
  'agent.title.confirmOffer1': '请确认是否发放佣金?',
  'agent.title.confirmReject': '确认拒绝',
  'agent.title.confirmReject1': '请确认是否拒绝发放?',
  'agent.title.confirmCumulative': '确认累计核算',
  'agent.title.confirmCumulative1': '请确认是否累计到次月佣金结算?',
  'agent.title.settlementDate': '结算日',
  'agent.title.monthlyProfitLoss': '月盈亏',
  'agent.title.bonusAmount': '红利金额',
  'agent.title.depositWithdrawalFee': '存提手续费',
  'agent.title.depositWithdrawAndFee': '存提款及手续费',
  'agent.title.deposit': '存款金额',
  'agent.title.withdraw': '提款金额',
  'agent.title.transFee': '手续费',
  'agent.title.netProfit': '净利润',
  'agent.title.earningCommission': '所得佣金',
  'agent.title.commissionStatus1': '待审核一（风控）',
  'agent.title.commissionStatus2': '待审核二（财务）',
  'agent.title.commissionStatus3': '佣金已派发',
  'agent.title.commissionStatus4': '拒绝发放',
  'agent.title.commissionStatus5': '累计次月',
  'agent.settlementDate.month': '结算月',
  'agent.settlementDate.startDate': '开始',
  'agent.settlementDate.endDate': '结束',
  'agent.title.offerCommission': '发放佣金',
  'agent.title.reject': '拒绝',
  'agent.title.marketCost': '市场费用',
  'agent.title.refundFee': '退款费用',
  'agent.title.taxDeduction': '税收扣除',
  'agent.title.lowerLevel': '下级抽成',
  'agent.title.alreadyOffer': '已发放',
  'sys.upload.success': '文件上传成功',
  'sys.upload.fail': '文件上传失败，请删除后再上传文件。',
  'sys.upload.deleteSuccess': '成功删除。',
  'sys.upload.picture': '上传图片。',
  'sys.lengthLimit': '最多输入300个字符',
  'sys.input': '请输入',
  'pay.offline': '线下支付',
  'pay.online': '线上渠道',
  'pay.usdt': 'USDT支付',
  'pay.vipPay': 'V币支付',
  'pay.goPay': 'G币支付',
  'pay.ebPay': 'E币支付',
  'pay.ybfPay': '易币付',
  'pay.kdPay': 'K豆支付',
  'pay.cbPay': 'C币支付',
  'pay.okPay': 'OK币支付',
  'pay.jdPay': 'JD币支付',
  'pay.bcPay': '虚拟币支付',
  'pay.808Pay': '808币支付',
  'pay.title.payTypeInfo': '支付类型信息',
  'sys.title.parentCode': '归属分组',
  'sys.title.parentCode1': '请选择归属分组',
  'sys.title.forwardUrl': '跳转链接',
  'sys.title.forwardUrl1': '请输入跳转链接',
  'sys.title.forwardUrl2': '请输入合法跳转链接',
  'sys.title.background': '背景色',
  'sys.title.background1': '请输入背景色',
  'sys.title.background2': '请输入顺序背景色',
  'sys.title.background3': '推荐：蓝#0ae/绿#22ac38/深蓝#4a79d6/黄#d55a26/红#DD524D/淡黄#e9e5af/淡灰#f3f3f3',
  'sys.title.imgPC': '图标（PC）',
  'sys.title.imgMobile': '图标（H5）',
  'sys.title.img1': '请上传图标',
  'sys.title.img2': '推荐: 宽度不限,高度40px，格式png',
  'pay.title.insideName': '内部名称',
  'pay.title.payViewName': '用户端名称',
  'pay.title.groupLevel': '分组级别',
  'pay.title.sort': '排序',
  'pay.title.recommendDesc': '类型：推荐说明',
  'pay.title.externalChain': '外链支付',
  'pay.title.builtGrouping': '内置分组',
  'pay.title.builtGrouping1': '内置分组：{payDesc}',
  'pay.title.img': '图标',
  'pay.title.attributes': '属性',
  'pay.title.attributes1': '显',
  'pay.title.attributes2': '隐',
  'pay.title.attributes3': '荐',
  'pay.title.edit': '编辑',
  'pay.title.confirmOrder': '确认订单',
  'pay.title.cancelOrder': '取消订单',
  'pay.title.confirmOrder1': '请核实是否已到账?',
  'pay.title.cancelOrder1': '请确认是否取消订单?',
  'sys.title.loadingCallBtnFail': '加载拨打电话按钮失败',
  'sys.title.callSuccess': '拨打成功',
  'sys.title.callError': '拨打错误',
  'sys.title.callError1': '拨打超时、请稍后',
  'sys.title.orderNo': '订单号',
  'sys.title.thirdPlatform': '第三方',
  'sys.title.userAccount': '会员',
  'sys.title.payName': '支付平台',
  'sys.title.payerName': '存款信息',
  'sys.title.withdrawalInfo': '提款信息',
  'sys.title.bankName': '收款信息',
  'sys.title.orderAmount': '金额',
  'sys.title.orderAmount1': '充值成功',
  'sys.title.orderAmount0': '未付款',
  'sys.title.orderAmount2': '已过期',
  'sys.title.orderAmount3': '已取消',
  'sys.title.orderAmount4': '充值成功未确认',
  'sys.title.create': '创建/处理时间',
  'sys.title.update': '处理时长/人员',
  'sys.title.dealTime': '处理时间',
  'sys.title.dealAdmin': '处理人员',
  'sys.title.applyTime': '申请时间',
  'finance.export.depositOfflineExcel': '订单充值(线下支付)报表.xls',
  'finance.export.depositOnlineExcel': '订单充值(线上支付)报表.xls',
  'pay.input.orderUserAccountPlatform': '搜索关键字(准确信息)',
  'sys.title.checkPaymentPercent': '查看成功率',
  'sys.title.orderStatus': '订单状态',
  'sys.title.dataType': '数据类型',
  'sys.title.dataType0': '充值记录',
  'sys.title.dataType1': '会员汇总',
  'sys.title.dataType2': '渠道汇总',
  'sys.title.dataType3': '首存汇总',
  'pay.title.deviceSource': '订单来源',
  'pay.title.deviceSource1': 'PC端',
  'pay.title.deviceSource2': 'H5端',
  'pay.title.deviceSource3': '安卓端',
  'pay.title.deviceSource4': 'IOS端',
  'pay.title.deviceSource5': 'PWA端',

  'finance.export.orderDepositExcel': '订单充值报表.xls',
  'finance.export.orderWithdrawalExcel': '提现订单报表.xls',
  'pay.title.confirmReason': '确认原因',
  'pay.title.confirmReason1': '请输入确认原因',
  'pay.title.confirmUnlock': '确认解锁',
  'pay.title.confirmUnlock1': '是否确认解除提款锁定',
  'pay.title.rejectInfo': '拒绝信息',
  'pay.title.confirmWithdrawal': '确认提现',
  'pay.title.confirmWithdrawal1': '是否同意以{name}提现?',
  'pay.title.wrongSplitAmount': '拆分金额错误',
  'pay.title.wrongSplitAmount2': '拆分金额不能大于总金额',
  'pay.title.splitOrder': '确认拆成{length}笔订单吗?',
  'pay.title.success': '成功',
  'pay.title.success1': '是否确认提款到账？',
  'pay.title.fail': '失败',
  'pay.title.fail1': '是否确认提款失败？',
  'pay.title.withdrawalOrder': '提现订单号',
  'pay.title.windControlAudit': '风控审核',
  'pay.title.paymentReview': '出款审核',
  'pay.title.requestWithdrawalTime': '申请提款时间',
  'pay.title.paymentMethod': '出款方式',
  'pay.title.withdrawType': '订单类型',
  'pay.title.splitOrder1': '拆分订单',
  'pay.title.splitMasterOrder': '拆分主订单',
  'pay.title.splitMolecularOrder': '拆分子订单',
  'pay.title.molecularTransNo': '子订单号: {transNo}',
  'pay.title.masterTransNo': '主订单号: {transNo}',
  'pay.title.refuseWithdrawCash': '拒绝提现',
  'pay.title.confirmPayment': '确认出款',
  'pay.title.confirmAutoPayment': '自动出款',
  'pay.title.payForMoney': '代付出款',
  'pay.title.payForUSDT': 'USDT出款',
  'pay.title.unlock': '解锁',
  'pay.title.denialReason': '拒绝原因',
  'pay.title.withdrawalStatus2': '提现成功',
  'pay.title.withdrawalStatus1': '待出款',
  'pay.title.withdrawalStatus3': '已拒绝',
  'pay.title.withdrawalStatus0': '风控待审核',
  'pay.title.withdrawalStatus4': '代付处理中',
  'pay.title.withdrawalStatus5': '代付失败',
  'pay.title.withdrawalStatus6': '出款锁定中',
  'pay.title.withdrawalStatus8': '拆分成功',
  'pay.title.withdrawalStatus_1': '待审核',
  'pay.title.withdrawalStatus_2': '提现成功',
  'pay.title.withdrawalStatus_3': '已拒绝',
  'pay.title.withdrawalStatus_0': '风控审核中',
  'pay.title.withdrawalStatus_4': '代付处理中',
  'pay.title.withdrawalStatus_5': '代付失败',
  'pay.title.choseWithDrawalChannel': '请选择代付渠道',
  'pay.title.rate': '费率',
  'pay.title.eachOrderAmount': '每笔金额',
  'pay.title.splitAmountConfig': '拆分金额设置',
  'pay.title.splitAmount': '请输入拆分金额',
  'pay.title.rejectReason': '请输入拒绝原因',
  'pay.title.withdrawalSuccessTime': '提现成功时间',
  'pay.title.withdrawalChannel': '出款渠道',
  'pay.title.SuccessTimeOrFailTime': '成功或者失败时间',
  'pay.title.withdrawalOrderUserAccount': '提现订单号、用户名',
  'login.title.qrcode': '请验证二维码',
  'login.install.current': '当前版本号',
  'login.install.verify0': 'chrome 版',
  'login.install.verify1': 'Android 版',
  'login.install.verify2': 'iOS 版',
  'login.title.idcard': '请输入身份验证码',
  'login.title.verifyIdcard': '请验证身份验证码',
  'login.title.verificationCode': '验证码',
  'login.title.finishVerify': '完成验证',
  'lottery.title.userAccount': '会员账号',
  'lottery.title.complainantType': '投诉类型',
  'lottery.title.targetId': '投诉对象编号',
  'lottery.title.targetId1': '帖子',
  'lottery.title.targetId2': '评论',
  'lottery.title.complainantAndComplainantTime': '投诉人/投诉时间',
  'lottery.title.complainantDate': '投诉日期',
  'lottery.title.keyword': '关键字',
  'lottery.title.targetCode': '目标编号',
  'lottery.title.read': '阅读',
  'lottery.title.open': '开启',
  'lottery.title.close': '关闭',
  'lottery.title.dayLimit': '每日上限',
  'lottery.title.article': '篇',
  'lottery.title.ordinaryStickers': '普通贴',
  'lottery.title.cash': '现金',
  'lottery.title.flow': '流水',
  'lottery.title.point': '积分',
  'lottery.title.expertStickers': '专家贴',
  'lottery.title.greatGodSticker': '大神贴',
  'lottery.title.attention': '关注',
  'lottery.title.perPerson': '每人送',
  'lottery.title.person': '人',
  'lottery.title.comment': '评论',
  'lottery.title.eachDelivery': '每条送',
  'lottery.title.article1': '条',
  'lottery.title.like': '点赞',
  'lottery.title.everyTimeSend': '每次送',
  'lottery.title.one': '个',
  'lottery.title.buyLotterySwitch': '购彩开关',
  'lottery.title.handicapTime': '盘口时间',
  'lottery.title.switchOpen': '开',
  'lottery.title.closingTime': '封盘时间',
  'lottery.title.inputNumber': '请输入数字',
  'lottery.title.postReply': '发帖/回复',
  'lottery.title.post': '发帖',
  'lottery.title.reply': '回复',
  'lottery.title.sticker': '帖子',
  'lottery.title.applyForGod': '申请大神',
  'lottery.title.recentWinningStreak': '近期连胜',
  'lottery.title.inputPeriods': '请输入期数',
  'lottery.title.periods': '期',
  'lottery.title.periods1': '期数',
  'lottery.title.inputPeriods1': '请选择期数',
  'lottery.title.periods2': '第 {item} 期',
  'lottery.title.weekWinRate': '周胜率',
  'lottery.title.monthWinRate': '月胜率',
  'lottery.title.addMemberLevel': '添加会员等级',
  'lottery.title.levelName': '等级名称',
  'lottery.title.level': '级别',
  'lottery.title.addTime': '添加时间',
  'lottery.title.addAdmin': '添加人',
  'lottery.title.addBannedMember': '添加禁言会员',
  'lottery.title.inputMemberAccount': '请输入会员账号',
  'lottery.title.inputMemberAccount1': '请输入会员账号，多个账号用逗号分割',
  'lottery.title.banCount': '时长',
  'lottery.title.inputBanCount': '请输入时长',
  'lottery.title.reason': '原因',
  'lottery.title.inputReason': '请输入原因',
  'lottery.title.confirmNotice': '确认提示',
  'lottery.title.confirmNotice1': '确定要拒绝该订单奖金吗？',
  'lottery.title.confirmNotice2': '确定要删除选择的禁言会员吗？',
  'lottery.title.confirmNotice3': '确定要删除 {year} 年 {month} 月 {day} 日的开奖日期吗？',
  'lottery.title.confirmNotice4': '确定要使用该奖源号码作为开奖号码吗？',
  'lottery.title.confirmNotice5': '确定 {year} 年第 {period} 期的订单都已经派彩完毕了吗？',
  'lottery.title.confirmNotice6': '确定要派发所选择订单奖金吗？',
  'lottery.title.confirmNotice7': '确认要删除选择的回复吗？',
  'lottery.title.confirmNotice8': '确认要修改排序类型吗？',
  'lottery.title.confirmNotice9': '确认要删除选择的帖子吗？',
  'lottery.title.confirmNotice10': '确认要重置代理密码，重置后代理登录需要用新密码？',
  'lottery.title.confirmNotice11': '确认删除该条佣金比例吗？',
  'lottery.title.confirmNotice13': '此提交影响全局默认佣金计算百分比，请仔细核对信息是否正确？',
  'lottery.title.confirmNotice14': '此提交影响全局综合计算百分比，请仔细核对信息是否正确？',
  'lottery.title.confirmNotice15': '此提交影响全局下级代理默认佣金计算百分比，请仔细核对信息是否正确？',
  'lottery.title.confirmNotice16': '确认要重置代理支付密码，重置后代理提现需要用新密码？',
  'lottery.title.banTime': '禁言时间',
  'lottery.title.time': '时间',
  'lottery.title.timeStart': '开始时间',
  'lottery.title.timeEnd': '结束时间',
  'lottery.title.batchAdd': '批量添加',
  'lottery.title.batchRemove': '批量移除',
  'lottery.title.openDate': '开奖时间',
  'lottery.title.openPeriods': '开奖期号',
  'lottery.title.openNumber': '开奖号码',
  'lottery.title.openLottery1': '未完成派奖',
  'lottery.title.openLottery2': '已完成派奖',
  'lottery.title.confirmLotteryOpen': '派奖完毕',
  'lottery.title.lotteryResult': '派奖完毕',
  'lottery.title.batchGrant': '批量派奖',
  'lottery.title.orderDate': '下单日期',
  'lottery.title.officialTime': '官方',
  'lottery.title.platfromTime': '平台',
  'lottery.title.day': '日',
  'lottery.title.year': '年',
  'lottery.title.inputYear': '请输入年',
  'lottery.title.month': '月份',
  'lottery.title.inputMonth': '请输入月份',
  'lottery.title.date': '日期',
  'lottery.title.inputDate': '请输入日期',
  'lottery.title.enteringPersonAndTime': '录入人/录入时间',
  'lottery.title.openPersonAndOpenTime': '开奖人/开奖时间',
  'lottery.title.addOpenDate': '添加开奖日期',
  'lottery.title.enteringOpenNumber': '录入开奖号码',
  'lottery.title.enteringDate': '录入日期',
  'lottery.title.enteringNumber': '录入号码',
  'lottery.title.firstBall': '第一球',
  'lottery.title.firstBall1': '请输第一球',
  'lottery.title.secondBall': '第二球',
  'lottery.title.secondBall1': '请输入第二球',
  'lottery.title.thirdBall': '第三球',
  'lottery.title.thirdBall1': '第三球',
  'lottery.title.fourthBall': '第四球',
  'lottery.title.fourthBall1': '请输入第四球',
  'lottery.title.fifthBall': '第五球',
  'lottery.title.fifthBall1': '请输入第五球',
  'lottery.title.sixthBall': '第六球',
  'lottery.title.sixthBall1': '请输入第六球',
  'lottery.title.seventhBall': '第七球',
  'lottery.title.seventhBall1': '请输入第七球',
  'lottery.title.status1': '待采用',
  'lottery.title.status2': '已采用',
  'lottery.title.status3': '已弃用',
  'lottery.title.firstLevelName': '一级彩种名称',
  'lottery.title.secondLevelName': '二级彩种名称',
  'lottery.title.hongkong': '香港彩',
  'lottery.title.markSix': '六合彩',
  'lottery.title.playName': '玩法名称',
  'lottery.title.playName1': '请选择玩法',
  'lottery.title.bonusNumber': '中奖号码',
  'lottery.title.bonusAmount': '中奖金额',
  'lottery.title.grantAdminAndGrantTime': '派奖人/派奖时间',
  'lottery.title.grantDate': '派奖时间',
  'lottery.title.orderNumber': '订单编号',
  'lottery.title.number': '号码',
  'lottery.title.orderTimeAndOpenTime': '下单时间/开奖时间',
  'lottery.title.orderStatus1': '等待付款',
  'lottery.title.orderStatus2': '等待开奖',
  'lottery.title.orderStatus3': '开奖中',
  'lottery.title.orderStatus4': '结算中',
  'lottery.title.orderStatus5': '已中奖',
  'lottery.title.orderStatus6': '未中奖',
  'lottery.title.orderStatus7': '无效订单',
  'lottery.title.orderStatus8': '撤单',
  'lottery.title.betAmount': '下注金额',
  'lottery.title.eachBetAmount': '每注',
  'lottery.title.totalAmount': '总金额',
  'lottery.title.galleryName': '图库名字',
  'lottery.title.isHeat': '是否热门',
  'lottery.title.isHeat1': '热门',
  'lottery.title.isHeat0': '非热门',
  'lottery.title.thumbnail': '缩略图',
  'lottery.title.periodsMgt': '具体期数管理',
  'lottery.title.isDisplaySort': '是否按浏览量显示顺序',
  'lottery.title.ptrr': '赞/踩/阅读数/评论数',
  'lottery.title.praiseCount': '被赞数',
  'lottery.title.treadCount': '被踩数',
  'lottery.title.readCount': '阅读数',
  'lottery.title.reviewCount': '评论数',
  'lottery.title.lookBigPic': '查看大图',
  'lottery.title.likeCount': '点赞数',
  'lottery.title.content': '评论内容',
  'lottery.title.content1': '请输入评论内容',
  'lottery.title.UserAccountAndContent': '用户名、评论内容',
  'lottery.title.sendPushMsg': '发送推送消息',
  'lottery.title.pushPlatform': '推送平台',
  'lottery.title.pushDate': '推送日期',
  'lottery.title.pushPlatform1': '请选择推送平台',
  'lottery.title.android': '安卓',
  'lottery.title.ios': 'IOS',
  'lottery.title.title': '标题',
  'lottery.title.title1': '请填写推送标题',
  'lottery.title.title2': '请输入帖子标题',
  'lottery.title.contents': '推送内容',
  'lottery.title.contents1': '请填写推送内容',
  'lottery.title.pushAdminAndContents': '推送人/推送时间',
  'lottery.title.addSuccess': '增加成功！',
  'lottery.title.addException': '增加异常',
  'lottery.title.addLikeCountAndReadCount': '增加点赞或阅读数量',
  'lottery.title.choseType': '选择类型',
  'lottery.title.choseType1': '请选择添加类型',
  'lottery.title.countNumber': '数量',
  'lottery.title.countNumber1': '请输入数量',
  'lottery.title.commentSuccess': '评论成功！',
  'lottery.title.commentError': '评论错误',
  'lottery.title.postAndReply': '发表帖子回复',
  'lottery.title.numberCode': '编号',
  'lottery.title.replyAdmin': '回复人',
  'lottery.title.secondReply': '二级回复',
  'lottery.title.upperNumberCode': '上级编号',
  'lottery.title.firstReply': '一级回复',
  'lottery.title.replyTime': '回复时间',
  'lottery.title.replyLevel': '回复层级',
  'lottery.title.conten': '内容',
  'lottery.title.addLikeAndRead': '增加点赞或阅读数量',
  'lottery.title.addLikeAndRead1': '增加点赞、阅读、跟单数量',
  'lottery.title.follow': '跟单',
  'lottery.title.postNew': '发布新帖',
  'lottery.title.category': '分类',
  'lottery.title.category1': '请选择分类',
  'lottery.title.postDate': '发帖日期',
  'lottery.title.adPic': '广告图片',
  'lottery.title.adPic1': '请上传广告图片',
  'lottery.title.public': '是否公开',
  'lottery.title.public1': '请选择是否公开',
  'lottery.title.public2': '公开',
  'lottery.title.public3': '回复可查看',
  'lottery.title.pushSingleSticker': '是否推单贴',
  'lottery.title.pushSingleSticker1': '请选择帖子类型',
  'lottery.title.pushSingleSticker2': '非推单贴',
  'lottery.title.pushSingleSticker3': '推单贴',
  'lottery.title.secondaryPlay': '二级玩法',
  'lottery.title.secondaryPlay1': '请选择二级玩法',
  'lottery.title.thirdPlay': '三级玩法',
  'lottery.title.thirdPlay1': '请选择三级玩法',
  'lottery.title.amountPerBet': '每注金额',
  'lottery.title.amountPerBet1': '请输入每注金额',
  'lottery.title.ranking': '排行',
  'lottery.title.ranking1': '置顶',
  'lottery.title.ranking2': '推荐',
  'lottery.title.giftChoice': '赠送选择',
  'lottery.title.giftChoice1': '送钱',
  'lottery.title.giftChoice2': '送积分',
  'lottery.title.readSendCash': '阅读送现金',
  'lottery.title.readSendCash1': '请输入金额',
  'lottery.title.readSendPoint': '阅读送积分',
  'lottery.title.readSendPoint1': '请输入积分',
  'lottery.title.postAccount': '发帖账号',
  'lottery.title.postAccount1': '请输入发帖账号',
  'lottery.title.setStickerType': '设置帖子类型',
  'lottery.title.stickerType': '帖子类型',
  'lottery.title.stickerType1': '请输入帖子类型名称',
  'lottery.title.typeName': '类型名称',
  'lottery.title.showOrder1': '请输入展示顺序',
  'lottery.title.showOrder': '展示顺序',
  'lottery.title.addType': '添加类型',
  'lottery.title.moveBeforeDelete': '请将所属帖子转移至其他分类下后，再删除。',
  'lottery.title.postAdmin': '发帖人',
  'lottery.title.categoryAndTitle': '分类/标题',
  'lottery.title.readContentLike': '阅读/评论/点赞',
  'lottery.title.postAndEditTime': '发帖/编辑时间',
  'lottery.title.unpin': '取消置顶',
  'lottery.title.cancelRecom': '取消推荐',
  'lottery.title.viewReply': '查看回复',
  'lottery.title.addQuantity': '添加数量',
  'lottery.title.addSticker': '新增帖子',
  'lottery.title.deleteSticker': '删除帖子',
  'lottery.title.updateCategory': '更改分类',
  'lottery.title.setCategory': '设置分类',
  'lottery.title.targetType': '目标类型',
  'lottery.title.likeContent': '点赞对象内容',
  'lottery.title.likeTime': '点赞时间',
  'lottery.title.beLikeAccount': '被关注人账号',
  'lottery.title.attentionTime': '关注时间',
  'lottery.title.taskTime': '任务时间',
  'lottery.title.type': '类型',
  'lottery.title.readingTask1': '阅读任务-普通贴',
  'lottery.title.readingTask2': '阅读任务-专家贴',
  'lottery.title.readingTask3': '阅读任务-大神贴',
  'lottery.title.readTask': '阅读任务',
  'lottery.title.focusTask': '关注任务',
  'lottery.title.contentTask': '评论任务',
  'lottery.title.likeTask': '点赞任务',
  'lottery.title.taskTarget': '任务目标',
  'lottery.title.completed': '已完成',
  'lottery.title.isReceive': '是否领取',
  'lottery.title.received': '已领取',
  'lottery.title.unaccalimed': '未领取',
  'lottery.title.upgradeTime': '升级时间',
  'agent.title.verificationFail': '验证失败',
  'agent.title.verificationFail1': '用户名已存在。请重新输入',
  'agent.title.confirmPassWrong': '两次输入的密码不匹配!',
  'agent.title.fillAgentInfo': '填写代理信息',
  'agent.title.agentType': '代理类型',
  'agent.title.ordinaryAgent': '普通代理',
  'agent.title.agentLevel': '代理等级',
  'agent.title.manualAmount': '调账金额',
  'agent.title.agentLevel1': '一级代理',
  'agent.title.agentLevel2': '二级代理',
  'agent.title.agentLevel3': '三级代理',
  'agent.title.adChannel': '广告渠道',
  'agent.title.addAdChannel': '添加广告渠道',
  'agent.title.adCode': '广告渠道CODE',
  'agent.title.adCode1': '请选择广告CODE',
  'agent.title.adName': '广告名称',
  'agent.title.adName1': '请输入正确的广告名称',
  'agent.title.adAddress': '广告投放地址',
  'agent.title.adAddress1': '请输入正确的广告地址',
  'agent.title.adDesc': '广告描述',
  'agent.title.adDesc1': '请输入正确的广告描述',
  'agent.title.adPutDate': '投放日期',
  'agent.title.adPutDate1': '请选择投放日期',
  'agent.title.payName': '付款姓名',
  'agent.title.payName1': '请输入正确的付款姓名',
  'agent.title.bankNo': '银行卡号',
  'agent.title.usdtAddress': 'USDT收款地址',
  'agent.title.bankNo1': '请输入正确的银行卡号',
  'agent.title.adMgt': '广告管理',
  'agent.title.onlyOne': '广告代理渠道仅限选择一条',
  'agent.title.outOfIndex': '广告代理渠道不在选择区间，请重新选择。',
  'agent.title.baseInfo': '基本信息',
  'agent.title.payInfo': '付款信息',
  'agent.title.complete': '完成',
  'agent.title.nextStep': '下一步',
  'agent.title.backStep': '上一步',
  'agent.title.oneMore': '再添一条',
  'agent.title.resetPassSuccess': '重置密码成功',
  'agent.title.newPassIs': '重置密码成功，新密码为：',
  'agent.title.resetPassSuccess1': '重置提款密码成功',
  'agent.title.newPassIs1': '重置提款密码成功，新密码为：',
  'agent.title.unfreezeAgent': '是否要解冻此代理?',
  'agent.title.activationAgent': '是否要激活此代理?',
  'agent.title.freezeAgent': '是否要冻结此代理?',
  'agent.title.rejectActivationAgent': '是否要拒绝激活此代理?',
  'agent.title.confirmOperate': '操作确认',
  'agent.title.trackCode': '追踪代码',
  'agent.title.registerTimeAndLastLoginTime': '注册时间/最后登录',
  'agent.title.status0': '未激活',
  'agent.title.status1': '已激活',
  'agent.title.status2': '已冻结',
  'agent.title.status3': '已拒绝',
  'agent.title.activation': '激活',
  'agent.title.freeze': '冻结',
  'agent.title.thaw': '解冻',
  'agent.title.resetPass': '重置登录密码',
  'agent.title.userCodeNameMail': '用户名、代码、姓名、邮箱',
  'agent.title.registerTime': '注册时间',
  'agent.title.upperCode': '上级CODE',
  'agent.title.upperAgentCode': '请输入上级代理CODE',
  'agent.title.platform': '平台',
  'agent.title.platformDetail': '平台详情',
  'agent.title.desc': '平台输赢：{resultAmount}，佣金比例：{commissionPercent}，所得佣金：{commission}',
  'agent.title.flowDesc': '平台流水：{resultAmount}，佣金比例：{commissionPercent}，所得佣金：{commission}',
  'agent.title.disableReleUserMenu': '隐藏代理下线会员菜单',
  'agent.title.showReleUserMenu': '显示代理下线会员菜单',
  'agent.title.disableReleUserMenuMsg': '隐藏下线列表',
  'agent.title.showReleUserMenuMsg': '显示下线列表',

  'agent.title.monthSettlementCommission': '周期结算佣金',
  'agent.export.agentMonthExcel': '代理月度結算佣金报表.xls',
  'agent.title.agentName': '代理名称',
  'agent.title.depositAmount': '存款',
  'agent.title.withdrawAmount': '提款',
  'agent.title.totalChangeMoney': '手续费',
  'agent.title.commissionReport1': '代理佣金 =  下线平台佣金-下线优惠-下线存提款手续费  ',
  'agent.title.commissionReport2': '下线平台佣金 = （平台A输赢*{platformCost}*平台A佣金比例）+（平台B输赢*{platformCost}*平台B佣金比例）+（平台C输赢*{platformCost}*平台C佣金比例）+。。。。',
  'agent.title.commissionReport3': '下线优惠 = 代理下级会员发放的所有优惠总和',
  'agent.title.commissionReport4': '下线存提款手续费 = (下线存款+下线提款)*{minAmount}',
  'agent.title.commissionReport5': '代理佣金 = （平台输赢 * {platformCost} - 系统红利 - 用户存提款金额 * {minAmount}）* 佣金比例。',
  'agent.title.commissionReport6': '平台输赢 = 各个游戏平台输赢总和。',
  'agent.title.commissionReport7': '系统红利 = 代理下级会员发放的所有红利总和。',
  'agent.title.commissionReport8': '用户存提款金额 = 代理下级会员存款和提款的总金额。',
  'agent.title.commissionReport9': '佣金比例 = 代理佣金比例。',
  'agent.title.commissionReport10': '下线流水佣金 = （会员总有效投注 * （平台设置的区间流水返利比 / 100））',

  'agent.title.commissionForm': '佣金报表',
  'agent.title.dataForm': '数据报表',
  'agent.title.childFlow': '下线流水',
  'agent.title.childFlowCommission': '下线流水佣金',
  'agent.title.childBonus': '下线优惠',
  'agent.title.childDeposit': '下线存款',
  'agent.title.childWithdrawal': '下线提款',
  'agent.title.childResult': '下线输赢',
  'agent.title.childCommission': '下线平台佣金',
  'agent.title.viewDetail': '查看详情',
  'agent.title.childDWFee': '下线存提款手续费',
  'agent.title.commission': '佣金',
  'agent.title.childPlatformResult': '下线平台输赢',
  'agent.title.minimumMonthlyTotalNetProfit': '最低月总净盈利',
  'agent.title.minimumMonthlyTotalNetProfit1': '请输入最低月总净盈利',
  'agent.title.maximumMonthlyTotalNetProfit': '最高月总净盈利',
  'agent.title.maximumMonthlyTotalNetProfit1': '请输入最高月总净盈利',
  'agent.title.addAgentCommissionRatio': '添加代理佣金比例',
  'agent.title.activeMember': '活跃会员',
  'agent.title.activeMember1': '请输入活跃会员',
  'agent.title.commissionRatio': '佣金比例',
  'agent.title.commissionRatio1': '请输入佣金比例',
  'agent.title.cancel': '取消',
  'agent.title.save': '保存',
  'agent.title.defaultAgentDivision': '默认代理分成 按平台百分比',
  'agent.title.platformFeeRatio': '平台费用比例',
  'agent.title.platformWinLose': '平台输赢系数',
  'agent.title.depositWithdrawalFeeMui': '存提手续费系数',
  'agent.title.comprehensiveCost': '请输入综合费用(百分比 \'0\' - \'100\')',
  'agent.title.eachMonthSettlementDay': '每月结算日',
  'agent.title.eachMonthSettlementDayShowDetail': '每月第N天结算',
  'agent.title.halfMonthSettlementDay': '半月结算日',
  'agent.title.halfMonthSettlementDayShowDetail': '每月第N天或第N+15天结算',
  'agent.title.eachWeekSettlementDay': '每周结算日',
  'agent.title.eachWeekSettlementDayShowDetail': '每周第N天结算，星期一为第一天',
  'agent.title.settlementDayMsg': '请输入结算日期',
  'agent.billRate.halfMonthErrorMsg': '半月结算日期不能大于10',
  'agent.billRate.eachWeekErrorMsg': '每周结算日期不能大于7',
  'agent.title.agentTaxPercentage': '平台税收费率',
  'agent.title.agentSharePercent': '抽成比例',
  'agent.title.childAgent': '下级代理佣金设置',
  'agent.title.agentCommission': '代理佣金',
  'agent.title.domainCheck': '不能录入http、https、www开头的域名,请省略。',
  'agent.title.fillDomainInfo': '填写域名信息',
  'agent.title.agentDomain': '代理域名',
  'agent.title.agentDomain1': '请输入域名',
  'agent.title.isDefault': '是否默认',
  'agent.title.isDefault1': '请选择是否默认',
  'agent.title.isDefault2': '默认',
  'agent.title.isDefault3': '非默认',
  'agent.title.domain': '域名',
  'agent.title.domain1': '默认域名',
  'agent.title.domain2': '非默认域名',
  'agent.title.addDomain': '添加域名',
  'agent.title.userNameDomainCode': '用户名、域名、CODE',
  'agent.title.currentStatus': '当前状态',
  'common.title.detailInfo': '详细信息',
  'agent.title.addRemark': '添加备注',
  'agent.title.addRemarkSuccess': '添加备注成功!',
  'agent.title.addRemarkFail': '添加备注失败',
  'agent.title.addRemarkError': '添加备注错误',
  'agent.title.bankName': '银行名称',
  'agent.title.bankAccount': '银行账户名',
  'agent.title.bankAccount1': '请输入账户名',
  'agent.title.bankAddr': '分行地址',
  'agent.title.bankAddr1': '请输入分行地址',
  'agent.title.bankNumber': '银行账号',
  'agent.title.normal': '正常',
  'agent.title.activationCard': '是否要激活此银行卡?',
  'agent.title.deleteCard': '是否要删除此银行卡?',
  'agent.title.offlineCard': '是否要禁用此银行卡?',
  'agent.title.bankInfo': '银行信息',
  'agent.title.addBank': '添加银行卡',
  'agent.title.qrCode': '二维码图片',
  'agent.title.pubQrCode': '宣传二维码',
  'agent.title.phoneNumber': '手机号码',
  'user.title.registerTime1': '注册时间',
  'user.title.nameValidTime': '实名认证时间',
  'user.title.emailValidTime': '邮箱认证时间',
  'user.title.mobileValidTime': '手机认证时间',
  'user.title.withdrawPasswordValid': '提款密码设置时间',
  'user.title.addBankTime': '(默认)银行卡绑定时间',
  'user.title.lastLoginApp': '最后访问设备类型',
  'user.title.bindTime': '绑定时间',


  'user.title.firstDepositTime': '首次存款时间',
  'user.title.lastLoginTime1': '上次登录时间',
  'user.title.lastOnlineTime1': '上次在线时间',
  'user.title.lastDepositTime': '上次存款时间',
  'user.title.lastWithdrawalTime': '上次取款时间',
  'user.title.taotalDepositAmount': '总充值金额',
  'user.title.totalWithdrawalAmount': '总提现金额',
  'user.title.totalBonus1': '总优惠',
  'user.title.totalUserPoint': '总优惠积分',
  'user.title.totalBetFlow': '总流水',
  'user.title.goFail': '跳转失败',
  'user.title.disableLogin': '此账户未激活或已被冻结，不可跳转登录。',
  'agent.export.agentChildUserExcel': '代理名下用户.xls',
  'user.title.agentCommissionConfig': '代理佣金设置',
  'user.title.agentFlowCommissionConfig': '代理流水佣金设置',
  'user.title.goingTo': '跳转中...',
  'user.title.bonusBinding': '优惠绑定',
  'user.title.lastWithdrawalTime1': '上次取款时间',
  'user.title.loginAsAgent': '用代理身份登录',
  'user.title.birthday': '生日',
  'user.title.address': '地址',
  'user.title.upperAgent': '上级代理',
  'user.title.accountFunds': '账户资金',
  'user.title.freezingFunds': '冻结资金',
  'user.title.availableFunds': '可提资金',
  'user.title.profileStatistics': '概况统计',
  'user.title.historyPay': '历史支付',
  'user.title.exportChildUser': '导出名下用户报表.xls',
  'user.title.fillBankCardInfo': '填写银行卡信息',
  'user.title.adjustAccountBalanceSuccess': '调整账户余额成功，调整后余额：',
  'user.title.adjustAccountBalanceFail': '调整账户余额失败',
  'user.title.adjustAccountBalanceError': '调整账户余额错误',
  'user.title.manualTransfer1': '请选择调账类型',
  'user.title.increaseAmount': '增加金额',
  'user.title.decreaseAmount': '减少金额',
  'user.title.agencySpecificCommissionRatio': '代理专属佣金比例',
  'user.title.addAgencySpecificCommissionRatio': '添加代理专属佣金比例',
  'user.title.previousBalance': '之前余额',
  'user.title.afterBalance': '之后余额',
  'user.title.approved': '已同意',
  'user.title.notApproved': '未审批',
  'user.title.pendingApproved': '待审批',
  'user.title.rejected': '已拒绝',
  'user.title.historyBill': '历史账单',
  'user.title.deleteThisFee': '是否删除此笔费用?',
  'user.title.costTime': '费用产生时间',
  'user.title.costType': '费用类型',
  'user.title.costCreateTime': '费用创建时间',
  'user.title.settled': '已结算',
  'user.title.unsettlement': '未结算',
  'user.title.changeFee': '修改费用',
  'user.title.addFee': '添加费用',
  'user.title.notCalculated': '未计算',
  'user.title.Calculated': '已计算',
  'user.title.fillCostInfo': '填写费用信息',
  'user.title.uploadPromotionPicture': '上传推广图片',
  'user.title.oldPromotionPicture': '旧推广图片',
  'user.title.uploadFile': '请上传文件',
  'user.title.imageName': '图片名称',
  'user.title.imageName1': '请输入图片名称',
  'user.title.imageName2': '请输入推广图片名称',
  'user.title.addPromotionPicture': '添加推广图片',
  'user.title.updatePromotionPicture': '修改推广图片',
  'user.title.confirmActivation': '确认激活',
  'user.title.activationPicture': '是否激活此图片?',
  'user.title.banPicture': '是否禁用此图片?',
  'user.title.deletePicture': '是否删除此图片?',
  'user.title.newChildCount': '新注册人数',
  'user.title.activationChildCount': '活跃会员人数',
  'user.title.lowerBetCount': '下线总投注人数',

  'user.title.activationChildCountRole': '当天有投注行为的会员',


  'user.title.childCountInfo': '存款人数信息',
  'user.title.depositChildCount': '总存款人数',
  'user.title.firstDepositChildCount': '总首存人数',

  'user.title.whitdrawalChildCount': '提款人数',
  'user.title.totalDepositChildAmount': '下线总存款', //
  'user.title.totalWithdrawalChildAmount': '下线总提款', //
  'user.title.totalBonusChild': '下线总优惠', //
  'user.title.totalBetFlowChild': '总有效投注', // 下线总流水
  'user.title.totalResultChild': '总输赢', // 下线总输赢

  'user.title.confirmWithdrawal': '是否确认此提现?',
  'user.title.confirmConfirm': '确认后不可更改?',
  'user.title.rejectWithdrawal': '是否拒绝此提现?',
  'user.title.rejectConfirm': '拒绝后不可更改?',
  'user.title.withdrawalNumber': '提现编号',
  'user.title.agree': '同意',
  'user.title.userAccountAndNumber': '用户名/编号',
  'user.title.fillRemarkInfo': '填写备注信息',
  'user.title.confirmBinding': '确认绑定',
  'user.title.confirmBinding1': '确认绑定此优惠吗？',
  'user.title.alreadyBiding': '已经绑定优惠',
  'user.title.changeBindingBonus': '该代理已经绑定  {bonusName}  此注册优惠，确定替换绑定该优惠吗？',
  'user.title.alreadyBindingBonus': '{agentAccount} 此代理已经绑定 {bonusName} 该优惠。',
  'user.title.registerBonusBiding': '注册优惠绑定相关',
  'user.title.registerGiftAmount': '注册赠送金额',
  'user.title.flowTimes': '流水倍数',
  'user.title.binding': '绑定',
  'user.title.unTied': '解绑',
  'user.title.noBackFlowAgent': '是否设置该代理下会员无返水优惠？(流水优惠和实时返水优惠)',
  'user.title.haveBackFlowAgent': '是否设置该代理下会员拥有返水优惠？(流水优惠和实时返水优惠)',
  'user.title.resetPayPass': '重置支付密码',
  'user.title.haveBackFlow': '有返水',
  'user.title.noBackFlow': '无返水',
  'user.title.addCommonAgent': '添加普通代理',
  'user.title.noSelect': '未选择',
  'user.title.assignUser': '请选择需要分配的用户',
  'user.title.choseSalesperson': '请选择需要给的电销人员',
  'user.title.wrongChose': '错误的选择',
  'user.title.assignUserError': '选择分配的用户必须大于或等于选择的电销人员',
  'user.title.userType': '用户类型',
  'user.title.importUser': '导入用户',
  'user.title.silentUser': '沉默用户',
  'user.title.silentRate': '沉默用户',
  'user.title.registerUndepositUser': '注册未存款用户',
  'user.title.memberListImport': '会员列表导入',
  'user.title.importInfo': '导入信息',
  'user.title.importRemark': '导入备注',
  'user.title.importSrouce': '导入来源',
  'user.title.stepTwo': '步骤二  选择分配电销人员(多次选择，只会绑定到第一个电销人员)',
  'user.title.allSalesperson': '全部电销人员',
  'user.title.assign': '分配',
  'user.title.assignList': '分配名单',
  'user.title.assignListDetail': '分配名单详情',
  'user.title.assignTime': '分配时间   -   ',
  'user.title.isRecycle': '是否回收',
  'user.title.confirmRecycle': '请确认是否回收?',
  'user.title.assignedTo': '分配至',
  'user.title.assignedUser': '分配人',
  'user.title.recycled': '已回收',
  'user.title.recycle': '回收',
  'user.title.recycleAll': '全部回收',
  'user.title.confirmRecycle1': '注意：回收号码后，该号码产生的业绩将不会再计算。',
  'user.title.assignTime1': '分配时间',
  'user.title.userAttribute': '用户属性',
  'user.title.assignPersonCount': '分配人数',
  'user.title.assignDetail': '分配详情',
  'user.title.alreadyAssignList': '已分配名单',
  'user.title.importListMode': '导入名单格式如下',
  'user.title.importListMode1': '第一列 ：电话号码',
  'user.title.importListMode2': '第二列 ：导入详情',
  'user.title.importListMode3': '第三列 ：导入备注',
  'user.title.teleSaleAssignList': '电话销售-分配名单',
  'user.title.importDesc': '导入说明',
  'user.title.assignMgt': '分配管理',
  'user.title.waitAssignList': '待分配名单',
  'user.title.lastLogin': '最后登录',
  'user.title.activationTime': '激活时间',
  'user.title.activationFirstDeposit': '激活后首存',
  'user.title.activationTotalDeposit': '激活后总存款',
  'user.title.salesperson': '电销专员 - ',
  'user.title.Salesperson1': '请选择电销人员',
  'user.title.Salesperson2': '未选择电销人员...',
  'user.title.times': '次',
  'user.title.activationCount': '激活 {importCount} 人',
  'user.title.firstDepositCount': '首存 {regNotDepositCount} 人',
  'user.title.recoverCount': '挽回 {silentUserCount} 人',
  'user.title.registerCount': '注册 {importRegCount} 人',
  'user.title.saleStatus': '销售状态(可点击任意状态进入用户列表)',
  'user.title.undialedUser': '未拨打用户',
  'user.title.followUpUsers': '待跟进用户',
  'user.title.dialed': '已拨打',
  'user.title.dialedThisMonth': '本月已拨通',
  'user.title.connectionRate': '接通率',
  'user.title.teleQuality': '通话质量',
  'user.title.performanceOverview': '业绩概览',
  'user.title.averageCallDuration': '平均通话时长',
  'user.title.commissioner': '所属专员',
  'user.title.numberDials': '拨通次数',
  'user.title.chooseSalesperson': '选择电销人员',
  'user.title.uncalledUserList': '未拨打用户列表',
  'user.title.dialedUserList': '已拨打用户列表',
  'user.title.followUpListUsers': '待跟进用户列表',
  'user.title.activationDeposit': '激活后存款',
  'user.title.notDialed': '未拨打',
  'user.title.dial': '拨打',
  'user.title.keepFollow': '继续跟进',
  'user.title.cancelFollow': '取消跟进',
  'user.title.affiliatedSales': '所属电销',
  'user.title.invitationCodeUser': '邀请码用户',
  'user.title.myPerformance': '我的业绩',
  'user.title.performanceDetails': '业绩详情',
  'user.title.performanceList': '业绩详单',
  'user.title.dailyPerformanceStatistics': '每日业绩数据统计',
  'user.title.registrationNoDeposit': '新注册未存款',
  'user.title.dialCount': '拨打量',
  'user.title.activationsCount': '激活人数',
  'user.title.currentPerformanceOverview': '当期业绩概览',
  'user.title.calledThisMonth': '本月已拨打',
  'user.title.seatNumber': '坐席号',
  'user.title.currentAgentAssignor': '当前坐席分配人',
  'user.title.seatMgt': '电话销售-坐席管理',
  'user.title.assignSeatSalesperson': '分配电销坐席',
  'user.title.seatSalesperson': '坐席人员',
  'user.title.seatSalesperson1': '请输入分配电销人员',
  'user.title.times1': '次数',
  'user.title.percent': '百分比 (%)',
  'user.title.seatSalesperson2': '请选择分配电销人员',
  'user.title.offlineOutThreeDay': '三天以上未登录用户',
  'user.title.userInfo': '用户信息',
  'user.title.registerAndLogin': '注册/登录',
  'user.title.telemarketing': '电话销售',
  'user.title.remarkInfo': '备注信息',
  'user.title.editAt': ' 编辑于 ',
  'user.title.confirm': '确定',
  'user.title.loading': '加载中...',
  'user.title.waitIntoDialList': '是否进入待拨打用户列表',
  'user.title.confirmWaitIntoDialList': '请确认是否进入待拨打用户列表',
  'user.title.waitIntoDialedList': '是否进入已拨打用户列表',
  'user.title.confirmWaitIntoDialedList': '请确认是否进入已拨打用户列表',
  'user.title.waitIntoFollowList': '是否进入待跟进用户列表',
  'user.title.confirmWaitIntoFollowList': '请确认是否进入待跟进用户列表',
  'user.title.platformSerialNumber': '，平台流水号：',
  'user.title.gameSerialNumber': '游戏流水号',
  'user.title.rawData': '原始数据(游戏平台时间)',
  'user.title.verified': '已认证',
  'user.title.unfilled': '未填写',
  'user.title.notCertified': '未认证',
  'user.title.gender': '性别',
  'user.title.userInfoExcel': '会员信息报表.xls',
  'user.title.riskControlLevel': '风控等级',
  'user.title.dateEnrollment': '注册日期',
  'user.title.firstDepositDate': '首存日期',
  'user.title.bankCardList': '银行卡列表',
  'user.title.unBinding': '解除绑定',
  'user.title.confirmUnBinding': '请确认解除绑定?',
  'user.title.confirmEnableBankCard': '请确认启用该银行卡?',
  'user.title.isDisable': '是否禁用',
  'user.title.confirmDisableBankCard': '请确认禁用该银行卡?',
  'user.title.bankRelated': '银行相关',
  'user.title.bankCode': '银行代码',
  'user.title.accountRelated': '账户相关',
  'user.title.unbindingAll': '全部解绑',
  'user.title.confirmUnbindingAllCard': '注意：此操作后，将解绑属于该用户的所有银行卡。',
  'user.title.changeUpperAgent': '修改上级代理',
  'user.title.oldAgent': '原代理',
  'user.title.newAgent': '新代理',
  'user.title.newAgentAccount': '新代理账号',
  'user.title.deviceRelateUser': '登录同设备关联用户',
  'user.title.devicId': '设备ID',
  'user.title.devicIdAppType': '设备来源',
  'user.title.devicTime': '关联时间',
  'user.title.relateUser': '关联用户',
  'user.title.relateUserNum': '关联用户账号数量',
  'user.title.emailAuthentication': '邮箱认证',
  'user.title.newMail': '新邮箱',
  'user.title.oldMail': '旧邮箱',
  'user.title.lockFundsList': '锁定资金列表',
  'user.title.bonusLock': '优惠锁定',
  'user.title.depositLock': '存款锁定',
  'user.title.confirmOffer': '请确认是否发放?',
  'user.title.confirmRejectApply': '请确认拒绝此优惠申请?',
  'user.title.confirmCancel': '确认解锁',
  'user.title.confirmCancelBonus': '请确认解锁此优惠?',
  'user.title.baseBonus': '优惠本金',
  'user.title.lockAmount': '锁定金额',
  'user.title.getBonusTime': '优惠领取时间',
  'user.title.flowCompletionProgress': '流水完成进度',
  'user.title.completedFlow': '已完成流水',
  'user.title.targetFlow': '目标流水',
  'user.title.confirmUnlockDeposit': '请确认解除该存款锁定?',
  'user.title.inviteUserRecordList': '邀请会员记录列表',
  'user.title.getBonus': '优惠领取',
  'user.title.loginIpRelateUser': '登录Ip关联用户',
  'user.title.verifiedName': '实名认证',
  'user.title.realName': '真实姓名',
  'user.title.newRealName': '新真实姓名',
  'user.title.newIdNo': '新身份证号',
  'user.title.oldRealName': '旧真实姓名',
  'user.title.oldIdNo': '旧身份证号码',
  'user.title.idNo2': '身份证号码',
  'user.title.realName1': '请输入正确的真实姓名',
  'user.title.idNo1': '请输入正确的身份证号码',
  'user.title.verifyPhone': '手机认证',
  'user.title.phoneNumber': '手机号',
  'user.title.newPhoneNumber': '新手机号',
  'user.title.oldPhoneNumber': '旧手机号',
  'user.title.phoneNumber1': '请输入正确的手机号',

  'user.title.aliPayAccount': '支付宝用户名',
  'user.title.alipayPhone': '支付宝手机号',
  'user.title.alipayEmail': '支付宝邮箱',
  'user.title.alipayRealName': '支付宝真实姓名',
  'user.title.delAlipay': '删除支付宝账号',
  'user.title.askDelAlipay': '请确认删除支付宝账号',
  'user.title.confirmUnbindingAllAliPay': '注意：此操作后，将解绑属于该用户的所有支付宝账号。',
  'user.title.confirmUnbindingAllUSDT': '注意：此操作后，将解绑属于该用户的所有USDT账号。',
  'user.title.confirmUnbindingAllVirtual': '注意：此操作后，将解绑属于该用户的所有虚拟币账号。',
  'user.title.delUSDT': '删除USDT地址',
  'user.title.askDelUSDT': '请确认删除USDT地址?',


  'user.title.getAccountBalanceFail': '获取账户金额失败。',
  'user.title.getAccountBalanceError': '获取账户金额错误。',
  'user.title.getBackSuccess': '取回成功',
  'user.title.batchGetBack': '批量取回中，请稍候查看账户余额。',
  'user.title.getBackFail': '取回失败',
  'user.title.getBackError': '取回错误',
  'user.title.refreshSuccess': '刷新成功',
  'user.title.refreshFail': '刷新失败',
  'user.title.refreshError': '刷新错误',
  'user.title.accountInfo': '账户信息（单位:元）',
  'user.title.accountInfoVN': '账户信息（单位:VND）',
  'user.title.getBackAll': '全取回',
  'user.title.refreshAll': '全刷新',
  'user.title.totalBalance': '总余额',
  'user.title.mainAccount': '主账户',
  'user.title.detail': '详情',
  'user.title.refresh': '刷新',
  'user.title.money': '元',
  'user.title.moneyVN': 'VND',
  'user.title.point': '积分',
  'user.title.requestTimeAndOfferTime': '申请时间|发放时间',
  'user.title.bonusContent': '优惠内容',
  'user.title.bonusType': '优惠类型',
  'user.title.offerAdmin': '发放人',
  'user.title.resetWithdrawalPass': '重置提款密码',
  'user.title.inviteRecord': '邀请记录',
  'user.title.relatedDevice': '关联设备',
  'user.title.relateIP': '关联IP',
  'user.title.bankCard': '银行卡',
  'user.title.noeLogin': '没有登录过的',
  'user.title.relate': '关联的',
  'user.title.noBindingBankCard': '没有绑定银行卡',
  'user.title.relateBankCard': '关联银行卡',
  'user.title.device': '设备',
  'user.title.female': '女性',
  'user.title.male': '男性',
  'user.title.unverifiedID': '身份未认证',
  'user.title.verifiedMail': '邮箱已认证',
  'user.title.unverifiedMail': '邮箱未认证',
  'user.title.verifiedPhone': '手机已认证',
  'user.title.unVerifiedPhone': '手机未认证',
  'user.title.mobilePhoneAttribution': '手机归属地',
  'user.title.confirmResetUserPass': '确认要重置用户密码，重置后用户登录需要用新密码？',
  'user.title.confirmResetUserWithdrawal': '确认要重置用户的提款密码?',
  'user.title.confirmChangeSourceToRegister': '是否删除会员来源代理,改为自己注册？',
  'user.title.noneSet': '未设置',
  'user.title.cancelAgent': '撤销代理',
  'user.title.playerInviteCode': '玩家邀请码',
  'user.title.invited': '，已邀请：',
  'user.title.playerInvite': '玩家邀请',
  'user.title.noneInvitedRecord': '暂无邀请记录',
  'user.title.noneLoginRecord': '暂时还未登录',
  'user.title.changeRegisterSource': '修改注册来源',
  'user.title.registerSource': '注册来源',
  'user.title.signPoint': '签到积分',
  'user.title.userRiskLevel': '风控等级',
  'user.title.userLevel1': '会员等级',
  'user.title.userLevelShow': '{vipLevel}级',
  'user.title.expireDate': '到期时间',
  'user.title.permanent': '永久有效',
  'user.title.totalManualTransfer': '总手工调账',
  'user.title.wechat': '微信',
  'user.title.loginTimes': '登录9999{loginCount}次',
  'user.title.pointChange': '积分变化',
  'user.title.remarkCount': '共有{length}条备注',
  'user.title.riskDetail': '风控详情',
  'user.title.getRiskInfoFail': '获取风控信息失败。',
  'user.title.getRiskInfoError': '获取风控信息错误。',
  'user.title.transactionTime': '交易时间',
  'user.title.addBonusError': '添加优惠错误',
  'user.title.addBonusSuccess': '添加优惠成功',
  'user.title.addBonus': '添加优惠',
  'user.title.bonusName1': '请输入优惠名称',
  'user.title.bonusName2': '请输入需要多少目标流水可提现',
  'user.title.withdrawTargetFlow': '可提现目标流水',
  'user.title.orderNo': '请输入订单号',
  'user.title.processingFail': '处理失败，请稍候再试',
  'user.title.adjustedLevelSuccess': '调整等级成功！',
  'user.title.adjustedLevelFail': '调整等级失败',
  'user.title.adjustedLevelError': '调整等级错误',
  'user.title.liuheLevel': '六合等级',
  'user.title.adjustLiuheLevel': '调整会员六合等级',
  'user.title.liuheLevel1': '请选择六合等级',
  'user.title.adjustUserLevel': '调整会员等级',
  'user.title.adjustAccountPointSuccess': '调整账户积分成功，调整后积分：',
  'user.title.adjustAccountPointFail': '调整账户积分失败',
  'user.title.adjustAccountPointError': '调整账户积分错误',
  'user.title.pointAdjust': '积分调整',
  'user.title.changePoint': '加减积分',
  'user.title.changePoint1': '请输入要加减的积分',
  'user.title.changedPoint': '加减的积分',
  'user.title.showColor': '显示颜色',
  'user.title.showColor1': '请选择显示颜色',
  'user.title.defaultBlack': '黑色(默认)',
  'user.title.red': '红色',
  'user.title.blue': '蓝色',
  'user.title.green': '绿色',
  'user.title.riskLevel1': '请选择风险等级',
  'user.title.adjustedRiskLevel': '调整风险等级',
  'user.title.noneBindingMail': '用户邮箱未绑定',
  'user.title.sendMailSuccess': '发送邮件成功',
  'user.title.sendMailFail': '发送邮件失败',
  'user.title.sendMailError': '发送邮件错误',
  'user.title.loadTemplateFail': '加载模板失败',
  'user.title.loadTemplateError': '加载模板错误',
  'user.title.sendMail': '发邮件',
  'user.title.sendMail1': '发送邮件',
  'user.title.optionalTemplate': '可选模板',
  'user.title.mailTitle': '邮件标题',
  'user.title.mailTitle1': '请输入邮件标题',
  'user.title.mailContent': '邮件内容',
  'user.title.mailContent1': '请输入邮件内容',
  'user.title.sendSiteTextSuccess': '发送站内信成功',
  'user.title.sendSiteTextFail': '发送站内信失败',
  'user.title.sendSiteTextError': '发送站内信错误',
  'user.title.sendSiteText': '发送站内信',
  'user.title.siteText': '站内信',
  'user.title.missOrder': '支付掉单可前往 会员管理-充值订单管理 人工确认。',
  'user.title.countIn': '计入存提',
  'user.title.loadingUserInfoFail': '加载用户信息失败',
  'user.title.loadingUserInfoError': '加载用户信息错误',
  'user.title.orderName1': '请输入订单名称，如不输入将使用默认值',
  'user.title.orderName': '订单编号',
  'user.title.orderName2': '请输入订单编号',
  'user.title.unbindingSeatNumber': '未绑定坐席号，请绑定坐席号再操作',
  'user.title.recentMainAccountTran': '近期主账户交易',
  'user.title.last7DayBet': '近七日投注',
  'user.title.bonusBonus': '优惠优惠',
  'user.title.userPoint': '会员积分',
  'user.title.operateLog': '操作日志',
  'user.title.allUser': '所有用户',
  'user.title.depositRate': '存款率',
  'user.title.depositRate1': '存款率：存款用户/总用户',
  'user.title.depositUserComposition': '存款用户构成',
  'user.title.depositAmount': '存款金额（当天）',
  'user.title.totalDepositCount': '总存款次数',
  'user.title.totalDepositAmount': '总存款金额',
  'user.title.senderRecipientTitle': '发件人/收件人/标题',
  'user.title.recipient': '收件人',
  'user.title.sender': '发件人',
  'user.title.registerAndFirstAndLastLoginTime': '注册登录存款信息',
  'user.title.unDeposit': '未存款',
  'user.title.totalDepositTotalWithdrawal': '总存总提',
  'user.title.realNamePhoneMail': '实名|手机|邮箱',
  'user.title.userListExcel': '会员列表报表.xls',
  'user.title.friendsInvite': '好友邀请',
  'user.title.minDepositCount': '最小存款次数',
  'user.title.maxDepositCount': '最大存款次数',
  'user.title.depositCount': '存款次数',
  'user.title.minDepositAmount': '最小存款金额',
  'user.title.maxDepositAmount': '最大存款金额',
  'user.title.depositAmount1': '存款金额',
  'user.title.resultExport': '结果导出',
  'user.title.firstDepositRate': '首存率',
  'user.title.firstDepositRate1': '首存率：首存用户/新增用户',
  'user.title.rate': '比率',
  'user.title.7DaysLost': '7天流失：连续7天没有登录的用户',
  'user.title.14DaysLost': '14天流失：连续14天没有登录的用户',
  'user.title.30DaysLost': '30天流失：连续30天没有登录的用户',
  'user.title.7DaysLostAndBack': '回流用户：7天流失的用户并且在时间段内登录的用户',
  'user.title.lostAndUserCount': '流失率：流失用户/总用户',
  'user.title.lostBackAndTotalLost': '回流率：回流用户/总流失用户',
  'user.title.7DaysLost1': '7天流失',
  'user.title.14DaysLost1': '14天流失',
  'user.title.30DaysLost1': '30天流失',
  'user.title.lostAndLostBack': '流失与回流用户',
  'user.title.lostAndLostBack1': '流失率与回流率',
  'user.title.lostUser': '流失用户',
  'user.title.lostBackUser': '回流用户',
  'user.title.lostRate': '流失率',
  'user.title.lostBackRate': '回流率',
  'user.title.newUserCount': '新增用户数',
  'user.title.silentUserCount': '沉默用户数',
  'user.title.silentUser90Days': '沉默用户：连续{days}天没登录的用户',
  'user.title.silentUserRate': '沉默用户比例：沉默用户/总用户',
  'user.title.silentUserRate1': '沉默用户比例',
  'user.title.absoluteValue': '绝对值',
  'user.title.retentionRate': '留存率',
  'user.title.dayAfter': '天后',
  'user.title.weekAfter': '周后',
  'user.title.monthAfter': '月后',
  'user.title.retentionUser': '留存用户：新增的用户进行了存款称为留存用户',
  'agent.export.agentReportExcel': '代理报表.xls',
  'user.title.from': '从',
  'user.title.to': '到',
  'user.title.last7': '过去7天',
  'user.title.last30': '过去30天',
  'user.title.last60': '过去60天',
  'user.title.queryType': '查询类型',
  'user.title.registerSelf': '自己注册',
  'user.title.registerAgent': '代理渠道',
  'user.title.channelSource': '渠道来源',
  'user.title.giveRequire': '派发限制',
  'game.title.changeGamePlatformSign': '修改游戏平台标识',
  'game.title.signType': '标识类型',
  'game.title.hotSignType': '热门标识类型',
  'game.title.signStatus': '标识状态',
  'game.title.hotSignStatus': '热门标识状态',
  'game.title.changeStatus_0': '标识禁用',
  'game.title.changeStatus_1': '标识启用',
  'game.title.changeStatus_01': '热门标识禁用',
  'game.title.changeStatus_10': '热门标识启用',

  // assetsBalanceLog
  'common.finance.autoTransferOutGame': '自动从游戏转出{platformName}',
  'admin.pay.manualDepositWithDrawals': '人工存提',
  'admin.finance.rejectWithdrawals': '拒绝提现',
  'admin.finance.rejectWithdrawalsReason': '申请提现被拒绝，被减余额返回',
  'admin.finance.recharge': '充值',
  'common.bonus.bonusToGame': '{fullName}红利自动转入游戏',
  'common.bonus.issueBonus': '{fullName}发放红利',
  'common.finance.customerServiceManualTransfer': '客服手工调账,{userName}',
  'common.finance.bonusAprove': '{userName}审批,{bonusName}',
  'admin.bonus.realTimeDepositBonus': '实时存款返利,{date}',
  'admin.bonus.remittanceChannelBonus': '汇款渠道红利,{date}',
  'admin.bonus.dividends': '派彩红利,{date}',
  'common.bonus.inviteBonus': '邀请红利,{date}',
  'common.bonus.signDrawBonus': '签到抽奖红利,{date}',
  'common.bonus.continuousDepositDrawBonus': '连续存款抽奖红利,{date}',
  'common.bonus.continuousDepositPointsBonus': '连续存款积分红利,{date}',
  'common.bonus.flowRebate': '{type}流水返利,{date}',
  'common.bonus.betBonus': '{type}投注红利,{date}',
  'common.bonus.rescueFundBonus': '救援金,{date}',
  'common.bonus.activityType1Prize': '幸运大转盘奖品',
  'common.bonus.activityType2Prize': '摇一摇奖品',
  'common.bonus.activityType4Prize': '盲盒奖品',
  'common.bonus.activityType5Prize': '现金大转盘奖品',
  'common.bonus.alwaysRebate': '{gametype}时时流水返利{date}',
  'common.bonus.signPointsBonus2': '{userAccount}签到积分红利,{date}',
  'front.bonus.noteBonus': '注单红利',
  'front.bonus.memberInfoBindingBonus': '会员信息绑定红利',
  'front.bonus.agentRegisterBonus': '通过代理注册赠送注册优惠',
  'front.bonus.depositBonus': '存款红利',
  'front.bonus.upgradeReward': '{bonusName}-升级奖励',
  'front.bonus.weekReward': '{bonusName}-周俸禄奖励',
  'front.bonus.monthReward': '{bonusName}-月俸禄奖励',
  'front.bonus.customerServiceRetrieval': '客服取回{platformCode}',
  'admin.finance.assetsAccountMsg1': '客服补单,从游戏取回失败,{platformCode}',
  'admin.finance.assetsAccountMsg2': '客服补单,转入游戏失败,{platformCode}',
  'front.bonus.customerServiceBatchRetrieval': '客服批量取回{platformKey}',
  'front.bonus.autoReplenishment1': '自动补单,从游戏取回失败，{platformCode}',
  'front.bonus.autoReplenishment2': '自动补单,转入游戏失败，{platformCode}',
  'common.finance.autoTransferInGame': '自动转入游戏{platformName}',
  'front.pay.applyForWithdrawal': '申请提现',
  'front.pay.applyForWithdrawalMinusAmount': '申请提现减去金额',
  'common.bonus.addBonusesBackground': '后台添加红利:{name}',
  'constants.gameLottery4_GW': 'GW世彩',
  'constants.gameLottery4_PMCP': 'PM彩票',
  'constants.gameLottery4_DBCP': 'DBCP彩票',
  'constants.gameLottery4_NEWDB': 'NEWDB彩票',
  'constants.gameLottery4_TP': 'TP',
  'constants.gameLottery4_BBIN': 'BBIN',
  'constants.gameLottery4_DB': 'DB彩票',

  'constants.gameLottery4_QQK': 'QQKeno 彩票',
  'constants.gameLottery4_FG': 'Funky Games 彩票',
  'constants.gameLottery4_SEA': 'Sealotto 彩票',
  'constants.gameLottery4_YESB': 'YES BINGO 彩票',

  'constants.gameChess6_DGC': 'DG棋牌',
  'sys.bonus.domain.type': '是否限制域名',
  'sys.bonus.domain.type.prompt': '限制域名不能为空',
  'sys.bonus.domain.noLimited': '无限制',
  'sys.bonus.domain.Limited': '限制域名',
  'sys.bonus.domain.input.prompt': '域名列表(逗号分隔)',
  'sys.bonus.domain.nullPrompt': '请输入域名',
  'sys.bonus.domain.input.maxPrompt': '最大长度256，请勿超出',
  'sys.bonus.domain.prompt': '请输入赠送的域名(顶级域名即可)；如：baidu.com,baidutwo.com',
  'front.bonus.selfRegisterBonus': '通过自己注册赠送注册优惠',
  'sys.frontMatch.matchName': '赛事名称',
  'sys.frontMatch.hTeam': '主队名称',
  'sys.frontMatch.hTeamLogo': '主队图标',
  'sys.frontMatch.gTeam': '客队名称',
  'sys.frontMatch.gTeamLogo': '客队图标',
  'sys.frontMatch.jumpUrl': '跳转地址',
  'sys.frontMatch.insertMatch': '新增赛事',
  'sys.frontMatch.updateMatch': '修改赛事',
  'sys.bonus.refuseMessage': '拒绝信息',
  'sys.bonus.signInOnlyExistOn': '该优惠只能设置一条。',
  'sys.validit.joinUserLevel': '可参与会员等级',
  'sys.validit.pleaseSelectJoinUserLevel': '请选择可参与活动的会员最低等级',
  'sys.signInCnd': '签到条件',
  'sys.signInDay': '天',
  'sys.signInTotalDeposit': '累计存款金额',
  'sys.signInOneDeposit': '单笔存款金额',
  'sys.signInGiveAmount': '奖励金额',
  'sys.signInGivePoint': '奖励积分',
  'sys.signInBetflowMultiple': '流水倍数',
  'sys.signInOtherAmount': '额外奖金',
  'sys.signInOtherPoint': '额外积分',
  'sys.signInTotalBetflowCnd': '有效投注额',
  'sys.pcPicH5SmallPic': 'PC/H5小图标',
  'sys.pcSmallPic': 'PC小图标',
  'sys.h5SmallPic': 'H5小图标',
  'sys.addGame': '添加游戏',
  'sys.select.gameList': '请选择游戏',
  'sys.edit.popular': '修改热门信息',
  'sys.popularType': '热门类型',
  'user.title.signName': '标签名称',
  'user.title.signName1': '请输入标签名称',
  'user.title.addMemberSign': '新增会员标签',
  'common.button.addMemberSign': '添加会员标签',
  'sys.title.deleteMemberSignName': '即将删除的会员标签：{signName}',
  'sys.lengthLimit5': '最多输入7个汉字',
  'user.button.markMember': '标记用户',
  'user.title.noneSign': '当前暂无可选标签，请前往会员标签页面添加标签',
  'user.msg.markMember': '标记成功',
  'user.msg.markMember1': '标记失败',
  'user.title.memberSign': '所属标签',
  'user.title.memberSign2': '所属标签|所属会员组',
  'user.title.memberSign3': '会员APP属性|会员直播属性',
  'user.title.memberGroup': '会员组',
  'sys.cellphoneNumber4': '请输入越南手机号',
  'constants.gameChess6_BL': '博乐棋牌/电子',
  'constants.gameChess6_HQT': 'HQT棋牌',
  'constants.gameSlot1_AWS': 'AWS电子',
  'sys.rateBonus.allStatus': '全部',
  'sys.rateBonus.create': '新增方案',
  'sys.rateTable.amountLimit': '单笔限额',
  'sys.rateTable.totalRate': '总利率',
  'sys.rateTable.programCycle': '方案结算周期',
  'sys.rateTable.scheduleCycle': '方案周期',
  'sys.rateTable.settlementCycle': '结算周期',
  'sys.rateTable.timeType': '小时',
  'sys.rateTable.rateLimit': '利息上限',
  'sys.rateTable.needBetflow': '流水要求',
  'sys.rateTable.capital': '本金',
  'sys.rateTable.rate': '利息',
  'sys.rateTable.multiple': '倍',
  'sys.rateTable.settlement': '销售状况',
  'sys.rateTable.totalStock': '总份额',
  'sys.rateTable.selled': '已售',
  'sys.rateTable.going': '计息',
  'sys.rateTable.edit': '编辑中',
  'sys.rateTable.market': '上架',
  'sys.rateTable.takeOff': '下架',
  'sys.rateTable.sort': '排序',
  'sys.singleTime': '单笔纪录',
  'sys.accumulative': '累计纪录',
  'bonus.rateTitle.createBalanceRate': '新增余额宝方案',
  'bonus.rateTitle.editBalanceRate': '编辑余额宝方案',
  'bonus.rateTitle.bonusName': '方案名称',
  'bonus.rateTitle.bonusName1': '请输入方案名称',
  'bonus.rateTitle.sort': '顺序',
  'bonus.rateTitle.sort1': '请输入顺序',
  'bonus.rateTitle.minBuyAmount': '最低购买金额',
  'bonus.rateTitle.minBuyAmount1': '请输入最低购买所需金额',
  'bonus.rateTitle.maxBuyAmount': '最高购买金额',
  'bonus.rateTitle.maxBuyAmount1': '请输入最高购买所需金额',
  'bonus.rateTitle.buyAmountRightNotice': '请输入正确的金额',
  'bonus.rateTitle.totalRate': '总利息(%)',
  'bonus.rateTitle.totalRate1': '请输入总利息',
  'bonus.rateTitle.settlementCycle': '结算周期(小时)',
  'bonus.rateTitle.settlementCycle1': '请输入结算周期',
  'bonus.rateTitle.settlementCycleNotice': '方案周期内，每个结算周期会发放一次利息，每个结算周期的利率为"总利率/(方案周期/结算周期)=结算周期的利率"。假设总利率3%、方案周期为24小时、结算周期为1小时，那每个结算周期会发放0.125%的利息。',
  'bonus.rateTitle.schemeCycle': '方案周期(小时)',
  'bonus.rateTitle.schemeCycle1': '请输入方案周期',
  'bonus.rateTitle.loopType': '循环计算',
  'bonus.rateTitle.loopType1': '请选择循环计算模式',
  'bonus.rateTitle.loopTypeNotice': '循环计算开启：按方案周期循环结算利息至利息上限或客户主动提领。假设周期3小时结算10元利息，第6小时继续结算直至上限或发生提领为止；循环计算关闭：该方案周期结束之后，下个周期不再进行结算。假设周期3小时结算10元利息，结算一次之后都不再结算。',
  'bonus.rateTitle.maxRateAmount': '最高利息金额',
  'bonus.rateTitle.maxRateAmount1': '请输入最高利息金额',
  'bonus.rateTitle.capitalBetflowMultiple': '本金流水倍数',
  'bonus.rateTitle.capitalBetflowMultiple1': '请输入本金提现所需的流水倍数',
  'bonus.rateTitle.rateBetflowMultiple': '利息流水倍数',
  'bonus.rateTitle.rateBetflowMultiple1': '请输入利息提现所需流水倍数',
  'bonus.rateTitle.totalStock': '总份数',
  'bonus.rateTitle.totalStock1': '请输入总份数',
  'bonus.rateTitle.userBuyCount': '会员可购买份数',
  'bonus.rateTitle.userBuyCount1': '请输入会员最大可购买份数',
  'bonus.rateTitle.buyAgainTime': '再次购买间隔时间(小时)',
  'bonus.rateTitle.buyAgainTime1': '请输入间隔时间',
  'bonus.rateTitle.buyUserVip': '购买所需等级',
  'bonus.rateTitle.buyUserVip1': '请选择购买所需等级',
  'sys.rateTable.deleteNotice': '还有未赎回的方案，无法删除该方案。',
  'bonus.rateMsg.buyAmountNotice': '最低购买金额不能大于最高购买金额',
  'bonus.rateMsg.scheduleNotice1': '结算周期不能大于方案周期',
  'bonus.rateMsg.scheduleNotice2': '方案周期必须能被结算周期整除',
  //admin_user_behavior
  'front.pay.adjustableWithdrawal': '调整可提现: {betFlowBalance} -> {availBalance}',
  'admin.bonus.approveBonus': '审核通过红利：{bonusName}',
  'admin.bonus.effectiveFlow': '{bonusName},设置有效流水：{validBetflow}',
  'admin.bonus.cancelBonus': '取消红利：{bonusName}',
  'admin.bonus.rejectBonus': '拒绝红利：{bonusName}',
  //assets_bonus_log
  'common.bonus.playerManuallyApply': '玩家手动申请: {userAccount}',
  'front.bonus.extraBonus': '玩家签到额外红利: {userAccount}',
  'front.bonus.redeemPointsManually': '玩家手动签到积分兑换: {0}',
  'front.bonus.continuousDepositBonus': '连续存款红利',
  'front.bonus.checkInBonus': '签到红利',
  'front.bonus.invitationBonus': '邀请红利',
  //bonus_article_info
  'admin.bonus.bounusCopy': '{articleName}（复制）',
  //bonus_import_info
  'admin.bonus.uploadNoticeError': '第 {num} 行; 参数错误，请仔细核对。',
  'common.userAccountNotExist4': '用户不存在',
  //msg_site
  'admin.bonus.bonusArrivalNotice': '【{bonusName}】红利到账通知!',
  'admin.bonus.bonusArrivalNotice1': '您好，您的{bonusName}红利已到账，金额: {bonusAmount}元，请注意查收。',
  'admin.msg.withDrawalsApproveNotice': '您的取款申请{amount}已经审核成功',
  'admin.msg.wihtDrawalsPayoutNotice': '您于{date}申请的取款,目前已经通过审核,其中取款申请={amount1},(您承担手续费={amount2}.实际取款={amount3}).已经审核通过出款,请您稍后查收,谢谢您的参与,有任何问题请随时和我们联系.',
  'common.msg.withDrawalsSuccess': '您的取款申请{amount}已经出款至您的银行卡',
  'common.msg.withDrawalsSuccessNotice': '出款金额={amount},已经出款至您的银行卡,请查收.谢谢您的参与,有任何问题随时与我们联系',
  'common.msg.withDrawalsSuccess1': '您的取款申请{amount}已经出款至您的usdt账户',
  'common.msg.withDrawalsSuccessNotice1': '出款金额={amount},已经出款至您的usdt账户,请查收.谢谢您的参与,有任何问题随时与我们联系',
  'common.msg.withDrawalsSuccess2': '您的取款申请{amount}已经出款至您的支付宝账户',
  'common.msg.withDrawalsSuccessNotice2': '出款金额={amount},已经出款至您的支付宝账户,请查收.谢谢您的参与,有任何问题随时与我们联系',
  'common.msg.vipPayWithDrawalsSuccess': '您的取款申请{amount}已经出款至您的v币钱包',
  'common.msg.vipPayWithDrawalsSuccessNotice': '出款金额={amount},已经出款至您的v币钱包,请查收.谢谢您的参与,有任何问题随时与我们联系',
  'common.msg.goPayWithDrawalsSuccess': '您的取款申请{amount}已经出款至您的G币钱包',
  'common.msg.goPayWithDrawalsSuccessNotice': '出款金额={amount},已经出款至您的G币钱包,请查收.谢谢您的参与,有任何问题随时与我们联系',
  'common.msg.ebPayWithDrawalsSuccess': '您的取款申请{amount}已经出款至您的E币钱包',
  'common.msg.ebPayWithDrawalsSuccessNotice': '出款金额={amount},已经出款至您的E币钱包,请查收.谢谢您的参与,有任何问题随时与我们联系',
  'common.msg.YBFPayWithDrawalsSuccess': '您的取款申请{amount}已经出款至您的易币付钱包',
  'common.msg.YBFPayWithDrawalsSuccessNotice': '出款金额={amount},已经出款至您的易币付钱包,请查收.谢谢您的参与,有任何问题随时与我们联系',
  'common.msg.kdPayWithDrawalsSuccess': '您的取款申请{amount}已经出款至您的K豆钱包',
  'common.msg.kdPayWithDrawalsSuccessNotice': '出款金额={amount},已经出款至您的K豆钱包,请查收.谢谢您的参与,有任何问题随时与我们联系',
  'common.msg.cbPayWithDrawalsSuccess': '您的取款申请{amount}已经出款至您的C币钱包',
  'common.msg.cbPayWithDrawalsSuccessNotice': '出款金额={amount},已经出款至您的C币钱包,请查收.谢谢您的参与,有任何问题随时与我们联系',
  'common.msg.okPayWithDrawalsSuccess': '您的取款申请{amount}已经出款至您的OK币钱包',
  'common.msg.okPayWithDrawalsSuccessNotice': '出款金额={amount},已经出款至您的OK币钱包,请查收.谢谢您的参与,有任何问题随时与我们联系',
  'common.msg.jdPayWithDrawalsSuccess': '您的取款申请{amount}已经出款至您的JD钱包',
  'common.msg.jdPayWithDrawalsSuccessNotice': '出款金额={amount},已经出款至您的JD钱包,请查收.谢谢您的参与,有任何问题随时与我们联系',
  'common.msg.gcashWithDrawalsSuccess': '您的取款申请{amount}已经出款至您的GCASH账户',
  'common.msg.gcashWithDrawalsSuccessNotice': '出款金额={amount},已经出款至您的GCASH账户,请查收.谢谢您的参与,有任何问题随时与我们联系',
  'common.msg.payMayaWithDrawalsSuccess': '您的取款申请{amount}已经出款至您的PayMaya账户',
  'common.msg.payMayaWithDrawalsSuccessNotice': '出款金额={amount},已经出款至您的PayMaya账户,请查收.谢谢您的参与,有任何问题随时与我们联系',
  'common.msg.grabPayWithDrawalsSuccess': '您的取款申请{amount}已经出款至您的GrabPay账户',
  'common.msg.grabPayWithDrawalsSuccessNotice': '出款金额={amount},已经出款至您的GrabPay账户,请查收.谢谢您的参与,有任何问题随时与我们联系',
  'common.msg.wechatWithDrawalsSuccess': '您的取款申请{amount}已经出款至您的微信账户',
  'common.msg.wechatWithDrawalsSuccessNotice': '出款金额={amount},已经出款至您的微信账户,请查收.谢谢您的参与,有任何问题随时与我们联系',
  'common.msg.808PayWithDrawalsSuccess': '您的取款申请{amount}已经出款至您的808钱包',
  'common.msg.808PayWithDrawalsSuccessNotice': '出款金额={amount},已经出款至您的808钱包,请查收.谢谢您的参与,有任何问题随时与我们联系',
  //notice_record
  'admin.msg.riskControlApproveNotice': '(风控操作)用户{userAccount}申请提现{amount}元,已由{userName}审批通过,财务可进行审核了',
  'admin.msg.manualConfirmRechargeNotice': '(财务操作)用户{userAccount}充值{orderAmount}元，由{userName}手工确认',
  'admin.msg.riskControlRejectNotice': '(风控操作)用户{userAccount}申请提现{amount}元，已被{userName}拒绝',
  'admin.msg.financeRejectWithdrawalsNotice': '(财务操作)用户{userAccount}申请提现{amount}元，已被{userName}拒绝',
  'admin.msg.financeApproveNotice': '(财务操作)用户{userAccount}申请提现{amount}元，已由{userName}出款',
  'admin.msg.financePayforTimeoutNotice': '(财务操作)用户{userAccount}申请提现{amount}元，已由{userName}同意，{payName}代付请求超时，请核对代付平台订单状态',
  'admin.msg.financePayforExceptionNotice': '(财务操作)用户{userAccount}申请提现{amount}元，已由{userName}同意，{payName}代付请求异常，请核对代付平台订单状态',
  'admin.msg.financePayforFailNotice': '(财务操作)用户{userAccount}申请提现{amount}元，已由{userName}同意，{payName}代付请求失败：{message}，请核对代付平台订单状态',
  'admin.msg.financePayforSuccess': '(财务操作)用户{userAccount}申请提现{amount}元，已由{userName}同意，{payName}代付出款中',
  'admin.msg.financePayforSuccess1': '(财务操作)用户{userAccount}申请提现{amount}元，已由{channel}代付出款成功',
  'admin.msg.financePayforFail': '(财务操作)用户{userAccount}申请提现{amount}元，{channel}代付出款失败',
  'admin.msg.paymentSuccessRate1': '财务操作)支付方式：{payRemark}，支付渠道：{viewName}，支付成功率：{successRate}，低于预警成功率。请注意控制。',
  'admin.msg.paymentSuccessRate2': '财务操作)支付方式：{payRemark}，支付渠道：{viewName}，支付成功率：{successRate}，低于预警成功率。该支付方式已被自动禁用。请注意查看。',
  'admin.msg.companyDeposit': '(财务操作)玩家: {userAccount},申请公司入款{amount}元，订单号: {orderNo}',
  'front.finance.windControlAudit': '(风控)用户{account}申请提现{amount}元，请风控审核。',
  'front.finance.rechargeSuccess': '(系统)用户{userAccount}充值{orderAmount}元成功。',
  'admin.msg.financePayforManualFail': '(财务操作)用户{userAccount}申请提现{amount}元，已由{userName}手工置为代付出款失败',
  'admin.msg.deposit': '(财务操作)玩家: {userAccount},申请入款{amount}元，订单号: {orderNo}',
  //log_export
  'admin.sys.ftpPathError': 'FTP 路径创建错误',
  'admin.sys.ftpReaptFileError': '文件已经存在，重新生成错误',
  //sms_name_verify_log
  'admin.msg.realNameName': '实名名称：{userName}',
  //user_remark
  'admin.finance.withdrawals': '提现',
  //assets_deposit
  'admin.pay.manualTransfer': '手工调账',
  'admin.pay.manualDeposit': '人工存入',
  'admin.pay.manualTransferRemoval': '手工调账，人工取出: {userName}',
  'admin.pay.depositType': '存款类型',
  'sys.registerMember': '非代理会员',
  'admin.pay.deletePayment': '请先禁用再进行删除！',
  'bonus.buyRecord.buyTime': '购买时间',
  'bonus.buyRecord.ransomTime': '赎回时间',
  'bonus.buyRecord.status_1': '计息中',
  'bonus.buyRecord.status_2': '待赎回',
  'bonus.buyRecord.status_3': '已赎回',
  'bonus.buyRecordTable.bonusName': '方案名称',
  'bonus.buyRecordTable.programAmount': '方案金额',
  'bonus.buyRecordTable.captipleAmount': '本金',
  'bonus.buyRecordTable.rateAmount': '利息',
  'bonus.buyRecordTable.programSchedule': '方案计划',
  'bonus.buyRecordTable.schemeCycle': '方案周期：{schemeCycle}小时',
  'bonus.buyRecordTable.settlementCycle': '结算周期：{settlementCycle}小时',
  'bonus.buyRecordTable.loopType': '循环方式',
  'bonus.buyRecordTable.status': '状态',
  'bonus.buyRecordTable.status_1': '计息中',
  'bonus.buyRecordTable.status_2': '待赎回',
  'bonus.buyRecordTable.status_3': '已赎回',
  'bonus.buyRecordTable.time': '时间',
  'bonus.buyRecordTable.buyTime': '购买时间',
  'bonus.buyRecordTable.ransomTime': '赎回时间',
  'bonus.buyRecordTable.finishTime': '计息结束时间',
  'bonus.buyRecordTable.ransomAdmin': '赎回人',
  'bonus.buyRecordTable.operate': '操作',
  'bonus.buyRecordTable.forceRansom': '强制赎回',
  'bonus.buyRecordTable.capitalBetflowMultiple': '本金赎回流水要求：{capitalBetflowMultiple}',
  'bonus.buyRecordTable.rateBetflowMultiple': '利息赎回流水要求：{rateBetflowMultiple}',
  'bonus.buyRecordTable.maxRateAmount': '最大利息金额：{maxRateAmount}',
  'bonus.buyRecordTable.confirmForceRansomMsg': '确认提示',
  'bonus.buyRecordTable.confirmForceRansom': '确认是否强制赎回该方案？',
  'sys.title.bonusArtId': '文章ID',
  'sys.title.onlinePay': '线上支付',
  'sys.title.offlinePay': '线下支付',
  'sys.title.officePay': '公司入款',

  'pay.earlyWarning.addEarlyWarning': '添加预警',
  'pay.earlyWarning.earlyWarningThreshold': '预警阈值',
  'pay.earlyWarning.earlyWarningThreshold1': '请输入预警阈值',
  'pay.earlyWarning.editEarlyWarning': '填写预警信息',
  'pay.earlyWarning.successRoteEarlyWarning': "渠道成功率报警",
  'admin.finance.payEarlyWarningNotify': "{customizeName}当前成功率{earlyWarningSuccessRate}%,低于{earlyWarningThreshold}%,请及时查看",
  'user.userChangeParentAgent': "更改上级代理",
  'user.userChangeParentAgent1': "请选择会员进行更改上级代理",
  'user.addTHAUser': '新增用户',
  'user.addTHAUser.withdrawPassword': "提款密码",
  'user.addTHAUser.agentCode': "代理编号",
  'user.phoneIsValid': '号码是否验证',
  'user.updateBank': "银行信息",
  'finance.payGroup.remark': "支付说明",
  'finance.payGroup.addRemark': "添加支付说明",
  'finance.payGroup.externalLinkAmountRange': "外链金额范围显示",
  'user.member.signMember': '会员标签',
  'sys.title.deleteFail': '删除失败,请重试',
  'user.title.realtimeListExcel': '会员实时统计报表.xls',
  'admin.withdraw.currentChannelDisable': '当前通道已禁用，请使用其他通道',
  'withdraw.loadConfigInfoFail': '加载代付配置信息失败',
  'withdraw.loadConfigInfoError': '加载支付配置信息失败error',
  'withdraw.label.withdrawChannel': '代付渠道',
  'withdraw.label.withdrawChannel1': '请选择代付渠道',
  'withdraw.label.Code': '三方代号',
  'withdraw.channel.submit.title.prompt': '提交代付渠道',
  'withdraw.channel.submit.content.prompt': '新增代付渠道后请填写代付渠道参数，否则代付时会出现错误！',
  'sys.bonus.editDisplaySort': '活动大厅排序',
  'sys.editSuccess': '修改排序成功！',
  'sys.editFail': '修改失败',
  'sys.editError': '修改错误',
  'user.title.currentResultAmount': '当前输赢',
  'bet.queryFrm.gameName': '游戏名称',
  'bet.queryFrm.agentName': '代理账号',
  'bet.queryFrm.betweenResultAmount': '输赢区间',
  'common.queryFrm.searchGameName': '游戏名称',
  'common.queryFrm.searchGameNameOrGameType': '游戏名称/玩法类型',
  'common.queryFrm.searchAgentName': '代理账号',
  'common.queryFrm.searchMinResultAmount': '最小输赢',
  'common.queryFrm.searchMaxResultAmount': '最大输赢',
  'constants.gameSlot1_NEWSA': '新SA',
  'constants.gameFish5_NEWSA': '新SA',
  'sys.approveLock': '审批锁定',
  'sys.confirmConsent3': '确定开始审核？',
  'sys.confirmConsent4': '是否锁定该笔提款为审核中',
  'sys.confirmConsent5': '风控锁定提示',
  'sys.confirmConsent6': '该风控记录正由{userAccount}审核,已锁定',
  'sys.confirmConsent7': '该风控记录{userAccount}审核已完成,已解锁',
  'sys.confirmConsent8': '该风控记录由管理员{userAccount}强制解锁,已解锁',
  'risk.approveLock': '审核锁定中',
  'risk.approveUnLock': '审核已解锁',
  'pay.title.adminUnlock': '管理员解锁',
  'sys.autofresh': '自动刷新',
  'sys.autofresh.none': '不刷新',
  'sys.autofresh.15s': '15秒刷新',
  'sys.autofresh.30s': '30秒刷新',
  'sys.autofresh.60s': '60秒刷新',
  'pay.title.withdrawalStatus10': '审批锁定中',
  'pay.title.withdrawalStatus11': '审批已解锁',
  'constants.riskLevelType_-5': '限制存款',
  'user.button.kickOffLine': '踢下线',
  'user.button.whetherOffline': '是否下线',
  'menu.operationalStatistics': '运营数据统计',
  'menu.killAnalysis': '杀数分析',
  'menu.discountAnalysis': '活动优惠分析',
  'member.title.regCount': '注册人数',
  'member.title.firstDepositTotal': '首存',
  'member.title.firstDepositRate': '首存率',
  'member.title.firstDepositCount': '当日总首存金额',
  'member.title.secondDepositCount': '当日2存',
  'member.title.thirdDepositCount': '当日3存',
  'member.title.fourthDepositCount': '当日4存',
  'member.title.fifthDepositCount': '当日5存',
  'member.title.depositCount': '总存款人数',
  'member.title.depositTotal1': '总存款金额',
  'member.title.withdrawalCount': '总提款人数',
  'member.title.withdrawalTotal': '总提款金额',
  'member.title.depositWithdrawalDiff': '存提差',
  'member.title.tripartitePlatformProfit': '所有三方平台盈利',
  'member.title.bonusName': '优惠活动名称',
  'member.title.attendCount': '参与人数',
  'member.title.depositTotal': '参与会员总存款',
  'member.title.withdrawTotal': '参与会员总提款',
  'member.title.profitAndLoss': '活动盈亏',
  'member.title.codeBonusAmount': '活动奖励',
  'member.title.codeBonusStrSet': '暗号设置',
  'member.title.applicationConditions': '条件',
  'member.title.luckyDrawOpportunity': '奖券获取方式',
  'member.title.raffleLife': '奖券使用期限',
  'member.title.participationRestriction': '参与条件',
  'member.extra.attendCountPage': '本页参与人数',

  'member.extra.depositTotalPage': '本页总存款(元)',
  'member.extra.depositTotalPageVN': '本页总存款(VND)',
  'member.extra.bonusTotalPage': '本页总优惠(元)',
  'member.extra.bonusTotalPageVN': '本页总优惠(VND)',
  'member.extra.withdrawTotalPage': '本页总提款(元)',
  'member.extra.withdrawTotalPageVN': '本页总提款(VND)',
  'member.extra.profitAndLossPage': '本页总活动盈亏(元)',
  'member.extra.profitAndLossPageVN': '本页总活动盈亏(VND)',
  'member.extra.attendCountTotal': '总参与人数',
  'member.extra.depositTotalTotal': '总存款(元)',
  'member.extra.depositTotalTotalVN': '总存款(VND)',
  'member.extra.bonusTotalTotal': '总优惠(元)',
  'member.extra.bonusTotalTotalVND': '总优惠(VND)',
  'member.extra.withdrawTotalTotal': '总提款(元)',
  'member.extra.withdrawTotalTotalVN': '总提款(VND)',
  'member.extra.profitAndLossTotal': '总活动盈亏(元)',
  'member.extra.profitAndLossTotalVN': '总活动盈亏(VND)',

  'member.title.platformName': '平台名称',
  'member.title.platformFlow': '当日平台流水',
  'member.title.platformWinAndLoss': '当日平台输赢',
  'member.title.betCount': '当日投注的总人数',
  'member.title.kill': '杀数',
  'member.title.addUserGroup': '添加会员组',
  'member.label.userGroupName': '会员组名称',
  'member.label.inputGroupName': '请输入会员组名称',
  'member.label.selectGroupName': '请选择会员组',
  'member.label.selectGroupName2': '正常会员',
  'member.label.selectUserId': '请先选择需要操作的会员',
  'member.title.delGroupName': '即将删除的会员组',
  'member.title.userGroupAuthManage': '会员组权限管理',
  'member.title.userLiveAttr': '会员直播属性',
  'member.label.selectUserLiveAttr': '请选择会员直播属性',
  'member.title.general': '普通会员',
  'member.title.patrol': '巡查会员',
  'member.title.live': '主播会员',
  'member.title.setUserLiveAttr': '设置会员直播属性',
  'user.title.selectChangeRiskLevel': '修改会员风控等级',
  'user.title.riskLevel.opType': '操作类型',
  'user.title.riskLevel.opType.msg': '请选择操作类型',
  'user.title.riskLevel.add': '增加',
  'user.title.riskLevel.reduce': '减少',
  'user.title.selectChangeVIPLevel': '修改会员VIP等级',
  'user.title.adjustedVipLevel': 'VIP等级调整',

  'menu.announcementList': '公告列表',
  'sys.title.pubTime': '发布时间',
  'sys.title.title': '公告标题',
  'sys.title.content': '公告内容',
  'sys.title.pubAmdin': '发布人',
  'sys.title.isRead': '是否已读',
  'sys.title.readTime': '已读时间',
  'sys.title.datePlatform': '日期/平台',
  'user.title.operationalStatisticsExcel': '运营数据统计报表.xls',
  'user.title.killAnalysisExcel': '杀数分析报表.xls',
  'user.title.discountAnalysisExcel': '优惠活动分析报表.xls',
  'user.title.countTime': '统计时间',
  'constants.payLevel1_0': '一级会员',
  'constants.payLevel1_1': '全部会员',
  'constants.payLevel1_2': '二级会员',
  'constants.payLevel1_3': '三级会员',
  'constants.payLevel1_4': '四级会员',
  'constants.payLevel1_5': '五级会员',
  'constants.payLevel1_6': '六级会员',
  'constants.payLevel1_7': '七级会员',
  'constants.payLevel1_8': '八级会员',
  'constants.payLevel1_9': '九级会员',
  'constants.payLevel1_10': '十级会员',
  'constants.payLevel1_11': '十一级会员',
  'constants.payLevel1_12': '十二级会员',
  'constants.payLevel1_13': '十三级会员',
  'constants.payLevel1_14': '十四级会员',
  'constants.payLevel1_15': '十五级会员',
  'constants.payLevel1_16': '十六级会员',
  'constants.payLevel1_17': '十七级会员',
  'constants.payLevel1_18': '十八级会员',
  'constants.payLevel1_19': '十九级会员',
  'constants.gameLive2_WM': 'WM',
  'constants.gameLive2_WE': 'WE真人',
  'constants.gameLive2_IBO': 'IBO真人',
  'constants.gameLive2_EVO': 'EVO真人',
  'constants.gameLive2_AE': 'AE真人',
  'constants.gameLive2_XG': 'XG真人',
  // 'constants.gameLive2_Evolution': 'Evolution真人',
  'constants.gameChess6_RMG': '大富翁棋牌',
  'constants.gameChess6_XSJ': '新世界棋牌',
  'constants.gameXLIVE9': '竞猜',
  'constants.gameXLIVE10': '电竞',
  'constants.gameLive9_XLIVE': '竞猜',
  'constants.gameLive10_XLIVE': '电竞',

  'constants.gameLive2_YABO': '亚博真人',
  'pay.title.ipWhite': '白名单IP',
  'pay.title.operateDetail': '操作人｜操作时间',
  'pay.add.newIpWhite': '添加白名单',
  'pay.query.keyword': '渠道名称或IP',
  'pay.label.ipWhite': '请填写白名单IP',
  'pay.setting.prompt': '提示信息',
  'pay.setting.promptDetail': '请先设置参数',
  'pay.label.tokenKeyDetail': '加密信息',
  'user.title.authRealName': '实名认证',
  'user.title.authEmail': '邮箱认证',
  'user.title.authPhone': '手机号认证',
  'user.title.registerAndLastLoginTime': '注册时间|最后登录时间',
  'sys.deposit': '充值',
  'sys.needDeposit': '需要',
  'user.title.fundOverview': '资金概况',
  'sys.registerItem.msg1': '{typeName}注册项',
  'sys.validit.length': '字段长度',
  'sys.validit.requireSwith': '是否必填',
  'constants.require.status_1': '必填',
  'constants.require.status_0': '非必填',
  'menu.operation.frontContent.RegisterItem': '注册项管理',
  'user.title.realWechat': '真实微信',
  'user.title.realQQ': '真实QQ',
  'user.title.showQQContact': '查看QQ',
  'user.title.showWechatContact': '查看微信',
  'user.title.changeQQContact': '修改QQ',
  'user.title.changeWechatContact': '修改微信',
  'user.title.oldWechat': '旧微信',
  'user.title.newWechat': '新微信',
  'user.title.oldQQ': '旧 QQ',
  'user.title.newQQ': '新 QQ',
  'user.title.pleaseEnterNewWechat': '请输入新微信账号',
  'user.title.pleaseEnterNewQQ': '请输入新QQ号码',
  'common.radio.requireTrue': '改为必填',
  'common.radio.requireFalse': '改为非必填',
  'sys.firstDepositTimeLimit': '首存时间范围限制',
  'sys.selectFirstDepositTimeLimit': '请选择首存时间范围限制',
  'menu.newSetting': 'VIP会员等级',

  'agent.SubordinateTransfer': '给下级代理或会员转账',
  'constants.agentSubordinate_0': '下级代理',
  'constants.agentSubordinate_1': '下级会员',
  'agent.subordinateTransfer_0': '请选择代理或会员',
  'agent.subordinateTransfer_1': '请选择人员',
  'agent.subordinateTransfer_2': '请输入转账金额',
  'constants.transferType_13': '上级代理手动转入',
  'common.select.beginTime': '请选择开始时间',
  'common.select.endTime': '请选择结束时间',
  'common.title.questionnaire': '问卷名称',
  'common.title.questionnaireDesc': '问卷说明',
  'common.title.respondents': '调查对象',
  'common.title.questionnaireOperate': '问卷管理操作',
  'common.title.questionOperate': '题目操作',
  'user.disableNotice1': '确认要禁用该调查问卷吗？',
  'user.enableNotice1': '确认要启用该调查问卷吗？',
  'sys.addQuestionnaire': '添加问卷',
  'sys.enterQuestionnaireTitle': '请输入问卷名称',
  'sys.enterQuestionnaireDesc': '请输入问卷说明',
  'sys.enterBeginDate': '请选择开始日期',
  'sys.enterRespondents': '请选择调查对象',
  'sys.enterEndDate': '请选择结束日期',
  'common.title.questionDesc': '题目描述',
  'common.title.questionType': '题目类型',
  'common.title.isMust': '是否必填',
  'sys.enterQuestionDesc': '请输入题目描述',
  'sys.enterQuestionType': '请选择题目类型',
  'sys.title.editBonus': '编辑优惠',
  'sys.giftType': '赠送类型',
  'sys.rewardCashAmount': '现金奖励',
  'sys.enterRewardCashAmount': '请输入现金奖励金额',
  'sys.cashBetflow': '现金奖励流水倍数',
  'sys.enterCashBetflow': '请输入现金奖励的可提款流水倍数',
  'sys.rewardPointAmount': '积分奖励',
  'sys.enterRewardPointAmount': '请输入积分奖励',
  'sys.rewardSwingTimes': '摇一摇奖励次数',
  'sys.enterRewardSwingTimes': '请输入摇一摇奖励次数',
  'sys.rewardSpinTimes': '幸运大转盘奖励次数',
  'sys.enterRewardSpinTimes': '请输入幸运大转盘奖励次数',
  'sys.rewardConditionType': '奖励条件类型',
  'sys.enterRewardConditionType': '请选择奖励条件类型',
  'sys.title.result': '调查结果',
  'sys.enterDepositCondition': '请输入存款次数',
  'sys.depositCondition': '存款次数',

  'quiz.guessGroup.manage': '管理竞猜项',
  'quiz.guessGroup.gameName': '游戏名称',
  'quiz.guessGroup.type': '游戏分类',
  'quiz.guessGroup.sort': '排序',
  'quiz.guessGroup.resultType': '单/多结果',
  'quiz.guessGroup.status': '状态',
  'quiz.guessGroup.name': '游戏名称/玩法名称',
  'quiz.guessGroup.add.game': '添加游戏',
  'quiz.guessGroup.edit.game': '编辑游戏',
  'quiz.guessGroup.add.group': '添加玩法',
  'quiz.guessGroup.edit.group': '编辑玩法',
  'quiz.guessGroup.del': '删除',
  'addGamePage.fromVerify.name.required': '游戏名称不能为空',
  'addGamePage.fromVerify.type.required': '游戏分类不能为空',
  'addGamePage.fromVerify.sort.required': '排序不能为空',
  'addGamePage.fromVerify.name.max': '名称不能超过20字',
  'addGamePage.fromVerify.name.placeholder': '请输入游戏名称',
  'addGamePage.fromVerify.sort.placeholder': '请输入排序',
  'quiz.guessGroup.addGroup': '添加玩法',
  'quiz.guessGroup.selectGroup': '选择游戏',
  'quiz.guessGroup.groupName': '玩法名称',
  'quiz.guessGroup.expirationDate': '有效期',
  'quiz.guessGroup.startDate': '开始时间',
  'quiz.guessGroup.endDate': '结束时间',
  'quiz.guessGroup.selectGroup.placeholder': '请选择游戏',
  'quiz.guessGroup.groupName.placeholder': '请输入玩法名称',
  'quiz.guessGroup.groupName.required': '玩法名称不能为空',
  'quiz.guessGroup.delGroup.confirm': '确认要删除？',
  'quiz.guessGroup.changeStatus.confirm': '确认要操作吗？',
  'quiz.guessGroup.delGame.confirm': '确认要删除{name}吗？确认后将直接删除此游戏！',

  'quiz.guessItem.contentManage': '管理开奖内容',
  'quiz.guessItem.addType': '添加玩法类型',
  'quiz.guessItem.editType': '编辑玩法类型',
  'quiz.guessItem.addItem': '添加竞猜项',
  'quiz.guessItem.editItem': '编辑竞猜项',
  'addTypePage.fromVerify.name.required': '玩法类型名称不能为空',
  'addTypePage.fromVerify.sort.required': '排序不能为空',
  'addTypePage.fromVerify.odds.required': '赔率不能为空',
  'addTypePage.fromVerify.contain.required': '所属开奖结果不能为空',
  'addTypePage.fromVerify.odds.placeholder': '请输入赔率',
  'addTypePage.fromVerify.name.max': '玩法类型名称不能超过20字',
  'addTypePage.fromVerify.name.placeholder': '请输入玩法类型名称',
  'addTypePage.fromVerify.sort.placeholder': '请输入排序',
  'quiz.typeAdd.name': '玩法类型',
  'quiz.typeAdd.sort': '排序',

  'quiz.guessItem.typeId': '所属玩法类型',
  'quiz.guessItem.name': '竞猜项名称',
  'quiz.guessItem.contain': '所属开奖结果',
  'quiz.guessItem.odds': '赔率',
  'quiz.guessType.delItem.confirm': '确定要删除：{name}？',

  'quiz.guessContent.addContent': '添加开奖内容',
  'quiz.guessContent.editContent': '编辑开奖内容',
  'quiz.guessContent.content': '开奖内容',
  'quiz.guessContent.contentName': '输入名称进行搜索',
  'addContentPage.fromVerify.name.placeholder': '请输入开奖内容名称',
  'addContentPage.fromVerify.name.required': '开奖内容名称不能为空',
  'addContentPage.fromVerify.name.max': '开奖内容名称不能超过20字',

  'guessRecordData.roundNo': '局号',
  'guessRecordData.orderNo': '订单号',
  'guessRecordData.createTime': '投注时间',
  'guessRecordData.showId': '所属直播场次',
  'guessRecordData.roomNumber': '房间号',
  'guessRecordData.groupName': '玩法名称/开奖结果',
  'guessRecordData.nickname': '投注人',
  'guessRecordData.antes': '底注',
  'guessRecordData.multiple': '倍数',
  'guessRecordData.status0': '已下注',
  'guessRecordData.status1': '取消',
  'guessRecordData.status2': '已派彩',
  'guessRecordData.payAmount': '总金额',
  'guessRecordData.sendAwardAmount': '已派彩金额',
  'guessRecordData.details': '详情',

  'guessResultLogData.resultName': '开奖结果名称',
  'guessResultLogData.resultData': '封盘开奖信息',
  'guessResultLogData.status0': '下注中',
  'guessResultLogData.status1': '已封盘',
  'guessResultLogData.status2': '已确认',
  'guessResultLogData.status3': '已开奖',
  'guessResultLogData.status4': '已取消',
  'guessResultLogData.status5': '确认修改',
  'guessResultLogData.status6': '待流局',
  'guessResultLogData.status7': '待修改',
  'guessResultLogData.startTime': '开局时间',
  'guessResultLogData.sealTime': '封盘时间',
  'guessResultLogData.confirmTime': '确认时间',
  'guessResultLogData.reviewTime': '审核时间',
  'guessResultLogData.mark': '说明',
  'guessResultLogData.showPic': '结果截图',
  'guessResultLogData.sealPic': '封盘截图',
  'guessResultLogData.showClosePic': '封盘视频',
  'guessResultLogData.showDetails': '查看详情',

  'guessRecordDetailsData.odds': '赔率',


  'sys.title.searchType': '搜索类型',
  'sys.title.searchType1': '订单编号',
  'sys.title.searchType2': '会员账号',
  'sys.title.searchType3': '支付渠道名称',
  'sys.title.searchType4': '第三方订单编号',
  'sys.addLotteryLimit': '次数上限设置',
  'sys.cancelLottery': '取消抽奖资格',
  'sys.emptyLottery': '清空抽奖资格',
  'sys.content2': '是否取消选中的会员的抽奖资格？',
  'sys.enterCountLimit': '请输入次数上限',
  'sys.countLimit': '次数上限',
  'sys.countLimitLength': '次数上限最大为9999',
  'sys.noneLimit': '不限次数',
  'menu.userSysAdmin': '系统参数管理',
  'menu.lottery': '彩票管理',
  'menu.queryLotteryMethodList': '玩法管理',
  'menu.queryLotteryPropList': '属性管理',
  'menu.queryLotteryRateList': '赔率管理',
  'menu.popularPlatformGame': '热门游戏平台设置',
  'menu.ipBlockList': '用户 IP 黑名单',
  'menu.deviceBlockList': '用户设备黑名单',
  'menu.domainStatistics': '域名统计管理',
  'menu.queryOfflinePayOrder': '线下支付审核',
  'menu.queryOnlinePayOrder': '线上支付管理',
  'menu.config': '支付设置',
  'menu.payConfig': '支付渠道设置',
  'menu.withdrawPay': '代付渠道设置',
  'menu.payEarlyWarning': '渠道预警设置',
  'menu.onlineUser': '在线用户',
  'menu.reportManualTransfer': '会员调账报表',
  'menu.agentManualTransfer': '代理调账报表',
  'menu.userGameReport': '用户游戏报表',
  'menu.smsNameVerifyLog': '认证产生记录',
  'menu.upgrade': '升级模式',
  'menu.upgradeSetting': '等级设置',
  'menu.upgradeUser': '玩家列表',
  'menu.upgradeReport': '发放记录',
  'menu.vipSysConfig': 'VIP系统参数',
  'menu.programSetting': '方案设置',
  'menu.buyRecord': '购买记录',
  'menu.questionnaire': '问卷调查',

  'menu.sport': '体育管理',

  'menu.sportSetting': '页面管理',
  'menu.sportBanner': '首页banner管理',
  'menu.sportHotLeague': '热门联赛推荐位管理',
  'menu.sportHotMatch': '热门赛事推荐位管理',
  'menu.returnProportion': '下注金额退还比例',
  'menu.globalKillConfig': '全局杀数比例',
  'menu.singleKillConfig': '单场杀数比例',
  'menu.closeSportOdds': '关闭赔率',
  'menu.profitLimit': '盈利限额',
  'menu.participationConditions': '体育参数',
  'menu.scoreConfig': '比分信息设置',


  'menu.sportPublish': '赛事发布管理',
  'menu.handicapManage': '操盘管理',
  'menu.bookInplayManage': '赛事滚球订阅管理',
  'menu.marketTranslateMatch': '玩法翻译配对',
  'menu.sportMarketManage': '玩法管理',
  'menu.sportData': '数据管理',
  'menu.sportMerge': '隧伍聯賽数据匹配',
  'menu.sportMatch': '数据匹配',

  'menu.queryPushMessageList': '推送管理',
  'menu.signMember': '会员标签',
  'menu.balanceRate': '余额宝',
  'menu.articleMgmt': '文章管理',
  'menu.articleTypeMgmt': '文章类型管理',
  'menu.nav': '导航管理',
  'menu.pageMgmt': '页面管理',
  'menu.match': '赛事管理',
  'menu.RegisterItem': '注册项管理',
  'menu.agentEdit': '代理页编辑',
  'menu.winInformationEdit': '首页中奖信息编辑',
  'menu.checkin': '签到奖励记录',
  'menu.integralExchange': '积分兑换记录',
  'menu.paymentTab': '支付成功率报表',
  'menu.bonusArticle': '文章管理',
  'menu.bonusApplyRole': '互斥设置',
  'sys.title.maintainBegin': '维护起始时间',
  'sys.title.maintainEnd': '维护结束时间',
  'sys.button.maintainTickTock': '预设维护',
  'sys.button.add': '新增',
  'sys.button.edit': '编辑',
  'sys.button.button': '按钮',
  'sys.button.addTitle': '新增按钮',
  'sys.button.editTitle': '编辑按钮',
  'sys.button.menu': '菜单',
  'sys.button.selectMenu': '请选择菜单',
  'sys.button.buttonCode': '按钮编码',
  'sys.button.enterButtonCode': '请输入按钮编码',
  'sys.button.buttonName': '按钮名称',
  'sys.button.enterButtonName': '请输入按钮名称',
  'sys.button.menuName': '菜单名称',
  'sys.button.deleteConfirm': '确认删除此按钮吗？',
  'sys.menu.add': '新增',
  'sys.menu.edit': '编辑',
  'sys.menu.menu': '菜单',
  'sys.menu.addTitle': '新增菜单',
  'sys.menu.editTitle': '编辑菜单',
  'sys.menu.parentMenu': '父菜单节点',
  'sys.menu.selectParentMenu': '选择父菜单节点',
  'sys.menu.menuLevel': '菜单等级',
  'sys.menu.selectMenuLevel': '请选择菜单等级',
  'sys.menu.menuCode': '菜单Code',
  'sys.menu.menuName': '菜单名称',
  'sys.menu.isLeaf': '是否是叶子节点',
  'sys.menu.yes': '是',
  'sys.menu.no': '否',
  'sys.menu.menuUrl': '访问后台的url地址',
  'sys.menu.enterMenuUrl': '请输入访问后台的url地址',
  'sys.menu.menuOrder': '菜单顺序',
  'sys.languageCurrency.languageConfig': '多语言配置',
  'sys.languageCurrency.currencyConfig': '多币种配置',
  'sys.language.add': '新增',
  'sys.language.edit': '编辑',
  'sys.language.icon': '图标',
  'sys.language.iconSpec': '图标规格为130*130',
  'sys.language.language': '语言',
  'sys.language.language.sign': '语言标识',
  'sys.language.enterLanguage': '请输入语言',
  'sys.language.enterLanguage.sign': '请输入语言标识',
  'sys.language.cancel': '取消',
  'sys.language.confirm': '确定',
  'sys.language.initError': '请先初始化编辑参数',
  'sys.language.operationSuccess': '操作成功',
  'sys.language.uploadSuccess': '上传成功',
  'sys.language.uploadFailed': '上传失败',
  'sys.language.setDefaultConfirm': '确定要设置选中的语言为默认语言吗？',
  'sys.language.enableConfirm': '确定要启用选中的语言吗？',
  'sys.language.disableConfirm': '确定要停用选中的语言吗？',
  'sys.language.currentDefault': '当前默认语言',
  'sys.language.setAsDefault': '设为默认',
  'sys.language.addLanguage': '新增语言',
  'sys.currency.add': '新增',
  'sys.currency.edit': '编辑',
  'sys.currency.icon': '图标',
  'sys.currency.iconSpec': '图标规格为130*130',
  'sys.currency.currencyName': '货币名称',
  'sys.currency.enterCurrencyName': '请输入货币名称',
  'sys.currency.currencyAbbr': '货币缩写',
  'sys.currency.enterCurrencyAbbr': '请输入货币缩写',
  'sys.currency.currencySign': '货币符号',
  'sys.currency.enterCurrencySign': '请输入货币符号',
  'sys.currency.cancel': '取消',
  'sys.currency.confirm': '确定',
  'sys.currency.operationSuccess': '操作成功',
  'sys.currency.uploadSuccess': '上传成功',
  'sys.currency.uploadFailed': '上传失败',
  'sys.currency.setDefaultConfirm': '确定要设置选中的币种为默认币种吗？',
  'sys.currency.enableConfirm': '确定要启用选中的货币吗？',
  'sys.currency.disableConfirm': '确定要停用选中的货币吗？',
  'sys.currency.currentDefault': '当前默认币种',
  'sys.currency.setAsDefault': '设为默认',
  'sys.currency.addCurrency': '新增币种',
  'sys.currency.noIcon': '无图标',
  'sys.addMaintenanceInfoSuccess1': '添加预设维护信息成功！',
  'sys.addMaintenanceInfoFail1': '添加预设维护信息失败',
  'sys.addMaintenanceInfoError1': '添加预设维护信息错误',
  'sys.addMaintenanceInfoNotice': '添加预设维护信息提示',
  'sys.addMaintenanceInfoNotice1': '是否确定替换已有的预设信息',
  'sys.addMaintenanceInfoNotice2': '是否确定预设该时间段的维护',
  'member.remark.delete.all': '全部删除',
  'user.title.getBack': '取回',
  'sys.msgContentTooLong': '内容超过1000字符长度，请检查文本内容，从写字板中复制。',
  'constants.PAY_LEVEL1_VIP_MODEL_2_-1': '全部可用',
  'constants.PAY_LEVEL1_VIP_MODEL_2_0': '0级可用',
  'constants.PAY_LEVEL1_VIP_MODEL_2_1': '1级可用',
  'constants.PAY_LEVEL1_VIP_MODEL_2_2': '2级可用',
  'constants.PAY_LEVEL1_VIP_MODEL_2_3': '3级可用',
  'constants.PAY_LEVEL1_VIP_MODEL_2_4': '4级可用',
  'constants.PAY_LEVEL1_VIP_MODEL_2_5': '5级可用',
  'constants.PAY_LEVEL1_VIP_MODEL_2_6': '6级可用',
  'constants.PAY_LEVEL1_VIP_MODEL_2_7': '7级可用',
  'constants.PAY_LEVEL1_VIP_MODEL_2_8': '8级可用',
  'constants.PAY_LEVEL1_VIP_MODEL_2_9': '9级可用',
  'constants.PAY_LEVEL1_VIP_MODEL_2_10': '10级可用',
  'constants.PAY_LEVEL1_VIP_MODEL_2_11': '11级可用',
  'constants.PAY_LEVEL1_VIP_MODEL_2_12': '12级可用',
  'constants.PAY_LEVEL1_VIP_MODEL_2_13': '13级可用',
  'constants.PAY_LEVEL1_VIP_MODEL_2_14': '14级可用',
  'constants.PAY_LEVEL1_VIP_MODEL_2_15': '15级可用',
  'constants.PAY_LEVEL1_VIP_MODEL_2_16': '16级可用',
  'constants.PAY_LEVEL1_VIP_MODEL_2_17': '17级可用',
  'constants.PAY_LEVEL1_VIP_MODEL_2_18': '18级可用',
  'constants.PAY_LEVEL1_VIP_MODEL_2_19': '19级可用',
  'sys.offerCreateTime': '优惠生成时间',
  'sys.betflowBonusGivePeriodType': '结算周期类型',
  'sys.betflowBonusGivePeriodTime': '结算周期',
  'sys.enterBetflowBonusGivePeriodType': '选择结算周期类型',
  'sys.betflowBonusGivePeriodTypeDaily': '每天',
  'sys.betflowBonusGivePeriodTypeWeekly': '每周',
  'sys.betflowBonusGivePeriodTypeMonthly': '每月',
  'sys.enterBetflowBonusGivePeriodTime': '输入结算周期',
  'menu.four': '4D彩票',
  'menu.bet': '4D彩票注单',
  'menu.drawOpen': '4D彩票开奖',
  'menu.fourConfig': '4D彩票配置',
  'fourd.export.excel': '4D彩票注单.xls',
  'fourd.merchant.profit': '商户盈利',
  'fourd.bet.countNumber': '下注总单数',
  'fourd.bet.betCountNumber': '下注总注数',
  'fourd.future.openPeriods': '预期开奖时间',
  'fourd.title.enteringOpenNumber': '录入开奖号码,多个请已(,)逗号分隔',
  'fourd.title.firstPrize': '一等奖',
  'fourd.title.twoPrize': '二等奖',
  'fourd.title.therePrize': '三等奖',
  'fourd.title.fourPrize': '入围奖',
  'fourd.title.fivePrize': '安慰奖',
  'fourd.bet.countBetAmount': '总下注金额',
  'fourd.titile.payAmount': '派奖金额',
  'fourd.title.lookDrawInfo': '查看开奖信息',
  'fourd.title.payBetCount': '中奖注数',
  'fourd.title.openType': '开奖类型',
  'sys.title.weekType': '周',

  'menu.promote': '推广管理',
  'menu.domain': '专属域名管理',
  'menu.manual': '手动分配',
  'menu.automatic': '自动分配',
  'menu.promoteSetting': '奖励配置',
  'menu.promoteRewardReport': '奖励报表',
  'menu.promoteInvitationReport': '邀请报表',
  'menu.mlmSetting': '人人代配置',
  'menu.mlmReport': '人人代报表',

  'mlm.title.betflowCheck': '有效流水满足',
  'mlm.title.depositCheck': '邀请有效人数定义：  存款满足',
  'mlm.title.settingEnable': '是否开启邀请成就',
  'mlm.title.desc1': '从开启之日（这里显示开启日期）起统计',
  'mlm.invite.id': '序号',
  'mlm.invite.promoteName': '成就名称',
  'mlm.invite.promoteImgUrl': '图片',
  'mlm.invite.inviteNumber': '累计邀请有效人数',
  'mlm.invite.extraAmount': '奖励金额',
  'mlm.invite.betflowMultiple': '流水倍数',
  'mlm.invite.extraPoint': '奖励积分',
  'mlm.invite.operation': '操作',
  'mlm.invite.settingAdd': '新增邀请成就',
  'mlm.invite.settingForm': '邀请成就配置',
  'mlm.invite.field1': '成就名称',
  'mlm.invite.field2': '累计邀请有效人数',
  'mlm.invite.field3': '奖励金额',
  'mlm.invite.field4': '流水倍数',
  'mlm.invite.field5': '奖励积分',
  'mlm.invite.field6': '是否限制同IP同设备',
  'mlm.invite.field7': 'PC端任务图标',
  'mlm.invite.field8': 'H5端任务图标',
  'mlm.invite.field9': '图片',
  'mlm.invite.field10': '邀请人用户名',
  'mlm.invite.field11': '邀请注册人数',
  'mlm.invite.field12': '注册时间',
  'mlm.invite.field13': '受邀人奖励金额',
  'mlm.invite.field14': '派发状态',
  'mlm.invite.field15': '累积有效流水',
  'mlm.invite.field16': '是否为有效会员',
  'mlm.invite.field17': '是否同IP设备',
  'mlm.invite.field18': '邀请有效用户',
  'mlm.invite.field19': '奖金类型',
  'mlm.invite.field20': '奖金',
  'mlm.invite.field21': '积分',
  'mlm.invite.field22': '邀请成就已发放',
  'mlm.invite.field23': '投注反水已发放',
  'mlm.invite.field24': '受邀人奖励已发放',
  'mlm.invite.field25': '笔',
  'mlm.invite.field26': '前台邀请描述',
  'mlm.invite.field27': '受邀人用户名',

  'table.title.promote.level': '等级',
  'table.title.promote.bonus': '奖励金额',
  'table.title.promote.multiple': '流水倍数',
  'table.title.promote.extra.status': '是否有额外奖励',
  'table.title.promote.extra.nothing': '无额外奖励',
  'table.title.promote.extra.perecent': '奖励百分比',
  'table.title.promote.extra.level': '参与等级：{level}级以上',
  'table.title.promote.upgradeCnd': '升级条件及奖励',
  'table.title.promote.extra.upgradeCount': '邀请{count}人以上',
  'table.title.promote.extra.upgradeAmount': '奖励{amount}',
  'table.title.promote.extra.upgradeMultiple': '需完成{multiple}倍流水',
  'table.title.promote.finishCnd': '完成条件',
  'table.title.promote.checkInCount': '签到次数：{count}',
  'table.title.promote.totalDeposit': '累积存款：{amount}',
  'table.title.promote.betflowAmount': '有效投注：{amount}',
  'table.title.promote.balanceFee': '余额宝利息：{amount}',
  'table.title.promote.operate': '操作',
  'sys.smg167': '确认删除{level}级推广奖励配置？',
  'btnText.addPromoteSetting': '添加配置',
  'input.placeholder.msg': '推广等级',
  'btnText.editPromoteSetting': '编辑配置',
  'btnText.updateUserPromoteAgentSetting': '升级代理条件',
  'form.titalName.promoteUpgradeAgent': '升级条件',
  'form.lableName.promote.currentCount': '当前条件',
  'form.lableName.promote.currentCount.msg': '0：表示升级条件无效，无法升级为代理',
  'form.lableName.promote.newCount': '新条件',
  'form.lableName.promote.newCount.msg': '请输入新的升级条件',
  'form.titalName.promote': '推广配置',
  'form.lableName.promote.level': '推广等级',
  'form.lableName.promote.level.prompt': '请输入推广等级',
  'form.lableName.promote.amount': '奖励金额',
  'form.lableName.promote.amount.prompt': '请输入奖励金额',
  'form.lableName.promote.multiple': '流水倍数',
  'form.lableName.promote.multiple.prompt': '请输入流水倍数',
  'form.lableName.promote.extra': '额外奖励',
  'form.lableName.promote.extraPercent': '额外奖励比例',
  'form.lableName.promote.extraPercent.prompt': '请输入额外奖励比例',
  'form.lableName.promote.extraLevel': '额外奖励参与等级',
  'form.lableName.promote.extraLevel.prompt': '请选择额外奖励参与等级',
  'form.lableName.promote.avoidRelegation': '保级条件',
  'form.lableName.promote.upgradeCount': '升级条件',
  'form.lableName.promote.upgradeCount.prompt': '请输入升级条件',
  'form.lableName.promote.upgradeAmount': '升级奖励',
  'form.lableName.promote.upgradeAmount.prompt': '请输入升级奖励',
  'form.lableName.promote.upgradeMultiple': '升级奖励流水倍数',
  'form.lableName.promote.upgradeMultiple.prompt': '请输入升级奖励流水倍数',
  'form.lableName.promote.checkIn': '签到次数',
  'form.lableName.promote.checkIn.prompt': '请选择是否设置签到次数条件',
  'form.lableName.promote.checkInCount': '签到次数',
  'form.lableName.promote.checkInCount.prompt': '请填写签到次数',
  'form.lableName.promote.totalDeposit': '累积存款',
  'form.lableName.promote.totalDeposit.prompt': '请选择是否设置累积存款条件',
  'form.lableName.promote.totalDepositAmount': '累积存款',
  'form.lableName.promote.totalDepositAmount.prompt': '请填写累积存款金额',
  'form.lableName.promote.betflow': '有效投注',
  'form.lableName.promote.betflow.prompt': '请选择是否设置有效投注额条件',
  'form.lableName.promote.betflowAmount': '有效投注',
  'form.lableName.promote.betflowAmount.prompt': '请填写有效投注金额',
  'form.lableName.promote.balanceFee': '余额宝利息',
  'form.lableName.promote.balanceFee.prompt': '请选择是否设置余额宝利息条件',
  'form.lableName.promote.balanceFeeAmount': '余额宝利息金额',
  'form.lableName.promote.balanceFeeAmount.prompt': '请填写余额宝利息金额',
  'form.lableName.promote.extraLevel.1': 'VIP1级以上',
  'form.lableName.promote.extraLevel.2': 'VIP2级以上',
  'form.lableName.promote.extraLevel.3': 'VIP3级以上',
  'form.lableName.promote.extraLevel.4': 'VIP4级以上',
  'form.lableName.promote.extraLevel.5': 'VIP5级以上',
  'form.lableName.promote.extraLevel.6': 'VIP6级以上',
  'form.lableName.promote.extraLevel.7': 'VIP7级以上',
  'form.lableName.promote.extraLevel.8': 'VIP8级以上',
  'form.lableName.promote.extraLevel.9': 'VIP9级以上',
  'form.lableName.promote.extraLevel.10': 'VIP10级以上',
  'user.title.addBankCard': '添加银行卡',
  'user.title.addBankCardSuccess': '添加银行卡成功',
  'user.title.addBankCardError': '添加银行卡失败',
  'user.title.addBankCardMendAuthMobilePhone': '添加银行卡需要先绑定手机号',
  'user.title.addBankCardMendAuthWithdrawPWD': '添加银行卡需要先设置提款密码',
  'lable.addBankCard.name': '银行卡账户名',
  'lable.addBankCard.name.msg': '请输入银行卡账户名',
  'lable.addBankCard.bankName': '银行名称',
  'lable.addBankCard.bankName.msg': '请选择银行名称',
  'lable.addBankCard.bankName.msg1': '请输入银行名称',
  'lable.addBankCard.bankNumber': '银行卡账号',
  'lable.addBankCard.bankNumber.msg': '请输入银行卡账号',
  'lable.addBankCard.subBank': '开户行名称',
  'lable.addBankCard.subBank.msg': '请输入开户行名称',
  'agent.title.subTotalShareProfit': '下级代理净利润总和:{shareProfit}',
  'agent.title.subTotalShareCom': '下级代理抽成总和:{shareCommission}',
  'agent.title.subTotalShareFee': '下级代理抽成:{shareFee}',
  'agent.title.billAmount': '结算佣金',
  'agent.billType.selfAmount': '自身佣金:{selfAmount}',
  'agent.billType.subAmount': '下级佣金:{subAmount}',
  'agent.billType.billAmount': '结算佣金:{totalAmount}',
  'agent.title.superiorAccount': '上级代理',
  'agent.title.superiorAccount2': '上级代理账号',
  'agent.title.level': '级别',
  'agent.title.level.all': '所有',
  'agent.title.level.1': '一级',
  'agent.title.level.2': '二级',
  'agent.title.level.3': '三级',
  'agent.monthlyTable.agentLevel': '{level}级代理',
  'agent.monthlyTable.superiorAccount': '上级代理:{account}',
  'agent.commissionReport.pageBetflow': '本页流水',
  'agent.commissionReport.pageBonus': '本页优惠',
  'agent.commissionReport.pageDeposit': '本页存款',
  'agent.commissionReport.pageWithdraw': '本页提款',
  'agent.commissionReport.pageResult': '本页输赢',
  'agent.commissionReport.totalBetflow': '总计流水',
  'agent.commissionReport.totalBonus': '总计优惠',
  'agent.commissionReport.totalDeposit': '总计存款',
  'agent.commissionReport.totalWithdraw': '总计提款',
  'agent.commissionReport.totalResult': '总计输赢',
  'agent.monthlyReport.pageProfit': '本页月赢亏',
  'agent.monthlyReport.pageBetflow': '本页投注',
  'agent.monthlyReport.pageBonus': '本页优惠',
  'agent.monthlyReport.pageTrans': '本页手续费',
  'agent.monthlyReport.pageFinalProfit': '本页净利润',
  'agent.monthlyReport.pageShareCom': '本页抽佣',
  'agent.monthlyReport.pageBillAmount': '本页结算',
  'agent.monthlyReport.totalProfit': '总计月赢亏',
  'agent.monthlyReport.totalBetflow': '总计投注',
  'agent.monthlyReport.totalBonus': '总计优惠',
  'agent.monthlyReport.totalTrans': '总计手续费',
  'agent.monthlyReport.totalFinalProfit': '总计净利润',
  'agent.monthlyReport.totalShareCom': '总计抽佣',
  'agent.monthlyReport.totalBillAmount': '总计结算',
  'agent.title.agentSubUserResult': '会员输赢',

  'user.title.updateBirthday': '修改生日',
  'user.title.oldBirthday': '旧生日',
  'user.title.newBirthday': '新生日',
  'user.title.pleaseEnterNewBirthday': '请输入新生日信息',
  'member.title.markCount': '被标记人数',
  'user.frmTitel.userModel': '玩家样本',
  'user.frmTitel.userPeriod': '期间',
  'user.frmTitel.daily': '每日',
  'user.frmTitel.weekly': '每周',
  'user.frmTitel.monthly': '每月',
  'user.frmTitel.with': '的',
  'user.frmTitel.regisiter': '注册用户',
  'user.frmTitel.regisiterAndDeposit': '注册并存款用户',
  'user.frmTitel.keepCnd': '留存行为： 在之后的',
  'user.frmTitel.inCnd': '内',
  'user.frmTitel.beted': '投注过',
  'user.frmTitel.online': '在线',
  'user.frmTitel.countKeepNum': '计为留存用户',
  'user.frmTitel.platform': '渠道',
  'common.sendMail.writeEmail': '写邮件',
  'common.sixLottery.deleteReply': '删除回复',
  'common.betResult.lost': '输',
  'common.betResult.fair': '平',
  'common.betResult.win': '赢',
  'common.btn.reset': '重置',
  'common.btn.search': '搜索',
  'user.title.firstDeposit': '首存',
  'user.title.realNameAuth': '实名认证',
  'user.title.mobilePhoneAuth': '手机号认证',
  'user.title.emailAuth': '邮箱认证',
  'user.title.userVIPLevel': '会员等级',
  'user.title.startTime': '开始时间',
  'user.title.endTime': '结束时间',
  'agent.title.domainPublic': '域名类型',
  'agent.title.domainPublicMsg': '请选择域名类型',
  'agent.title.domainPublic.public': '公共域名',
  'agent.title.domainPublic.private': '专属域名',
  'agent.title.preventBlock': '微信防封',
  'agent.title.agentAccountNotEmpty': '专属域名对应的代理账号不能为空',
  'user.title.loginIPAddress': '登录IP归属地',
  'user.title.userRelationTime': '当前用户关联时间',
  'user.title.loginIP': '登录IP',
  'bonus.newInviteBonus.msg1': "受邀请人每次存款",
  'bonus.newInviteBonus.msg2': "作为邀请人工资",
  'bonus.newInviteBonus.msg3': "受邀请人VIP晋级奖金",
  'bonus.newInviteBonus.msg4': "倍为邀请人奖金",
  'bonus.newInviteBonus.msg5': "邀请人工资提款",
  'bonus.newInviteBonus.msg6': "邀请人晋级奖金提款",
  'bonus.newInviteBonus.msg7': "元且起",
  'bonus.newInviteBonus.msg8': "倍流水",
  'bonus.newInviteBonus.msg9': "流水条件",
  'promote.reward.title.regDate': '被邀请人注册时间',
  'promote.reward.title.finishDate': '被邀请人完成时间',
  'promote.reward.title.keyword': '关键词',
  'promote.reward.title.keyword.msg': '邀请人/被邀请人账号',
  'promote.reward.table.promoteAccount': '邀请人',
  'promote.reward.table.targetAccount': '被邀请人账号',
  'promote.reward.table.targetRegDate': '被邀请人注册时间',
  'promote.reward.table.amount': '奖励金额',
  'promote.reward.table.status': '状态',
  'promote.reward.table.finishDate': '完成时间',
  'promote.reward.table.moneyDate': '领取时间',
  'promote.reward.table.commonAmount': '奖励:{amount}',
  'promote.reward.table.extraAmount': '额外奖励:{amount}',
  'promote.reward.table.status.unfinish': '未完成',
  'promote.reward.table.status.finish': '已完成',
  'promote.reward.table.status.received': '已领取',
  'promote.reward.table.pageUnfinishedAmount': '本页未完成金额',
  'promote.reward.table.pageFinishedAmount': '本页已完成金额',
  'promote.reward.table.totalUnfinishedAmount': '总未完成金额 ',
  'promote.reward.table.totalFinishedAmount': '总完成金额',
  'promote.invitation.title.queryDate': '查询日期',
  'promote.invitation.table.countDate': '统计日期',
  'promote.invitation.table.activeCount': '当日活跃用户',
  'promote.invitation.table.participateCount': '参与活动的用户',
  'promote.invitation.table.participateRate': '活动参与率',
  'promote.invitation.table.regCount': '新注册下线数',
  'promote.invitation.table.firstDeposit': '首存下线数',
  'promote.invitation.table.firstDepositRate': '新注册首存率',
  'promote.invitation.table.pageParticipateRate': '本页活动参与率',
  'promote.invitation.table.pageRegCount': '本页新注册下线数',
  'promote.invitation.table.pageFirstDepositCount': '本页首存下线数',
  'promote.invitation.table.pageFirstDepositRate': '本页新注册首存率',
  'promote.invitation.table.totalParticipateRate': '总活动参与率',
  'promote.invitation.table.totalRegCount': '总新注册下线数',
  'promote.invitation.table.totalFirstDeopsitCount': '总首存下线数',
  'promote.invitation.table.totalFirstDepositRate': '总新注册首存率',
  'promote.upgrade.title.queryDate': '升级时间',
  'promote.upgrade.title.keyword.msg': '会员账号',
  'promote.upgrade.table.userAccount': '会员账号',
  'promote.upgrade.table.amount': '奖励金额',
  'promote.upgrade.table.betflow': '流水进度',
  'promote.upgrade.table.createTime': '领取时间',
  'promote.upgrade.table.pageAmount': '本页奖励金额',
  'promote.upgrade.table.totalAmount': '总奖励金额',
  'menu.promoteUpgradeReport': '升级奖励报表',
  'menu.historySearch': '历史记录查询',
  'menu.backupSetting': '历史数据备份配置',
  'menu.queryHistoryBonus': '优惠领取历史记录',
  'menu.queryHistoryPayOrder': '充值历史记录',
  'menu.queryHistoryBalanceLog': '帐变历史记录',
  'historySearch.tranLog.frm.userName': '会员账号',
  'historySearch.tranLog.frm.userName.msg': '请输入会员账号',
  'historySearch.tranLog.frm.tranDate': '交易时间',
  'historySearch.tranLog.frm.type': '交易类型',
  'historySearch.setting.form.title': '备份配置',
  'historySearch.setting.form.name': '备份项名称',
  'historySearch.setting.form.day': '备份天数',
  'historySearch.setting.form.day.required': '请输入备份天数',
  'historySearch.setting.form.remark': '备份项说明',
  'historySearch.setting.form.submitMsg': '确认提交备份配置吗',
  'historySearch.setting.table.name': '备份项名称',
  'historySearch.setting.table.day': '备份天数',
  'historySearch.setting.table.status': '状态',
  'historySearch.setting.table.remark': '备份项说明',
  'bonus.checkinIntegral.msg1': 'VIP等级奖励设置',
  'bonus.checkinIntegral.msg2': 'VIP等级为',
  'menu.queryLoginMember': '客户端统计',
  'member.queryLoginMember.registeredUserTotal': '总注册人数',
  'member.queryLoginMember.taodyUp': '今日新增',
  'member.queryLoginMember.logedUserToday': '今日总登录人数',
  'member.queryLoginMember.daysUp': '日环比',
  'member.queryLoginMember.logedTimeToday': '今日登录次数',
  'member.queryLoginMember.logedSuccRateToday': '今日登录成功率',
  'member.queryLoginMember.thePie': '饼状图',
  'member.queryLoginMember.columnar': '柱状图',
  'member.queryLoginMember.logedTerminalStatistics': '登录人数端口概览',
  'sys.welcomeLogin.msg': '欢迎登录游石科技智能管理后台',
  'bonus.title.createTime': '优惠发放日期',
  'bonus.log.remark': '备注信息',
  'promote.reward.table.operateDetail': '操作人/操作时间',
  'promote.reward.table.operate': '操作',
  'promote.reward.table.showDetail': '查看进度',
  'promote.log.showDetail.account': '{account} 完成进度',
  'promote.log.showDetail.checkIn': '签到：{finish}/{target}',
  'promote.log.showDetail.deposit': '累计存款：{finish}/{target}',
  'promote.log.showDetail.betflow': '累计投注：{finish}/{target}',
  'promote.log.showDetail.balanceFee': '余额宝利息：{finish}/{target}',
  'promote.log.showRefuseReason': '拒绝原因',
  'promote.reward.table.changeRefuse': '置为失败',
  'promote.reward.table.changeNormal': '置为正常',
  'promote.log.changeRewardStatus': '修改奖励状态',
  'promote.log.confirmChangeRewardStatus': '确认修改{target}会员的奖励状态吗？',
  'promote.reward.table.status.refuse': '拒绝',
  'constants.bonusType_25': '盈亏优惠',
  'constants.newBonusType_25': '盈亏优惠',
  'constants.bonusMainType_25': '盈亏优惠',
  'constants.newBonusMainType_25': '盈亏优惠',
  'constants.bonusType_27': '游戏笔笔存',
  'constants.newBonusType_27': '游戏笔笔存',
  'constants.bonusMainType_27': '游戏笔笔存',
  'constants.newBonusMainType_27': '游戏笔笔存',
  'bonus.label.repeatTimeEveryDay': '每日可申请次数',
  'bonus.label.repeatTimeEveryDayMsg': '请填写每日可申请次数',
  'sys.profitType': '盈亏类型',
  'sys.profitType_info': '【盈利】：盈利总注单输赢-亏损总注单输赢涉及场景：玩家赢钱派发 【亏损】：盈利总注单输赢-亏损总注单输赢涉及场景：玩家输钱派发 【全部】：【 盈利总注单输赢-亏损总注单输赢】的绝对值涉及场景：玩家输赢都派发',
  'sys.profitType.win': '盈利',
  'sys.profitType.lost': '亏损',
  'sys.profitType.all': '全部',
  'bonus.winLost.cnd.title': '设置优惠条件',
  'bonus.winLost.cnd.add': '添加条件',
  'bonus.winLost.cnd.profitAmount': '盈/亏(绝对值)达到',
  'bonus.winLost.cnd.profitAmount.msg': '请输入盈亏绝对值',
  'bonus.winLost.cnd.giftAmount': '奖励金额',
  'bonus.winLost.cnd.giftAmount.msg': '请输入奖励金额',
  'bonus.winLost.frm.levelLimit': '参与等级',
  'bonus.winLost.frm.levelLimit.msg': '请选择参与等级',
  'sys.includeAndMoreThan': '及以上',
  'user.title.minBalance': '请输入最小余额',
  'user.title.maxBalance': '请输入最大余额',
  'user.title.totalMainBalance': '总主账户余额',
  'menu.sms': '短信系统',
  'menu.smsTemplate': '短信模板管理',
  'menu.smsAllocation': '短信发送',
  'menu.smsReport': '短信发送报表',
  'sms.sendTestSms': '发送测试',
  'common.bonus.winLostBonus': '{type}盈亏优惠,{date}',
  'sys.winLost.giveType.independent': '各游戏平台独立派发',
  'sys.winLost.giveType.unify': '参与游戏平台统一派发',
  'sys.winLost.giveType.msg': '请选择派发方式',
  'sys.winLost.giveType': '派发方式',
  'constants.riskLevelType_-8': '限制领取升级模式俸禄',
  'front.bonus.upgradeReward.riskMsg.title': '风控限制',
  'front.bonus.upgradeReward.riskMsg.upgradeAmount': '风控限制派发升级模式升级奖励',
  'front.bonus.upgradeReward.riskMsg.weekRemark': '风控限制派发升级模式周俸禄',
  'front.bonus.upgradeReward.riskMsg.monthRemark': '风控限制派发升级模式月俸禄',
  'menu.leaderboard': '排行榜',
  'menu.gameleaderboard': '第三方游戏平台排行榜',
  'menu.proxyleaderboard': '渠道代理排行榜',
  'menu.userleaderboard': '会员排行榜',
  'menu.vipLeaderboardSet': 'VIP排行榜设置',
  'console.leaderboard': '排名',
  'console.firstAmountCount': '首存人数',
  'console.activeUserCount': '活跃人数',
  'console.userName': '会员名称',

  'console.depositAmount': '存款(元)',
  'console.depositAmountVN': '存款(VND)',

  'console.withdrawAmount': '提现(元)',
  'console.withdrawAmountVN': '提现(VND)',

  'console.betflow': '投注(元)',
  'console.betflowVN': '投注(VND)',
  'console.betflow2': '投注',

  'console.resultAmount': '输赢(元)',
  'console.resultAmountVN': '输赢(VND)',

  'console.totalBetflow': '平台有效投注',
  'smsAllocation.mobilePhone.status': '号码状态',
  'smsAllocation.mobilePhone.status_1': '空号',
  'smsAllocation.mobilePhone.status_2': '停机',
  'smsAllocation.mobilePhone.status_0': '正常',
  'smsAllocation.mobilePhone.status_3': '未确认',
  'smsAllocation.mobilePhone.sendStatus': '发送状态',
  'smsAllocation.mobilePhone.sendStatus.select': '选择发送状态',
  'smsAllocation.mobilePhone.sendStatus.done': '已发送',
  'smsAllocation.mobilePhone.sendStatus.not': '未发送',
  'smsAllocation.mobilePhone.importInfo': '备注信息',
  'smsAllocation.mobilePhone.sendPhoneText': '发送短信',
  'smsAllocation.mobilePhone.searchKeyword': '手机号/用户名/备注信息',
  'phoneAllocation.importData': '导入',
  'phoneAllocation.selectSend': '选择性发送',
  'phoneAllocation.allSend': '全部发送',
  "user.title.updPwdTime": "修改密码日期",
  "common.queryFrm.dayCnt": "最近多少天没有修改过密码",
  "sys.riskUpdPwd": "密码修改",
  "sys.riskUpdPwd.need": "YES",
  "sys.riskUpdPwd.notneed": "NO",
  'user.pay.type': '支付方式',
  'user.title.payTypeList': '专属支付方式',
  'user.title.confirmDelete': '确认删除',
  'user.title.deletePayTypeMsg': '确认删除该支付方式吗？',
  'common.title.payChannel': '支付方式',
  'user.title.payType': '支付渠道',
  'user.title.payName': '支付名称',
  'user.title.addUserPayType': '添加支付方式',
  'lable.addUserPayType.payType': '支付方式',
  'lable.addUserPayType.payType.msg': '请选择支付方式',
  'user.title.addPayTypeSuccess': '添加支付方式成功',
  'sms.userAccountType': '会员列表',
  'sms.refreshSMSBalance': '刷新短信账户余额',
  'sms.smsBalance': '账户余额',
  'sms.smsCurrency': '币种',
  'user.title.addPayTypeFail': '添加支付方式失败',
  'user.title.pleaseUserList': '请选择需要添加的会员',
  'user.title.searchAddPayType': '查询结果添加支付方式',
  'user.title.selectAddPayType': '选择添加支付方式',
  'sys.version.announcement.add': '添加公告',
  'sys.version.announcement.title': '标题',
  'sys.version.announcement.title.msg': '请输入标题',
  'sys.version.announcement.content': '内容',
  'sys.version.announcement.content.msg': '请输入内容',
  'sys.version.announcement.status': '是否上线',
  'sys.version.announcement.status_0': '即将上线',
  'sys.version.announcement.status_1': '已上线',
  'sys.version.announcement.changeStatus': '发布上线',
  'sys.version.confirmPublic': '确认发布上线吗？',
  'sys.betBonus.needDeposit.title': '每日最低存款',

  'common.allWithdrawType': '全部提现方式',
  'pay.title.withdrawalType0': '银行卡提现',
  'pay.title.withdrawalType1': 'USDT提现',
  'pay.title.withdrawalType2': '支付宝提现',
  'pay.title.withdrawalType2_jk4': 'GCash提现',
  'pay.title.withdrawalType3': 'V币钱包提现',
  'pay.title.withdrawalType4': 'G币钱包提现',
  'pay.title.withdrawalType5': 'E币钱包提现',
  'pay.title.withdrawalType6': '易币付钱包提现',
  'pay.title.withdrawalType7': 'K豆钱包提现',
  'pay.title.withdrawalType8': 'C币钱包提现',
  'pay.title.withdrawalType9': 'OK币钱包提现',
  'pay.title.withdrawalType10': 'JD钱包提现',
  'pay.title.withdrawalType11': '虚拟币提现',
  'pay.title.withdrawalType12': 'PayMaya提现',
  'pay.title.withdrawalType13': 'GrabPay提现',
  'pay.title.withdrawalType14': '微信提现',
  'pay.title.withdrawalType15': '808钱包提现',
  'pay.title.withdrawalChannelType1': '支付宝',
  'pay.title.withdrawalChannelType2': '银行',
  'pay.title.withdrawalChannelType3': '微信',
  'pay.title.withdrawalChannelType4': 'USDT',
  'pay.title.withdrawalChannelType5': 'VIPPAY',
  'pay.title.withdrawalChannelType6': 'GOPAY',
  'pay.title.withdrawalChannelType7': 'EBPAY',
  'pay.title.withdrawalChannelType8': 'YBFPAY',
  'pay.title.withdrawalChannelType9': 'KDPAY',
  'pay.title.withdrawalChannelType10': 'CBPAY',
  'pay.title.withdrawalChannelType11': 'OKPAY',
  'pay.title.withdrawalChannelType12': 'JDPAY',
  'pay.title.withdrawalChannelType13': 'BCPAY',
  'pay.title.withdrawalChannelType14': 'PayMaya',
  'pay.title.withdrawalChannelType15': 'GrabPay',
  'pay.title.withdrawalChannelType16': '808Pay',
  'pay.title.exchangeRate': '汇率',
  'pay.title.usdtHl': '填写汇率',
  'pay.title.usdtHl2': '请填写汇率',
  'pay.title.usdtHlType0': '实时汇率',
  'pay.title.usdtHlType1': '固定汇率',
  'pay.title.usdtAddress': '收款地址',
  'pay.withdraw.usdtLink': '钱包地址',
  'pay.withdraw.usdtApplyCount': '申请个数',
  'pay.title.usdtAddressName': '地址名称',
  'pay.title.qrCode': '二维码',
  'pay.title.usdtStatus': '状态',
  'pay.title.usdtcreateTime': '创建时间',
  'pay.title.usdtTodaySk': '今日收款',
  'pay.title.usdtTodayCk': '今日出款',
  'pay.title.usdtTodayBalance': '账号余额',
  'pay.add.usdtAccount': '添加账号',
  'pay.usdt.instert': '添加收款地址',
  'pay.title.addressPlaceholder': '请填写账号收款地址',
  'pay.title.addressNamePlaceholder': '请填写账号收款名称',
  'pay.withdraw.applyAmount': '申请金额',
  'pay.withdraw.realAmount': '实际金额',

  'pay.title.huobikey': '火币apiKey',
  'pay.title.huobiSecretKey': '火币SecretKey',
  'pay.title.binanceKey': '币安apiKey',
  'pay.title.binanceSecretKey': '币安apiKey',
  'pay.title.huobikeyPlaceholder': '请填写火币账号的apiKey',
  'pay.title.huobiSecretKeyPlaceholder': '请填写火币账号的SecretKey',
  'pay.title.binanceKeyPlaceholder': '请填写币安账号的apiKey',
  'pay.title.binanceSecretKeyPlaceholder': '请填写币安账号的SecretKey',
  'pay.query.usdtkeyword': '地址或地址名称',
  'pay.edit.usdtAccount': '管理收款账号',
  'pay.label.withdrawalUSDTCount': '提币数',
  'pay.label.withdrawalUSDTRate': '汇率',
  'pay.label.withdrawalUSDTAddress': '收款地址',
  'pay.label.withdrawalUSDTRate1': '当前汇率',
  'pay.label.withdrawalUSDTamount': '人民币金额',
  'pay.usdtOrderNo': '交易所订单号',
  'pay.label.payUSDTCount': 'USDT充值数量',
  'pay.edit.usdtChain': '手续费管理',
  'pay.usdt.instertChain': '添加地址链',
  'common.finance.recharge': '充值',

  'pay.title.usdtChainName': '链名称',
  'pay.title.usdtRecharge': '交易手续费',
  'sys.title.USDTChain': '所属链',
  'sys.title.selectUSDTChain': '请选择地址所属链',

  'finance.title.businessUSdtCount': 'USDT交易个数',
  'finance.title.businessUSdtRate': 'USDT交易汇率',

  'pay.label.withdrawalUSDTFee': '手续费',
  'pay.label.withdrawalUSDTFinalCount': '最终提币数',

  'lottery.title.usdt': 'USDT',

  'usdt.msg3': '最低USDT(含)',
  'usdt.msg4': '请输入最低USDT个数',
  'usdt.msg5': '最高USDT(不含)',
  'usdt.msg6': '请输入最高USDT个数',
  'usdt.msg7': '封顶限额',
  'sys.giftMaxMoney': '| 封顶限额：{maxMoneyUsdt}元',
  'sys.offerType1': '| 优惠类型：',


  'report.radio.today.data': '当日实时',
  'agent.report.radio.today.data1': '当月实时 - 未结算',
  'report.radio.history.data': '历史数据',

  'pay.title.remark': '自定渠道名称',
  'pay.title.remark.description': '后台专用，方便识别渠道统计数据',
  'pay.title.innerRemark': '前端渠道名称',
  'pay.title.innerRemark1': '请输入会员端充值方式名称',
  'pay.title.innerRemark.description': '会员端专用，方便会员识别充值方式',
  'pay.title.innerRemark.tag': '用于前端渠道下展示小标签，如：送10%',

  'pay.title.payDesc': '前端渠道描述',
  'pay.title.payDesc1': '请输入前端渠道描述',
  'pay.title.payFluency': '支付流畅率',
  'pay.title.payFluency1': '请输入支付流畅率',
  'pay.title.payTag': '渠道红字标签',
  'pay.title.payTag1': '请输入渠道红字标签',


  'constants.ropeType_1': '红绳',
  'constants.ropeType_2': '青绳',
  'constants.ropeType_3': '黄绳',
  'constants.ropeType_4': '白绳',
  'constants.ropeType_5': '黑绳',
  'constants.ropeType_6': '五彩绳',
  'sys.ropeType.pleaseEnterAccumulatedBet': '请输入累计投注',
  'sys.ropeType.pleaseSelectSyntheticRope': '请选择合成绳子所需类型',
  'sys.ropeType.pleaseSelectQuantity': '请选择合成绳子所需数量',
  'sys.ropeType.ropeType': '绳子类型',
  'sys.ropeType.pleaseSelectRopeType': '请选择绳子类型',
  'sys.ropeType.convertibleCash': '可兑换现金',
  'sys.ropeType.pleaseEnterCashExchange': '请输入可兑换现金',
  'sys.ropeType.accumulatedBetting': '累计投注',
  'sys.ropeType.syntheticRopeRequiredType': '合成绳子所需类型',
  'sys.ropeType.amountNeededSynthesizeRope': '合成绳子所需数量',
  'sys.ropeType.prizeCreateTime': '奖励生成时间',
  'sys.ropeType.prizeUpdateTime': '奖励领取时间',
  'sys.ropeType.convertIntoCash': '兑换现金',
  'sys.ropeType.totalAmountReceived': '总领取金额',
  'sys.ropeType.totalDegree': '总优惠条数',
  'sys.withdraw.pickType.label': '领取有效期',
  'sys.withdraw.pickType.rule': '请选择领取有效期',
  'sys.withdraw.pickType.radio.value1': '长期有效',
  'sys.withdraw.pickType.radio.value2': '会员注册几天内有效',
  'sys.withdraw.pickExpireDays.rule': '请输入有效天数',
  'sys.withdraw.pickExpireDays.day': '日',
  'sys.withdraw.completeWithdrawDays.valid': '请填入完成首次提款时间',
  'sys.withdraw.pickExpireDays.valid': '请填入领取有效日期',
  'sys.withdraw.rule': '请选择提款次序',
  'sys.withdraw.withdrawType.label': '提款次序',
  'sys.withdraw.withdrawType.radio.value1': '首提',
  'sys.withdraw.completeWithdrawType.label': '完成首次提款时间',
  'sys.completeWithdrawType.rule': '请选择完成首次提款时间',
  'sys.completeWithdrawType.prefix': '会员注册',
  'sys.giftAmount.label': '赠送金额',
  'sys.giftAmount.rule': '请输入赠送金额',
  'sys.maxWithdrawAmount.label': '最高可提现金额',
  'sys.maxWithdrawAmount.rule': '请输入最高可提现金额',
  'sys.deposit.applyType.label': '发送类型',
  'sys.deposit.applyType.rule': '请选择发送类型',
  'sys.deposit.applyType.radio.value1': '自动发送',
  'sys.deposit.applyType.radio.value2': '手动领取',
  'sys.deposit.pickType.label': '领取有效期',
  'sys.deposit.pickType.rule': '请选择领取有效期',
  'sys.deposit.pickType.radio.value1': '长期有效',
  'sys.deposit.pickType.radio.value2': '会员注册几天内有效',
  'sys.deposit.pickExpireDays.rule': '请输入有效天数',
  'sys.deposit.pickExpireDays.day': '日',
  // 'sys.maxWithdrawAmount.rule': '请输入最高可提现金额',
  'sys.withdraw.applyType.label': '发送类型',
  'sys.withdraw.applyType.rule': '请选择发送类型',
  'sys.withdraw.applyType.radio.value1': '自动发送',
  'sys.withdraw.applyType.radio.value2': '手动领取',


  'menu.userDomain': '会员专属域名',
  'userDomain.title.title': '标题',
  'userDomain.title.detail': '副标题',
  'userDomain.title.domain1': '域名地址',
  'userDomain.title.domain2': '域名地址2',
  'userDomain.title.domain3': '域名地址3',
  'userDomain.title.count': '分配人数',
  'userDomain.title.createTime': '创建时间',
  'userDomain.title.status': '状态',
  'userDomain.status.enabled': '启用',
  'userDomain.status.disabled': '禁用',
  'userDomain.table.title': '会员专属域名',
  'userDomain.table.titleName': '标题',
  'userDomain.table.detail': '副标题',
  'userDomain.table.domain1': '域名地址1',
  'userDomain.table.domain2': '域名地址2',
  'userDomain.table.domain3': '域名地址3',
  'userDomain.table.userAccountStr': '分配会员',
  'userDomain.table.userAccountStr.msg': '请输入会员账号，多个会员用英文逗号(,)分割',
  'finance.title.withdrawFee': '提款手续费',
  'menu.reportBonus': '优惠类型报表',
  'withdrawFee.add.new': '添加',
  'common.table.tipsMsg': '请输入该内容',
  'common.operate.enable': '启用操作',
  'common.operate.enable.confirm': '确认启用该条数据吗？',
  'report.bonus.totalCount': '优惠总数',
  'common.title.bonusName': '优惠名称',
  'sys.upgrageBonus.monthlyDeposit.title': '月累计存款',
  'sys.upgrageBonus.monthlyActive.title': '月活跃天数',
  'sys.msg151': ' | 月最低存款：{monthlyDeposit}',
  'sys.msg152': ' | 月活跃天数：{monthlyActive}',
  'sys.msg62.realMoney': ' | 本金 {betMultiple} 倍流水',

  'pay.label.payeeName': '收款人名称',
  'pay.label.payeeName1': '请输入收款人名称',
  'pay.label.payeeName2': '最多输入25个字符',
  'pay.label.payeeNumber': '收款人帐号',
  'pay.label.payeeNumber1': '请输入收款人帐号',

  'front.bonus.firstWithdrawBonus': '新人首提红利',
  'front.bonus.firstRegisterBonus': '新人注册红利',
  'front.bonus.firstDepositBonus': '新人首存红利',
  'front.bonus.signInNewBonus': '新人签到红利',
  'front.bonus.lostNewBonus': '新人复活红利',
  'sys.title.userAccount.registrationTime': '会员注册时间',
  'user.title.totalResult': '总输赢',
  'bet.label.totalResult': '总输赢(元)',
  'bet.label.totalResultVN': '总输赢(VND)',
  'bet.label.pageResult': '本页输赢(元)',
  'bet.label.pageResultVN': '本页输赢(VND)',

  'onlineuser.export.excel': '在线用户报表.xlsx',

  'menu.onlineUserHistory': '在线用户（每10分钟）',
  'onlineUserHistory.title.countHourDesc': '每小时＼每十分',
  'onlineUserHistory.title.userCount10': '00：00～10：00',
  'onlineUserHistory.title.userCount20': '10：00～20：00',
  'onlineUserHistory.title.userCount30': '20：00～30：00',
  'onlineUserHistory.title.userCount40': '30：00～40：00',
  'onlineUserHistory.title.userCount50': '40：00～50：00',
  'onlineUserHistory.title.userCount60': '50：00～60：00',
  'menu.questList': '问卷调查列表',
  'menu.questRecord': '问卷调查记录',
  'sys.title.userLevel': '会员等级',
  'sys.title.userAwardTime': '积分变动日期',
  'sys.title.userAwardPointBefore': '变动前积分',
  'sys.title.userAwardPointAfter': '变动后积分',
  'menu.userAwardRecord': '会员积分记录',
  'sys.title.userAwardPoint': '积分变动数量',
  'sys.title.answerTime': '提交时间',
  'sys.form.surveyLog.keyword': '会员账号',
  'sys.title.questionTitle': '问卷名称',

  // 'sys.betBonus.needDeposit.title':'每日最低存款',

  'agent.title.attributes.check': '请选择代理属性',
  'agent.title.attributes': '代理属性',
  'agent.title.attributes.external': '外部代理',
  'agent.title.attributes.internal': '内部代理',
  'agent.title.account.manager.check': '请填写开户管理人账号',
  'agent.title.account.manager': '开户管理人',

  'pay.title.memberPaymentStatus': '会员确认到账状态',
  'pay.title.memberPaymentStatus0': '未开启',
  'pay.title.memberPaymentStatus1': '待确认',
  'pay.title.memberPaymentStatus2': '未到账',
  'pay.title.memberPaymentStatus3': '已到账',
  'pay.title.C2CPayment': 'C2C出款',
  'pay.title.splitOrderType': '拆分类型',
  'pay.title.splitOrderType1': '系统平均拆分',
  'pay.title.splitOrderType2': '人工拆分',
  'pay.title.splitOrderError': '请拆分完毕全部金额在进行提交',
  'pay.title.increase': '增加拆分金额',
  'pay.title.splitOrderTypeInfo': '系统计算拆分=总金额 / 每笔金额 \n 人工拆分 = 总金额 - 输入的拆分金额生成该笔子订单，可以多次人工处理拆分订单',
  'pay.title.popupNotifications': '是否弹窗通知',
  'pay.title.popupInterval': '弹框间隔',
  'pay.title.notReceiveDevidence': '未到账是否上传凭证',
  'pay.title.popupIntervalTips': '温馨提示：时间单位为分钟，间隔时间达到设置之后会再次弹框',
  'pay.title.notReceiveDevidenceTips': '温馨提示：开启后用户必须上传凭证',
  'pay.title.behalfConfirm': '代替会员确认',
  'pay.title.userDescription': '用户描述：',
  'pay.title.manualRealTrigger': '手动实时触发',
  'pay.title.pleaseEnterMinutes': '请输入分钟',
  'push.title.msgId': '消息ID',
  'menu.QueryMemberDevice': '会员装置信息',
  'menu.QueryAndroidInstallDevice': '安装量统计',
  'device.title.os': '会员装置',
  'device.title.registrationId': '极光ID',
  'user.title.isTop': '是否置顶',
  'user.title.top': '置顶',
  'user.title.topCancel': '取消置顶',

  'sys.vip.dayLimitWithdraw': '当日次数',
  'sys.vip.dayLimitWithdrawAmount': '当日提款',

  'sys.msg153': '满足条件，会员在活动页面手动领取奖励，逾期失效',
  'sys.msg154': '统计存款类型',
  'sys.msg155': '单笔存款',
  'sys.msg156': '累计存款',
  'bonus.titie.publicRewardSettings': '奖励设置',
  'sys.withdrawalChannel': '提款渠道',
  'sys.msg157': '最高提款金额必须大于最低提款金额',
  'sys.msg158': '最低提款(含)',
  'sys.msg159': '请输入最低提款金额',
  'sys.msg160': '最高提款(不含)',
  'sys.msg161': '请输入最高提款金额',
  'sys.msg162': '提款金额：{minAmount}~{maxAmount}',
  'sys.msg163': '单笔提款',
  'sys.msg164': '累计提款',
  'sys.selectWithdrawChannel': '请选择提款渠道',
  'sys.limitReceiveCount': '限制领取次数',
  'usdt.decimal.return': 'USDT兑换小数退还',

  // im 国际化
  'menu.im': 'IM 管理',
  'menu.immgmt': 'IM 权限管理',
  'menu.imMgmt': 'IM 权限管理',
  'menu.queryMsg': 'IM 消息查询',
  'menu.querymsg': 'IM 消息查询',
  'user.friendInfo': '好友列表',
  'user.friendAllRoom': '房间列表',
  'user.title.messagelist': '消息列表',
  'user.friendRoom': '查看房间',
  'im.user.binding': 'IM 绑定用户',
  'im.user.title.binding': '绑定用户',
  'im.user.title.role': 'IM 角色',
  'im.user.title.loginName': 'IM 登陆账号',
  'im.user.title.systemName': 'IM 系统名',
  'im.user.unbinding': 'IM 解绑用户',
  'im.sys.title.confirmUnbinding': '确认解绑用户',
  'im.sys.unbindingAccount': '即将解绑的账号：{userName}',
  'im.sys.login': 'im 登陆',
  'im.sys.login.error': '没有绑定im账号',
  'pay.withdraw.rejectionNotification': '提款拒绝通知',

  'common.use.log.count': '近半年总登录次数',

  'agent.title.setPixelParam': '设置像素参数',
  'agent.title.pixelId': '数据源ID',
  'agent.title.pixelAccessToken': '数据源KEY',
  'member.title.pixelPush': '像素推送',
  'member.title.selectPixelPush': '请选择要推送的像素',
  'member.title.pixelPushThat': '将该用户信息推送至像素',
  'pay.title.financialTime': '财务时间',

  'common.export.limit.exception': '导出数据已超过系统设定10000条，请加上筛选条件后重新尝试！',

  'sys.resetGoogleAuthPassword': '重置谷歌验证码',
  'sys.confirmGoogleAuthPassword': '确认要重置谷歌验证码？',
  'sys.googleAuth': '谷歌验证码',
  'sys.googleAuth.val': '请输入谷歌验证码',

  'sys.user.virtualCurrencyAddress': '虚拟货币',
  'sys.user.virtualCurrencyAddress2': '虚拟币地址列表',
  'user.title.delVirtualCurrencyAddress': '删除虚拟币地址',
  'user.title.askDelVirtualCurrencyAddress': '请确认删除虚拟币地址?',
  'user.title.updateVirtualCurrencyAddress': '修改虚拟币地址信息',
  'user.title.synchronizeDeposit': '同步存款数据',
  'user.title.synchronizeWithdrawal': '同步提款数据',
  'user.title.dataInDepositReport': '【存款报表】中数据为',
  'user.title.dataInWithdrawReport': '【取款报表】中数据为',
  'user.title.dataInMemberDetails': '【会员详情】中数据为',
  'user.title.sureSynchronizedDeposit': '确定存款报表数据同步到会员详情数据中吗？',
  'user.title.sureSynchronizedWithdrawal': '确定取款报表数据同步到会员详情数据中吗？',
  'user.title.noSynchronizationRequired': '金额相同，无需同步',
  'pay.withdraw.msg9': '{0}申请提现',
  'pay.withdraw.msg10': '易币付申请提现',
  'agent.title.completeInformation': '请输入完整信息',

  'pay.title.orderDescription': '订单描述',
  'finance.title.orderDescription1': '请输入订单描述',
  'agent.title.detail.activeUserNoDistinct': '同一下线活跃多天只计算一人',
  'agent.title.detail.depositUserNoDistinct': '同一下线多天充值只计算一人',

  'admin.bonus.singleDayDeposit': '当天单笔存款',
  'admin.bonus.accumulatedDeposits': '当天累积存款',
  'admin.pay.selectDepositType': '请选择存款类型',
  'admin.bonus.sevendayDepositDay': '天数',
  'admin.bonus.sevendayDepositGear': '档位',
  'admin.bonus.sevendayDepositDayText': '第{day}天',
  'admin.bonus.sevendayDepositGearText': '第{gear}档',

  'sys.allTransactionTypes': '全部交易类型',
  'admin.front.picture.domainName': '对应域名',


  'sys.push.msg': '消息推送',
  'sys.push.immediate': '实时推送',
  'sys.push.notify': '友盟通知',
  'sys.push.type': '推送类型',
  'sys.confirm.enable': '确认开启吗？',
  'sys.confirm.disable': '确认关闭吗？',
  'sys.push.phoneStatus': '手机推送状态',
  'sys.push.mailStatus': '邮箱推送状态',
  'sys.push.smsStatus': '短信推送状态',
  'push.msg.config.type1': '充值',
  'push.msg.config.type2': '提现',
  'push.msg.config.type3': '手动调账',
  'push.msg.config.type4': 'VIP升级礼金',
  'push.msg.config.type5': '周俸禄',
  'push.msg.config.type6': '月俸禄',
  'push.msg.config.type7': '实时推送',
  'push.msg.config.type700': '签到',
  'push.msg.config.type701': '续签',
  'push.msg.config.timing': '定时推送',
  'agent.title.setAdjustParam': '设置adjust参数',
  'agent.title.applicationID': '应用识别码',
  'agent.title.registrationID': '注册识别码',
  'agent.title.loginID': '登录识别码',
  'agent.title.firstSubmitRecharge': '首次提交充值',
  'agent.title.firstAddBankCard': '首次添加银行卡',
  'admin.front.title.PageMgmt': '请输入名称/内容/key的关键字',
  'admin.bonus.dayBonusUpperLimit': '当日优惠上限',
  'admin.bonus.relatedBonus': '关联优惠活动',
  'sys.selectPromotionsBonus': '请选择需要关联的优惠活动',

  'avatar.changePassword': '修改密码',
  'avatar.oldPassword': '旧密码',
  'avatar.oldPasswordPlaceholder': '旧密码',
  'avatar.newPassword': '新密码',
  'avatar.newPasswordPlaceholder': '新密码',
  'avatar.confirmPassword': '确认新密码',
  'avatar.confirmPasswordPlaceholder': '再次确认密码',
  'avatar.passwordMismatch': '新密码跟确认密码不相同',
  'avatar.changePasswordSuccess': '操作成功，请重新登入!',
  'avatar.oldPasswordRequired': '请输入旧密码',
  'avatar.newPasswordRequired': '请输入新密码',
  'avatar.confirmPasswordRequired': '请输入确认新密码',

  'agent.setAgentUsdtRate': '设置提现汇率',
  'agent.fillFixedExchangeRate': '请填写固定汇率',
  'admin.bonus.client': '使用端',
  'admin.bonus.calculationRules': '计算规则',
  'admin.bonus.calculationRules1': '计算优惠（旧规则）',
  'admin.bonus.calculationRules2': '不计算优惠（新规则）',
  'admin.bonus.calculationRulesInfo': '【计算优惠】：注单下注金额 - 注单中奖金额 = 亏损金额 【不计算优惠】：亏损金额 - 领取总优惠 = 实际亏损金额',
  'menu.matrixRoomMgmt': '聊天室管理',
  'user.title.addRoom': '创建聊天室',
  'user.button.addRoom': '创建聊天室',
  'user.button.room.select.func': '请选择聊天室类型',
  'user.title.room.name': '聊天室名称',
  'user.title.room.name.input': '请输入聊天室名',
  'user.title.room.title': '聊天室备注',
  'user.title.room.title.input': '请输入聊天室备注',
  'user.title.room.title.max': '超过聊天室备注长度',
  'user.title.room.service': '客服',
  'user.title.room.service.input': '请选择客服',
  'user.title.room.func': '聊天室类型',
  'user.title.room.order': '排序',
  'user.title.room.order.input': '请输入聊天室排序',
  'user.title.updateRoom': '修改聊天室',
  'common.title.account.freeze': '冻结',
  'common.title.account.unfreeze': '解冻',
  'common.title.status.running': '正常',
  'common.title.status.freeze': '冻结',
  'sys.account.freeze': '即将冻结的账号：{matrixAccount}',
  'sys.account.unfreeze': '即将解冻的账号：{matrixAccount}',
  'user.button.room.message.list': '消息列表',
  'menu.matrixRoomContentMgmt': '聊天室消息管理',
  'user.button.addRoomContent': '添加消息',
  'common.radio.room.list': '聊天室列表',
  'user.title.room.content': '消息内容',
  'user.title.room.content.status': '消息状态',
  'user.title.room.content.input': '请输入消息内容',
  'common.radio.room.list.input': '请选择聊天室列表',
  'menu.ImNotifiMsgMgmt': '会员通知消息查询',
  'user.title.room.id': '聊天室 ID',
  'member.title.account.name': '会员账号',
  'member.title.nickname': '会员昵称',
  'common.title.room.deploy': '发布',
  'common.title.room.withdraw': '撤回',
  'admin.title.addTelemarketingList': '添加至电销名单',
  'admin.title.selectedMembers': '选中的会员',
  'admin.title.addMethod': '添加方式',
  'admin.title.remove': '移除',
  'admin.title.memberActivateCount': '会员列表导入激活用户',
  'user.title.activatedDepositorsCount': '激活存款人数',
  'user.title.activatedBetCount': '激活投注人数',
  'user.title.lastCallTime': '最后拨打时间',
  'user.title.depositTimeActivation': '激活后存款时间',
  'user.title.betTimeActivation': '激活后投注时间',
  'user.title.dialStatus': '拨打状态',
  'user.title.notConnected': '未接通',
  'user.title.connected': '已接通',
  'user.title.numberCalls': '拨打次数',
  'user.title.callPerson': '拨打人',
  'user.title.dialTime': '拨打时间',
  'user.title.hangUpTime': '挂断时间',
  'user.title.callDuration': '通话时长',
  'agent.title.room.info': 'IM群信息',
  'pay.withdraw.payMayaName': 'PayMaya姓名',
  'pay.withdraw.payMayaAccount': 'PayMaya账号',
  'pay.withdraw.grabPayName': 'GrabPay姓名',
  'pay.withdraw.grabPayAccount': 'GrabPay账号',
  'user.title.payMayaPhone': 'PayMaya手机号',
  'user.title.payMayaRealName': 'PayMaya真实姓名',
  'user.title.delPayMaya': '删除PayMaya账号',
  'user.title.askDelPayMaya': '请确认删除PayMaya账号',
  'user.title.confirmUnbindingAllPayMaya': '注意：此操作后，将解绑属于该用户的所有PayMaya账号',
  'user.title.grabPayPhone': 'GrabPay手机号',
  'user.title.grabPayRealName': 'GrabPay真实姓名',
  'user.title.delGrabPay': '删除GrabPay账号',
  'user.title.askDelGrabPay': '请确认删除GrabPay账号',
  'user.title.confirmUnbindingAllGrabPay': '注意：此操作后，将解绑属于该用户的所有GrabPay账号',
  'user.title.enterPayMayaPhone': '请输入PayMaya手机号',
  'user.title.enterGrabPayPhone': '请输入GrabPay手机号',
  'user.title.enterPayMayaRealName': '请输入PayMaya真实姓名',
  'user.title.enterGrabPayRealName': '请输入GrabPay真实姓名',
  'user.title.exportMemberData': '导出会员资料',
  'user.title.email': '邮箱',
  'user.title.importAndExport': '上传并导出数据',
  'user.title.importAndExportType': '导出数据',
  'user.title.pleaseEnterImportAndExportType': '请先勾选导出数据',

  'user.title.OneKeyRecycle': '一键回收',

  "menu.blockchain": "区块链",
  "menu.blockchainRecord": "链上交易明细",
  "menu.walletMy": "我的钱包",
  "menu.userWallet": "收币钱包",
  "menu.payoutWallet": "提币钱包",
  "menu.digitalAssertManagement": "数字资产管理",
  "menu.fundingCollection": "资金归集",
  "menu.exchangeRateSell": "提现汇率",
  "menu.exchangeRateBuy": "充值汇率",
  'pay.title.payDesc2': '前端收款地址描述',
  'pay.title.payDesc2Required': '请输入前端收款地址描述',

  'pay.withdraw.weChatName': '微信姓名',
  'pay.withdraw.weChatAccount': '微信账号',
  'user.title.weChatRealName': '微信真实姓名',
  'user.title.delWeChat': '删除微信账号',
  'user.title.askDelWeChat': '请确认删除微信账号',
  'user.title.confirmUnbindingAllWeChat': '注意：此操作后，将解绑属于该用户的所有微信账号',
  'user.title.enterWeChatAccount': '请输入微信账号',
  'user.title.enterWeChatRealName': '请输入微信真实姓名',
  'user.title.modifyChannelInformation': '修改{channelName}账户信息',

  'sys.rewardGoldenEgg': '奖励金蛋',
  'sys.rewardRedEnvelope': '奖励红包',
  'sys.setPrizeDay': '请设置第{dayCount}天的奖品',
  "sign.receive,type1": "奖励现金",
  "sign.receive,type2": "奖励金蛋",
  "sign.receive,type3": "奖励红包",
  'device.install.src.title': '安装来源',
  'device.id.title': '设备ID',
  'device.serial.title': '机型设备',
  'user.title.withdrawalsProhibited': '禁止提款',
  'user.title.sign-inDays': '签到天数',
  'pay.title.payerName': '付款人',

  'member.select.filterRepeat.account.title': '去掉重复会员',
  'member.select.filterRepeat.ip.title': '去掉重复IP数据',
  'user.title.paymentCode': '收款码',
  'user.title.uploadPaymentCode': '请上传收款码',
  'constants.regSourceTypeJk4_0': '官网直客',
  'user.title.pointCreateTime': '积分发放时间',
  'user.title.pointAmount': '变动积分数量',
  'user.title.pointAmountAfter': '变动后数量',
  'user.title.pointAmountType': '积分类型',
  'bonus.pointType.1': '签到优惠积分',
  'bonus.pointType.2': '积分兑换',
  'bonus.pointType.3': '实时存款优惠积分',
  'bonus.pointType.4': '任务优惠积分',
  'bonus.pointType.5': '存款优惠积分',
  'bonus.pointType.6': '手动调整积分',
  'bonus.pointType.7': '未知',
  'bonus.pointType.8': '手动调整积分',
  'bonus.pointType.11': '代理积分',
  'bonus.pointType.12': '累计存投红利积分',
  'bonus.pointType.13': '累计存投优惠积分',
  'bonus.pointType.14': '存款渠道优惠积分',
  'bonus.pointType.15': '连续存投优惠积分',
  'bonus.pointType.16': 'VIP充值赠送积分',

  'analyze.quick3.deviceSource': '注单来源',
  'analyze.quick3.lotNo': '期号',
  'analyze.quick3.playName': '玩法|下注号码',
  'analyze.quick3.status': '注单状态',
  'analyze.quick3.status0': '未开奖',
  'analyze.quick3.status1': '未中奖',
  'analyze.quick3.status2': '已中奖',
  'analyze.quick3.status3': '用户撤单',
  'analyze.quick3.status4': '系统性撤单',
  'analyze.quick3.result': '盈亏',
  'analyze.quick3.playId1': '总和',
  'analyze.quick3.playId2': '二同',
  'analyze.quick3.playId3': '一同',
  'analyze.quick3.deviceSource1': 'PC',
  'analyze.quick3.deviceSource2': 'H5',
  'analyze.quick3.deviceSource3': 'Android',
  'analyze.quick3.deviceSource4': 'IOS',
  'analyze.quick3.totalBets': '总注数',
  'analyze.quick3.totalBetAmount': '总投注额',
  'analyze.quick3.unawardedAmount': '未开奖金额',
  'analyze.quick3.cancellationAmount': '撤单金额',
  'analyze.quick3.totalUsers': '总用户',
  'menu.betManagement': '注单管理',
  'menu.gamePlayRanking': '玩法排行',
  'menu.playOdds': '玩法赔率',
  'menu.gameConfiguration': '玩法配置',
  'menu.winningNumbers': '开奖号码',
  'quiz.guessGroup.type1': '游戏竞猜',
  'quiz.guessGroup.type2': '博弈竞猜',
  'quiz.guessGroup.type3': '快三竞猜',
  'menu.quick3': '快三',
  'analyze.quick3.nowOdds': '当前赔率',
  'analyze.quick3.reset': '恢复上次配置',
  'finance.export.gamePlayRanking': '快三玩法排行.xls',
  'analyze.quick3.gameType': '玩法类型',
  'analyze.quick3.maximumAmountSingleBet': '注单单注最大金额',
  'analyze.quick3.userMaximumBet': '用户当前期最大下注',
  'analyze.quick3.currentPeriodMaximumBet': '玩法当前期最大下注',
  'analyze.quick3.gameplayEnableDisable': '玩法启用/停用',
  'analyze.quick3.gameplayAbbreviation': '玩法缩写',
  'analyze.quick3.gameplay': '玩法简介',
  'analyze.quick3.bettingExamples': '投注示例',
  'analyze.quick3.sampleCode': '示例代码',
  'analyze.quick3.lotteryName': '彩种名称',
  'analyze.quick3.deadlineIssue': '本期截止时间',
  'analyze.quick3.fullyRandom': '全随机',
  'analyze.quick3.profitability': '盈利率',
  'analyze.quick3.betDetails': '注单详情',
  'analyze.quick3.bettingNumbers': '下注号码',
  'analyze.quick3.numberBets': '投注注数',
  'analyze.quick3.totalBetAmount2': '投注总额',
  'analyze.quick3.singleBetAmount': '单注金额',
  'analyze.quick3.prizes': '可中奖项',

  'live.title.36': '直播间领取红包',
  'live.title.42': '直播任务完成奖金',
  'live.title.71': '直播间转盘抽奖现金奖励',
  'live.title.80': '主播礼物金额兑换，主播总收益{changeMoney}',
  'live.title.107': '购买竞猜下注',
  'live.title.142': '送出[{0}]*{1}个',
  'live.title.168': '直播间发送红包',
  'live.title.208': '竞猜派奖结算',
  'live.title.209': '竞猜流局退款',
  'live.title.210': '赌神榜上升了',
  'live.title.211': '赌神榜下降了',

  'user.title.connectedState': '接通状态',
  'user.title.totalCalls': '总共拨打次数',

  'quick3.quick3Bets': '快三下注',
  'quick3.orderCancellation': '快三撤单退回',
  'quick3.quick3Payout': '快三派彩',

  'quick3.table.title': '房间号/房间名称/主播昵称',

  'bonus.checkin.xls': '签到奖励记录.xls',
  'bonus.integral.xls': '积分兑换记录.xls',
  'job.progress.xls': '用户任务进度.xls',
  'job.progress.acceptTime': '任务接受时间',
  'job.progress.completeTime': '任务完成时间',
  'job.progress.receiveTime': '任务领取时间',
  'job.progress.title': '标题',
  'job.progress.userAccount': '用户ID/用户名/昵称',
  'job.progress.status': '任务状态',
  'job.progress.status0': '已领取任务',
  'job.progress.status1': '已完成任务',
  'job.progress.status2': '领取任务未完成',
  'job.progress.status3': '已领取奖金',
  'job.progress.jobType': '任务类型',
  'job.progress.jobType0': '新手任务',
  'job.progress.jobType1': '每日任务',

  'menu.MerberLoginLock': '锁定用户列表',
  'user.title.loginLockTime': '登录锁定时间',
  'user.title.notUnlocked': '未解锁',
  'user.title.unlocked': '已解锁',
  'user.title.lockedState': '锁定状态',
  'user.title.loginPasswordChange': '登录密码修改',
  'user.title.loginPassword': '登录密码',
  'user.title.generatePasswordDirectly': '直接生成密码',
  'user.title.re-enter': '再次输入',
  'user.title.pleaseEnterAgain': '请再次输入',
  'user.title.confirmUnlock': '确认解除锁定？',
  'user.title.activatedBetStatus': '激活投注状态',
  'user.title.activatedDepositStatus': '激活存款状态',
  'user.title.selectActivatedBetStatus': '选择激活投注状态',
  'user.title.selectActivatedDepositStatus': '选择激活存款状态',

  'analyze.title.applicationScenario': '应用场景',
  'analyze.title.sendContent': '发送内容',
  'analyze.title.causeOfFailure': '失败原因',
  'analyze.title.verificationCodeFilledIn': '验证码是否回填',
  'analyze.title.backfillStatus': '回填状况',
  'analyze.title.registerToSend': '注册发送',
  'analyze.title.loginToSend': '登录发送',
  'menu.smsDeliveryRate': '短信到达率列表',

  'front.onebuy.amount.sub': '一元购抢购',
  'front.onebuy.amount.change': '一元购彩金兑换',
  'front.onebuy.amount.return': '一元购抢购退单',
  'front.onebuy.amount.rebuy': '一元购商品回购',
  'admin.onebuy.excelExport.odrder': '订单数据',
  'admin.onebuy.excelExport.commodity': '商品数据',
  'admin.onebuy.excelExport.plan': '抢购计划数据',
  'admin.onebuy.excelExport.platformStatistic': '数据汇总',
  'admin.onebuy.excelExport.platformDetailStatistic': '数据明细',

  'constants.transferType_18': '一元购抢购',
  'constants.transferType_19': '一元购商品回购',
  'constants.transferType_20': '一元购彩金兑换',
  'constants.transferType_21': '一元购抢购退单',
  'constants.onebuyType_1': '一元购优惠券',
  'user.title.onebuyBalance': '一元购资金',
  'user.title.onebuyBalanceTooltip': '一元购资金= 可提资金 + 存款金额',
  'analyze.title.SMSLog': '短信记录',
  'analyze.title.loginSMSStatistics': '登录短信统计',
  'analyze.title.registrationSMSStatistics': '注册短信统计',
  'analyze.title.numberApplications': '申请数',
  'analyze.title.numberSuccessfulBackfills': '回填成功数',
  'analyze.title.backfillSuccessRate': '回填成功率',
  'analyze.title.backfillFailureCount': '回填失败数',
  'analyze.title.backfillFailureRate': '回填失败率',

  'common.bonus.vipRewardType1': '晋级奖金',
  'common.bonus.vipRewardType2': '蝉联奖金',
  'common.bonus.vipRewardType3': '生日礼金',
  'common.bonus.vipRewardType4': '电子救援金',
  'common.bonus.vipRewardType5': '真人娱乐救援金',
  'common.bonus.vipRewardType6': '体育救援金',
  'common.bonus.vipRewardType7': '彩票救援金',
  'common.bonus.vipRewardType8': '捕鱼救援金',
  'common.bonus.vipRewardType9': '棋牌救援金',
  'common.bonus.vipRewardType10': 'H5免费筹码',
  'common.bonus.vipRewardType11': '周俸禄',
  'common.bonus.vipRewardType12': '月俸禄',
  'common.bonus.vipRewardType13': 'PC免费筹码',
  'common.bonus.vipRewardType14': '幸运大转盘奖励次数',
  'common.bonus.vipRewardType15': '积分',
  'common.bonus.vipRewardType16': 'APP免费筹码',
  'common.bonus.vipRewardType17': 'PWA免费筹码',
  'common.bonus.vipLevelBonusName': '{vipLevel}{bonusName}',
  'admin.bonus.profitLoss': '盈亏奖励',
  'common.title.expirationDay': '有效期/天',
  'common.title.flowIssued': '流水发放',
  'common.title.sufficientDeposit': '满足存款额',
  'common.title.grant': '可发放',
  'common.title.usersSendComments': '用户是否允许发送弹幕',
  'front.vip.level': '{0}级别优惠',
  'front.vip.up': '{0}晋级礼金',
  'front.vip.upMsg1': '暂无可领取的晋级礼金',
  'front.vip.upMsg2': '已领取过当前等级晋升礼金',
  'front.vip.birthday': '{0}生日礼金',
  'front.vip.birthdayMsg1': '暂无可领取的生日礼金',
  'front.vip.birthdayMsg2': '请先填写生日日期',
  'front.vip.birthdayMsg3': '领取失败，已过了生日礼金的领取时效',
  'front.vip.birthdayMsg4': '已领取过当前等级今年生日礼金',
  'front.vio.depositMsg1': '您已经领取过该笔红利，请您重新充值',
  'front.vio.depositMsg2': '请先充值后，再来领取优惠',
  'front.vio.depositMsg3': '当前无可领取的VIP等级存款优惠',
  'front.vio.depositMsg4': '无可领取优惠',
  'sys.oneBuyCouponTimes': '一元购优惠券',
  'sys.enterOneBuyCouponTimes': '请输入一元购奖励优惠券奖励份数',
  'common.userPoint.noEnough': '会员没有足够的积分',
  'user.title.addPointSuccess': '积分修改成功。',
  'user.title.addPointError': '积分修改操作失败。',
  'user.title.addPoint': '修改积分',
  'user.title.increasePoint': '添加积分',
  'user.title.decreasepoint': '扣减积分',
  'sys.enterPreferentialPoint': '请输入积分数',
  'sys.PreferentialPoint.msg': '积分数',

  'menu.yygCoupon': '优惠劵列表',
  'push.msg.config.typeOnebuy': '一元购',
  'sys.msgDepositPage': '最低存款：{minDeposit}',
  'admin.bonus.depositPageBonus': '充值页面存款返利,{date}',

  'sys.title.verificationRequestTime': '验证请求时间',
  'sys.title.numberVerificationFailures': '验证失败次数',
  'sys.title.timeIncorrectPasswordInput': '密码输入错误时间',
  'sys.title.numberIncorrectPasswords': '密码错误次数',
  'sys.title.loginRequestTime': '请求登录时间内',
  'sys.title.numberLoginRequests': '请求登录次数',
  'sys.title.restrictionMethod': '限制方式',
  'sys.title.IPBlacklist': 'IP黑名单',
  'sys.title.deviceBlacklist': '设备黑名单',
  'sys.title.loginRestriction': '限制登录',
  'admin.onebuy.type.return': '退款',
  'admin.onebuy.name.return': '一元购退款',
  'sys.title.blindBoxConfiguration': '盲盒配置',
  'sys.title.dailyOpeningTimes': '盲盒每日开启次数',
  'sys.title.dayTime': '每日开启时间',
  'sys.title.dailyBlindBoxDrawLimit': '每日抽盲盒限制',
  'sys.title.rebateRatio': '返水比例',
  'sys.title.weight': '权重',
  'sys.title.orAbove': '或以上',
  'sys.title.depositsAndBet': '存款及投注',
  'sys.title.maximumIssuance': '最多发放',

  'sys.title.setCashWheel': '设置现金大转盘',
  'sys.title.timePeriod': '时间周期',
  'sys.title.activityRewardAmount': '活动奖励金额',
  'sys.title.directCashWithdrawalNotPossible': '不可直接提现',
  'sys.title.initialAmountFirstLotteryDraw': '第一次抽奖初始化金额',
  'sys.title.numberDraws': '抽奖次数',
  'sys.title.falseWithdrawalInformation': '虚假提现信息',
  'sys.title.realWithdrawalInformation': '真实提现信息',
  'sys.title.uploadAwardImage': '上传奖项图片',
  'sys.title.addAwards': '添加奖项',
  'sys.title.conditionSettings': '条件设置',
  'sys.title.validNumberInvitations': '邀请有效人数',
  'sys.title.giveawayDraw': '赠送抽奖',
  'sys.title.taskDescription': '任务描述',
  'sys.title.depositBonus': '存款奖励',
  'sys.title.numberDeposits': '存款笔数',
  'sys.title.amountCannotLessThan': '每笔金额不能低于',
  'sys.title.downloadAPPLoginReward': '下载APP登录奖励',
  'sys.title.downloadAPPLogDraw': '下载APP并有登录赠送抽奖',
  'sys.title.withdrawalRestrictions': '提现限制',
  'sys.title.amountMustDepositRequirement': '奖励金额全部提现需满足存款',
  'sys.title.ifNotMetReduce': '如未满足则减少',
  'sys.title.activityRules': '活动规则说明',
  'sys.title.lotteryRecords': '抽奖记录',
  'sys.title.firstFewDraws': '第几次抽奖',
  'sys.title.lotteryResults': '抽奖结果',
  'sys.title.amountAfterChange': '变动后金额',
  'sys.title.completed': '是否完成',
  'sys.title.numberAssistsRecorded': '助力次数记录',
  'sys.title.assistTime': '助力时间',
  'sys.title.numberLotteryDraws': '助力抽奖次数',
  'sys.title.withdrawalRecord': '提现记录',
  'sys.title.withdrawalTime': '提现时间',
  'sys.title.withdrawalAmount': '提现金额',
  'sys.title.withdrawalRatio': '提现比例',
  'sys.title.meetDepositRequirements': '是否满足存款条件',
  'sys.title.timeSettings': '时间设置',
  'sys.title.addFalseWithdrawalInformation': '添加虚假中奖信息',
  'common.bonus.systemGive': '系统赠送',
  'common.bonus.deposit': '完成充值',
  'common.bonus.appLogin': 'APP登录奖励',
  'common.bonus.invite': '邀请好友{count}个',
  'menu.automaticReview': '提款自动审核设置',
  'sys.rolemanagement.rolename': '角色名稱',
  'sys.rolemanagement.rolenote': '角色說明',
  'sys.rolemanagement.issuper': '超级管理员',
  'sys.rolemanagement.rolewarnning': '请至少勾选一个菜单项',
  'sys.rolemanagement.menus.tree': '权限菜单',
  'sys.rolemanagement.editTitle': '修改角色',
  'sys.row.title': '序号',
  'sys.user.name': '用户账号',
  'sys.user.use': '使用人',
  'sys.user.selectRole': '选择角色',
  'sys.user.selectRolePlaceholder': '请选择角色',
  'sys.user.status': '状态',
  'sys.user.selectStatusPlaceholder': '请选择状态',
  'sys.user.enabled': '启用',
  'sys.user.disabled': '禁用',
  'sys.role.delete1': '为防止错误,请先禁用后再删除',
  'sys.role.delete2': '该角色权限下还有{count}个用户账户在使用',
  'sys.role.delete3': '确认要删除该角色吗？',
  'game.gameTypeMgmt.column.title.index': '序号',
  'game.gameTypeMgmt.column.title.gameGroupName': '类型',
  'game.gameTypeMgmt.column.title.gameDefaultSort': '排序',
  'game.gameTypeMgmt.column.title.gameGroupPcImg': 'PC未选中图标',
  'game.gameTypeMgmt.column.title.gameGroupH5Img': 'H5未选中图标',
  'game.gameTypeMgmt.column.title.gameGroupAppImg': 'App未选中图标',
  'game.gameTypeMgmt.column.title.gameGroupPcImgEnlarge': 'PC选中图标',
  'game.gameTypeMgmt.column.title.gameGroupH5ImgEnlarge': 'H5选中图标',
  'game.gameTypeMgmt.column.title.gameGroupAppImgEnlarge': 'App选中图标',
  'game.gameTypeMgmt.column.title.gameStatus': '是否启用',
  'game.gameTypeMgmt.column.title.operator': '操作人',
  'game.gameTypeMgmt.column.title.operateTime': '操作时间',
  'game.gameTypeMgmt.column.title.operateAction': '操作',
  'game.gamePlatformMgmt.column.title.index': '序号',
  'game.gamePlatformMgmt.column.title.gamePlatformName': '平台名称',
  'game.gamePlatformMgmt.column.title.gameFullName': '平台名称',
  'game.gamePlatformMgmt.column.title.gameShowName': '显示名称',
  'game.gamePlatformMgmt.column.title.gamePlatformCode': '平台标识',
  'game.gamePlatformMgmt.column.title.gameType': '平台类型',
  'game.gamePlatformMgmt.column.title.percent': '平台费率',
  'game.gamePlatformMgmt.column.title.status': '状态',
  'game.gamePlatformMgmt.column.title.desc': '平台描述',
  'game.gamePlatformMgmt.column.title.gameCount': '游戏数量',
  'game.gamePlatformMgmt.column.title.action': '操作',
  'game.gamePlatformMgmt.editconfig': '游戏配置',
  'game.gameListMgmt.column.title.index': '序号',
  'game.gameListMgmt.column.title.gamePlatformName': '平台名称',
  'game.gameListMgmt.column.title.gameName': '游戏名称',
  'game.gameListMgmt.column.title.rpt.recommendRate': '官方RPT',
  'game.gameListMgmt.column.title.rpt.showRate': 'RPT展示区间',
  'game.gameListMgmt.column.title.rpt.boostRate': 'boost预估值',
  'game.gameListMgmt.column.title.winPlayerRange': '获胜玩家区间',
  'game.gameListMgmt.column.title.player30MinRange': '30分钟玩家区间',
  'game.gameListMgmt.column.title.maxPrizeRange': '最大获得奖金区间',
  'game.gameListMgmt.placeholder.minPlayerCount': '最少人数',
  'game.gameListMgmt.placeholder.maxPlayerCount': '最大人数',
  'game.gameListMgmt.placeholder.minAmount': '最少数值',
  'game.gameListMgmt.placeholder.maxAmount': '最大数值',
  'game.gameListMgmt.validation.positiveIntegerOnly': '请输入正整数',
  'game.gameListMgmt.validation.maxValueExceeded': '数值不能超过 2,147,483,647',
  'game.gameListMgmt.validation.maxPrizePairIncomplete': '最小与最大数值需同时填写',
  'game.gameListMgmt.column.title.gameFullName': '游戏平台',
  'game.gameListMgmt.column.title.gameCode': '游戏编码',
  'game.gameListMgmt.column.title.gameType': '平台类型',
  'game.gameListMgmt.column.title.currency': '币种',
  'game.gameListMgmt.column.title.gamePcImg': 'PC图片',
  'game.gameListMgmt.column.title.gameH5Img': 'H5图片',
  'game.gameListMgmt.column.title.gameAppImg': 'App图片',
  'game.disable': '是否要禁用？',
  'game.enable': '是否要启用？',
  'common.tradeId' : '交易编号',
  'common.enterTradeId' : '请输入交易编号',
  'activity.activityMgmt.column.title.index': '优惠编号',
  'activity.activityMgmt.column.name': '优惠名称',
  'activity.activityMgmt.column.multiType': '优惠分类',
  'activity.activityMgmt.column.templateType': '优惠模版',
  'activity.activityMgmt.column.lang': '语言',
  'activity.activityMgmt.column.status': '活动状态',
  'activity.activityMgmt.column.showTime': '优惠展示时间',
  'activity.activityMgmt.column.enableTime': '优惠生效时间',
  'activity.activityMgmt.column.sort': '排序',
  'activity.activityMgmt.column.action': '操作',
  'clientInfo.contactUs': '联系方式',
  'clientInfo.displayIcon': '显示图标',

  'game.show.type': '展示方式',
  'game.show.type.input': '請選擇展示方式',

  // 網站配置相關翻譯
  'webConfig.depositTurnoverMultiplier': '充值流水倍数',
  'webConfig.saveSuccess': '保存成功',
  'webConfig.updateSuccess': '更新成功',
  'webConfig.disableSuccess': '禁用成功',
  'webConfig.enableSuccess': '启用成功',
  'webConfig.deleteSuccess': '删除成功',

  // 提款配置相關翻譯
  'payWithdraw.autoApproval': '提款时风控是否自动审批',
  'payWithdraw.withdrawPassword': '提款是否需要认证提款密码',
  'payWithdraw.bankCard': '银行卡',
  'payWithdraw.config.title': '充值提现配置',
  'payWithdraw.save': '保存',
  'payWithdraw.basicConfig': '提款基本配置',
  'payWithdraw.accountBindConfig': '提款账号绑定配置',
  'payWithdraw.disabled': '禁用',
  'payWithdraw.enabled': '启用',
  'payWithdraw.bindableAccountCount': '可綁定帐号数量',
  'payWithdraw.bindableAccountCountInvalid': '可绑定账号数量必须大于等于1',
  'payWithdraw.updateSuccess': '更新成功',
  'payWithdraw.formValidationFailed': '表单验证失败',
  'payWithdraw.vipRange': 'VIP等级',
  'payWithdraw.addRange': '添加区间',
  'payWithdraw.deleteRange': '删除',
  'payWithdraw.vipRangeTips': '按VIP等级区间配置各支付方式可绑定账号数量（起始和截止均为包含）',
  'payWithdraw.vipRangeOverlap': 'VIP等级区间不能重叠',
  'payWithdraw.vipRangeInvalid': 'VIP区间起始等级不能大于结束等级',
  'payWithdraw.vipRangeContinuous': '新增区间必须紧接上一区间，不能跳过等级',
  'payWithdraw.vipRangeMaxReached': '已覆盖到VIP31，无法继续新增区间',

  // 提款验证配置项国际化
  'payWithdraw.withdraw_verification_mobile': '提款是否需要认证手机号码',
  'payWithdraw.withdraw_verification_real_name': '提款是否需要认证真实姓名',
  'payWithdraw.withdraw_verification_card_valid': '提款是否需要银行卡有效期',
  'payWithdraw.withdraw_verification_email': '提款是否需要认证邮箱',
  'payWithdraw.withdraw_verification_withdraw_pwd': '提款是否需要认证提款密码',
  'payWithdraw.withdraw_verification_login_pwd': '绑定提款账号验证登录密码',
  'payWithdraw.withdraw_maya_auth': 'Maya提款授权',

  // 账户绑定配置项国际化
  'payWithdraw.bind_USDT': 'USDT',
  'payWithdraw.bind_SPEI': 'SPEI',
  'payWithdraw.bind_bank': 'BankCard',
  'payWithdraw.bind_cashapp': 'CashApp',
  'payWithdraw.bind_chime': 'Chime',
  'payWithdraw.bind_zelle': 'Zelle',
  'payWithdraw.bind_paypal': 'PayPal',
  'payWithdraw.bind_ach': 'ACH',
  'payWithdraw.bind_Grabpay': 'Grabpay',
  'payWithdraw.bind_Gcash': 'Gcash',
  'payWithdraw.bind_Paymaya': 'Paymaya',

  // Notice component internationalization
  'notice.soundSettings': '音效設置',
  'notice.withdrawSoundPrompt': '提现声音提示',
  'notice.kycSoundPrompt': 'KYC声音提示',
  'notice.close': '关闭',


  // 會員詳情模態框
  'memberDetail.modal.title': '會員詳情 - {memberAccount}',

  // 商品類別
  'product.category.cash': '现金',
  'product.category.props': '道具',
  'product.category.product': '实物',
  'product.category.unknown': '未知类型',

  // ==================== 存款榜/取款榜/优惠榜 ====================
  // 菜单
  'menu.userRanking': '用户排名',
  'menu.depositLeaderboard': '存款榜',
  'menu.withdrawLeaderboard': '取款榜',
  'menu.promoLeaderboard': '优惠榜',

  // 存款榜页面
  'leaderboard.depositTitle': '存款榜',
  'leaderboard.withdrawTitle': '取款榜',
  'leaderboard.promoTitle': '优惠榜',

  // 表格列
  'leaderboard.rank': '排名',
  'leaderboard.userAccount': '会员账号',
  'leaderboard.nickname': '会员昵称',
  'leaderboard.realName': '会员姓名',
  'leaderboard.mobile': '手机号',
  'leaderboard.vipLevel': 'VIP等级',
  'leaderboard.currency': '货币',

  // 存款榜字段
  'leaderboard.depositAmount': '存款总额',
  'leaderboard.depositCount': '存款笔数',
  'leaderboard.avgDeposit': '平均单笔存款',
  'leaderboard.maxDeposit': '最大单笔存款',
  'leaderboard.lastDepositTime': '最近存款时间',

  // 取款榜字段
  'leaderboard.withdrawAmount': '取款总额',
  'leaderboard.withdrawCount': '取款笔数',
  'leaderboard.avgWithdraw': '平均单笔取款',
  'leaderboard.maxWithdraw': '最大单笔取款',
  'leaderboard.lastWithdrawTime': '最近取款时间',

  // 优惠榜字段
  'leaderboard.promoClaimCount': '优惠领取次数',
  'leaderboard.promoAmount': '派发金额',
  'leaderboard.promoPoints': '派发积分',
  'leaderboard.lastPromoTime': '最近派发时间',
  'leaderboard.clickToSort': '点击按此字段排序',

  // 时间周期
  'leaderboard.periodLabel': '排名时间',
  'leaderboard.today': '今日',
  'leaderboard.todayRealtime': '今日实时',
  'leaderboard.yesterday': '昨日',
  'leaderboard.lastWeek': '上一周',
  'leaderboard.lastMonth': '上一个月',
  'leaderboard.hourly': '当日实时',
  'leaderboard.periodDaily': '昨日排行榜',
  'leaderboard.periodWeekly': '上周排行榜',
  'leaderboard.periodMonthly': '上月排行榜',
  'leaderboard.periodHourly': '当日实时排行榜',

  // 统计字段
  'leaderboard.sortField': '统计字段',
  'leaderboard.selectSortField': '请选择统计字段',

  // 占位符
  'leaderboard.userAccountPlaceholder': '请输入会员账号',
  'leaderboard.nicknamePlaceholder': '请输入会员昵称',
  'leaderboard.realNamePlaceholder': '请输入会员姓名',
  'leaderboard.mobilePlaceholder': '请输入手机号',

  // ==================== 赢钱榜/输钱榜/投注榜 ====================
  // 表单字段
  'leaderboard.periodType': '时间周期',
  'leaderboard.periodTypeRequired': '请选择时间周期',
  'leaderboard.selectPeriodType': '请选择时间周期',
  'leaderboard.currencyRequired': '请选择币种',
  'leaderboard.selectCurrency': '请选择币种',
  'leaderboard.enterUserAccount': '请输入会员账号',
  'leaderboard.selectVipLevel': '请选择VIP等级',

  // 赢钱榜/输钱榜/投注榜字段
  'leaderboard.netProfit': '净盈利',
  'leaderboard.netLoss': '净亏损',
  'leaderboard.validBet': '有效投注',
  'leaderboard.profitRate': '盈利率',
  'leaderboard.lossRate': '亏损率',
  'leaderboard.betCount': '投注笔数',
  'leaderboard.lastBetTime': '最近投注时间',

  // 排行榜导出和提示
  'leaderboard.naturalTimeCycleHint': '榜单按自然时间周期统计（非滚动时间）',
  'leaderboard.exportSubmitSuccess': '导出任务已提交，请稍后到"文件下载"查看',
  'leaderboard.exportFailed': '导出失败，请稍后重试',

  // 小时榜相关
  'leaderboard.statsDate': '统计日期',
  'leaderboard.statsHour': '截至小时',
  'leaderboard.selectStatsDate': '请选择统计日期',
  'leaderboard.selectStatsHour': '请选择截至小时',
  'leaderboard.statsDateRequired': '请选择统计日期',
  'leaderboard.statsHourRequired': '请选择截至小时',
  'leaderboard.hourlyHint': '显示当日 00:00 至所选小时的累计排行数据',
  'leaderboard.hourlyDataUpdatedAt': '数据更新至 {hour} 点',

  // 游戏排行榜
  'gameRanking.title': '游戏排行榜',
  'gameRanking.gameName': '游戏名称',
  'gameRanking.gameNamePlaceholder': '请输入游戏名称',
  'gameRanking.gameId': '游戏ID',
  'gameRanking.gameIdPlaceholder': '请输入游戏ID',
  'gameRanking.gameVendor': '游戏厂商',
  'gameRanking.gameVendorPlaceholder': '请输入游戏厂商',
  'gameRanking.gameShowName': '显示名称',
  'gameRanking.rank': '排名',
  'gameRanking.betUserCount': '投注人数',
  'gameRanking.betCount': '投注笔数',
  'gameRanking.betAmount': '投注金额',
  'gameRanking.winUserCount': '赢钱次数',
  'gameRanking.playerWinAmount': '玩家中奖金额',
  'gameRanking.playerLossAmount': '玩家输钱金额',
  'gameRanking.platformNetAmount': '平台净输赢',
  'gameRanking.avgBetAmount': '人均投注金额',
  'gameRanking.avgBetCount': '人均投注笔数',
  'gameRanking.avgPlatformNet': '人均平台净输赢',
  'gameRanking.dataHint': '数据统计范围：今日实时(每小时累计更新)/昨日/上周一至上周日/上月1日至上月最后一天（自然时间周期）',
}
